<div class="p-0 panel-firststep--wrapper">
  <div class="p-0 panel_start pay_now" *ngIf="opened_step == 0">

    <div class="no_scroll mx-0 pay_now_request">
      <div class="back-portion panel-outer--mainwrapper two-plan ps-0 pe-0 file_highlight"
        [ngClass]="patientData ? '-patientskils' :''">
        <!-- <app-new-plans></app-new-plans> -->
        <div class="col py-md-4 bg-white sidebar_plan_details" [ngClass]="{'borderBottom': stepHeader}"
          *ngIf="!scanner_continue && !manual_continue">
          <div>
            <app-steps (triggerChangeScreen)="changeScreen()" class="mt-3"></app-steps>
          </div>
        </div>

        <div class="mx-auto panel_plans progress-main--wrapper__right" *ngIf="patientData">
          <div class="col-12 d-none block_hello_user_2" *ngIf="patientData && patientData.patient_first_name">
            <div class="w-100 d-flex align-items-center justify-content-between px-1 mt-2">
              <span class="color-gray">{{patientData && patientData.plans_array && patientData.plans_array.length}}
                Plan{{patientData
                &&
                patientData.plans_array && patientData.plans_array.length > 1 && '(s)'}} available
              </span>

              <span class="toggle_block">

                <span class="px-1" [ngClass]="[!show_all_plans ? '' : 'd-none']" role="button"><img
                    src="assets/svg/element-equal-inActive.svg" alt="" srcset=""></span>
                <span class="px-1" (click)="show_all_plans = false;" [ngClass]="[show_all_plans ? '' : 'd-none']"
                  tooltip="collapse" role="button"><img src="assets/svg/element-equal.svg" alt="" srcset=""></span>
                <span class="px-1" (click)="show_all_plans = true;" [ngClass]="[!show_all_plans ? '' : 'd-none']"
                  tooltip="expand" role="button"><img src="assets/svg/row-vertical-active.svg" alt="" srcset=""></span>
                <span class="px-1 ms-1" [ngClass]="[show_all_plans ? '' : 'd-none']" role="button"><img
                    src="assets/svg/row-vertical.svg" alt="" srcset=""></span>
              </span>
            </div>
          </div>

          <div class="col-12 container_plan_cards no_scroll pt-2">
            <div class="col-12 block_hello_user_1 d-md-block" *ngIf="planInfo && planInfo.patient_first_name">
              <span class="howard1 ">Hello <b>{{(planInfo.patient_first_name || '') + ' '
                  +(planInfo.patient_last_name || '') | titlecase }}</b>,
              </span>
              <span class="review"> please review the proposed payment plan(s) from&nbsp;{{planInfo.practice_name ||
                (planInfo.doctor_first_name +
                '' + planInfo.doctor_last_name)}}: </span>

            </div>
            <div class="plan-scroll-container px-md-0 px-lg-0 p-md-0">
              <ng-container *ngFor="let plan of patientData.plans_array; let i = index;">
                <div (click)="selected_plan_index  = i" class="form-check content_mid change_hover mb-2"
                  [ngClass]="[ ((selected_plan_index == i && show_all_plans) || selected_plan_index == i) ? 'selected1' : show_all_plans ? 'display_full_content' : '']"
                  [ngStyle]="patientData && patientData.plans_array.length == 1?{'margin-bottom': '35px'}:''">

                  <div class="payment_data align-items-md-center align-items-start">
                    <span class="d-none pe-2 radio_content">
                      <input type="radio" name="" id="" [checked]="selected_plan_index == i">
                    </span>
                    <div class="plan_values w-100 d-sm-flex align-items-center justify-content-between py-2 flex-wrap">
                      <div class="plan_values-month">
                        <input type="radio" [id]="i" name="fav_language" value="select" class="input-radio"
                          [checked]="selected_plan_index == i">
                        <!-- <button class="b-b-p-1 border-0 button-login d-md-block d-sm-block d-none fw-700 fs-10"
                            style="padding:10px; border-radius: 76px; font-size: 10px;"
                            [ngClass]="[selected_plan_index == i ? 'plan_selected':'']">
                            <img src="assets/svg/check_button.svg" alt="" *ngIf="selected_plan_index == i"
                              style="margin-bottom: 2px;">
                            {{selected_plan_index == i ? 'Selected' : 'Select'}}
                          </button> -->

                        <span
                          class="d-sm-flex align-items-center flex-grow-1 py-md-2 mb-sm-0 mb-md-0 justify-content-between fs-20 ps-3 ">
                          <h5 class="mb-0 fw-900 color-blue-black fs-20 monthly-fixed" style="min-width: 110px;">
                            {{plan.month}} Months
                          </h5>
                          <hr class="border_added monthly-fixed">
                          <span
                            class="ps-2 pe-2 ps-md-4 pe-md-3 h5 mb-sm-0 mb-1 mt-sm-0 mt-4 fs-28 monthly-fixed monthly-rate color-black"
                            style="min-width: 185px;">
                            <span class="notranslate"> {{mainService.currency_data.display_logo}}
                              {{plan.recurring_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span> <span
                              class="ms-sm-2 ms-0 fs-16 text--grey">monthly</span>
                          </span>
                        </span>
                      </div>
                      <!-- </div> -->
                      <!-- <div class="plan_total_payable"> -->
                      <div
                        class="d-flex align-items-center flex-grow-1 py-md-2 justify-content-end ps-md-3 total_payable_today">
                        <span class=" mb-0 fs-16 monthly-fixed" style="color: #646C70;">Total Payable Today:
                          <span>
                            <span role="link" style="text-decoration: none; color: #20A9D3;">
                              &nbsp;&nbsp;
                              <span translate="no">{{mainService.currency_data.display_logo}} {{
                                plan.to_pay_today|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                            </span>
                          </span>

                          <img src="assets/svg/info_blue.svg" alt="" data-container="body"
                            tooltip="{{'This includes the Down Payment, ' + (plan.advance_interest_amount ? (patientData.contract_type == 1 || patientData.contract_type == 3 ? 'First Recurring Payment, ': (patientData.is_ar_contract == 1 ? 'Upfront Payment, ' :'Upfront Fee, ')) : '') + ' Enrollment Fee and Transaction Fee'}}"
                            style="height: 15px;width: 15px;margin-bottom: 2px;">
                        </span>

                      </div>
                    </div>
                  </div>
                  <!-- <hr> -->
                  <div class="interest" *ngIf="plan">
                    <div class="flex-grow-1 text-center float-interest py-3 px-2">
                      <div class="similar">Interest Rate: <span class="plan_card_value fs-14">
                          <span class="fs-16 fw-600 text--black"><span translate="no">{{plan &&
                              plan.interest_rate_to_show||
                              plan.interest_rate}}%</span>
                            <sup>{{plan.interest_rate_type}}</sup>
                          </span></span></div>
                    </div>
                    <div class="flex-grow-1 text-center transitfee py-3 px-2">
                      <div class="title-card">Transaction Fee:</div>
                      <span *ngIf="mainService.getTransactionFee(patientData,plan.recurring_amount)"
                        class="title-value font-15 text-colr"> <span *ngIf="mainService.promotionalTransactionOffer"
                          class="strike_through_class fs-16 fw-600"
                          [innerText]="mainService.getTransactionFeeStrike(patientData,plan.recurring_amount,1)"
                          style="margin-right: 8px;"></span>
                        <div [ngClass]="mainService.promotionalTransactionOffer ? 'transaction-fee' : ''"
                          class=" d-inline-block">
                          <!-- <span *ngIf="mainService.promotionaloffer">
                                  ${{mainService.promotionalofferValue}}
                                </span> -->
                          <span class="text--black fw-600 fs-15">
                            <span
                              translate="no">{{(mainService.getCalculatedTransactionFee(patientData,plan.recurring_amount,1)
                              ==
                              mainService.currency_data.display_logo + '0' ||
                              mainService.getTransactionFee(patientData,plan.recurring_amount,1) == '0%') ?
                              mainService.getTransactionFee(patientData,plan.recurring_amount,1) :
                              mainService.getTransactionFee(patientData,plan.recurring_amount,1) + '/ payment'}}</span>
                          </span>
                          <div *ngIf="mainService.promotionalTransactionOffer" class="transaction-fee-popup pop-up-top">
                            Promo
                          </div>
                        </div>
                      </span>
                    </div>
                    <!-- <div *ngIf="plan.advance_interest_amount" class="flex-grow-1 text-center py-3 px-2 color-dblue">
                          <div class="similar">{{patientData.contract_type == 1 || patientData.contract_type == 3 ? 'First Recurring Due
                                Today' : patientData && patientData.is_ar_contract == 1 ? 'Upfront Payment' :'Upfront Fee' }}: <span class="plan_card_value fs-14"> {{plan &&
                              plan.advance_interest_amount | currency
                              :'$'}}</span></div>
                        </div> -->
                    <div
                      class="flex-grow-1 text-center py-3 px-2 color-dblue upfrontfee d-flex align-items-center justify-content-center flex-wrap"
                      *ngIf="plan && plan.advance_interest_amount">
                      <span *ngIf="patientData.contract_type == 1 || patientData.contract_type == 3">First Recurring Due
                        Today</span>
                      <!--  || patientData.contract_type == 5 -->
                      <span *ngIf="patientData.contract_type == 2 || patientData.contract_type == 4" class="similar">
                        {{patientData && patientData.is_ar_contract == 1 ? 'Upfront Payment' :'Upfront Fee'}}
                      </span>
                      <div class="">
                        <span class="plan_card_value fs-16 text--black"> :
                          <span translate="no">{{mainService.currency_data.display_logo}}
                            {{plan.advance_interest_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span></span>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>


            <div class="durationdata">
              <div class="durationdata-box d-block">
                <div class="row justify-content-between align-items-center">
                  <div class="mb-sm-3 mb-2" [ngClass]="planInfo && planInfo.contract_type == 6?'col-md-3': 'col-md-4'">
                    <div
                      class="termcondition d-sm-flex d-block align-items-center transition invoice-pay-innr m-0 mw-100">
                      <div class="img-calender me-sm-3 text-center count_month">
                        <p class="months"><span translate="no">{{planInfo && planInfo.plans_array &&
                            planInfo.plans_array[0]
                            ? planInfo.plans_array[0].month: '3'}}</span></p>
                        <img src="assets\png\calendar.png" alt="calendar">
                      </div>
                      <div
                        class="mt-sm-0 mt-3 d-sm-inline-block d-flex justify-content-center align-items-center term_month plan_amount_visible">
                        <p class="text-heads mb-sm-1 mb-0 mt-0 text-sm-start text-center me-sm-0 me-1">Payment Plan
                          Amount
                        </p>
                        <div class="month mb-0 text-sm-start text-center ms-sm-0 ms-1"><span
                            translate="no">{{mainService.currency_data.display_logo}} {{planInfo &&
                            planInfo.financed_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                        </div>

                      </div>
                      <div
                        class="mt-sm-0 mt-3 d-sm-inline-block d-flex justify-content-center align-items-center term_month count_month">
                        <p class="text-heads mb-sm-1 mb-0 mt-0 text-sm-start text-center me-sm-0 me-1">Term:
                        </p>
                        <p class="month mb-0 text-sm-start text-center ms-sm-0 ms-1"><span translate="no"> {{planInfo &&
                            planInfo.plans_array
                            && planInfo.plans_array[0]
                            ? planInfo.plans_array[0].month: '3'}}</span> Months
                        </p>

                      </div>
                    </div>

                  </div>
                  <div class="invoice-border-left mb-3 total_pay_hide"
                    [ngClass]="planInfo && planInfo.contract_type == 6?'col-sm-3': 'paynow-simpleViewcard col-sm-4'">
                    <div class="termcondition transition invoice-pay-innr pay_total align-items-center">
                      <p class="text-heads mb-sm-1 mb-0">Total Payable Today </p>
                      <span>
                        <h5 class="pay-text mb-0">
                          <span translate="no">{{mainService.currency_data.display_logo}} {{planInfo &&
                            planInfo.plans_array &&
                            planInfo.plans_array[0] ? (planInfo.plans_array[0].total_payable_amount
                            |DynamicDecimalPipe:mainService.currency_data.currency_code)
                            :'0.00'}}</span>
                        </h5>
                      </span>
                    </div>
                  </div>

                  <div class="invoice-border-left mb-3 d-none d-md-block"
                    *ngIf="planInfo && planInfo.contract_type != 6"
                    [ngClass]="planInfo && planInfo.contract_type !== 6 ? 'recurr-no-deff col-sm-4': 'col-sm-3' ">
                    <div
                      class="termcondition transition invoice-pay-innr d-sm-block d-flex align-items-center justify-content-center">
                      <p class="text-heads mb-sm-1 mb-0 me-1">Recurring:</p>
                      <h5 class="fw-800 pay-text fs-20 mb-0">
                        <span class="text-labels-def fs-20 fw-700 text--black">
                          <span class="notranslate"> {{mainService.currency_data.display_logo}} {{planInfo &&
                            planInfo.selected_plan &&
                            planInfo.selected_plan.recurring_amount
                            ?((planInfo.selected_plan.recurring_amount +
                            mainService.getCalculatedTransactionFee(planInfo,
                            planInfo.selected_plan.recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code) ): '0.00'}}</span>
                          <span class="fw-400 fs-16"> / month</span>
                        </span>
                      </h5>
                    </div>
                  </div>


                  <div class="mb-3 invoice-border-left d-none d-md-block"
                    *ngIf="planInfo && planInfo.contract_type == 6"
                    [ngClass]="planInfo && planInfo.contract_type == 6?'col-sm-3': 'col-sm-4'">
                    <div *ngIf="planInfo && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount"
                      class="invoice-pay-innr d-sm-block d-flex align-items-center justify-content-center">
                      <p class="text-heads mb-0"> {{(planInfo.contract_type == 1 || planInfo.contract_type == 3)?
                        'First
                        Recurring Due
                        Today' :
                        'Upfront Fee:'}}
                      </p>
                      <p class="fw-800 fs-20 ms-1 w-100 mb-0 pay-text"> <span
                          translate="no">{{mainService.currency_data.display_logo}}
                          {{planInfo &&
                          planInfo.selected_plan &&
                          planInfo.selected_plan.advance_interest_amount ?
                          (planInfo.selected_plan.advance_interest_amount|DynamicDecimalPipe:mainService.currency_data.currency_code): '0.00'}}</span>
                      </p>
                    </div>
                  </div>

                  <div class="mb-3 invoice-border-left d-none d-md-block"
                    *ngIf="planInfo && planInfo.contract_type == 6"
                    [ngClass]="planInfo && planInfo.contract_type == 6?'col-sm-3': 'col-sm-4'">
                    <div
                      class="invoice-pay-innr interest invoice-ineterst-fee d-sm-block d-flex align-items-center justify-content-center">
                      <div class="d-sm-block d-flex align-items-center">
                        <p class="text-heads mb-0 me-sm-0 me-2">Transaction Fee:</p>
                        <span *ngIf="planInfo && planInfo.selected_plan"
                          class="d-block title-value font-15 text-colr position-relative">
                          <span *ngIf="mainService.promotionalTransactionOffer"
                            class="strike_through_class fs-20 fw-700 position-relative me-2"
                            [innerText]="mainService.getTransactionFeeStrike(planInfo,planInfo && planInfo.selected_plan && planInfo.selected_plan.recurring_amount,1)"
                            translate="no"></span>
                          <div [ngClass]="mainService.promotionalTransactionOffer ? 'transaction-fee fs-20 fw-700' : ''"
                            class="d-inline-flex">
                            <span class="notranslate value-fee">

                              <span
                                *ngIf="!mainService.getTransactionFee(planInfo,planInfo.selected_plan.recurring_amount, 0).includes(mainService.currency_data.display_logo)">{{mainService.currency_data.display_logo}}
                              </span>{{planInfo && planInfo.selected_plan &&
                              planInfo.selected_plan.recurring_amount ?
                              ((mainService.getTransactionFee(planInfo,planInfo.selected_plan.recurring_amount, 0))):
                              '0.00'}}
                            </span>
                            <div [ngClass]="mainService.promotionalTransactionOffer ? '' : ''"
                              *ngIf="mainService.promotionalTransactionOffer"
                              class="text-white fs-12 position-relative transaction-fee-popup pop-up-right fw-800">
                              Promo
                            </div>
                          </div>
                        </span>
                      </div>
                      <!-- <div class="">
                  <div [ngClass]="mainService.promotionalTransactionOffer ? 'transaction-fee' : ''"
                    class="d-inline-block">
                    <span class="text-labels ms-1">
                      {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                      planInfo.selected_plan.recurring_amount ?
                      (mainService.getCalculatedTransactionFee(planInfo,planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</span>
                  </div>
  
                  <div *ngIf="mainService.promotionalTransactionOffer" class="transaction-fee-popup pop-up-right">Promo</div>
                </div> -->
                    </div>
                  </div>
                </div>
                <!--Deffered Mobile View PRicing Start -->

                <div class="recure-form d-md-none" *ngIf="planInfo && planInfo.contract_type != 6">
                  <div class="mt-2 mb-2 recurring_new">
                    <div class="position-relative d-inline-block recure-form-innr">
                      <div class="start_amount color_change">
                        <span class="rec_amount">Recurring Amount:</span>
                        <div class="first_amount">
                          <span class="recuring-price text-black block_classes fw-900 m-0"
                            *ngIf="planInfo && planInfo.contract_type == 6" translate="no">
                            {{mainService.currency_data.display_logo}}{{(planInfo.recurring_amount ||
                            planInfo.selected_plan.recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}}
                          </span>
                          <span class="recuring-price text-black block_classes fw-900 m-0"
                            *ngIf="planInfo && planInfo.contract_type != 6" translate="no">
                            {{mainService.currency_data.display_logo}} {{((planInfo.recurring_amount ||
                            planInfo.selected_plan.recurring_amount) +
                            mainService.getCalculatedTransactionFee(planInfo,(planInfo.recurring_amount ||
                            planInfo.selected_plan.recurring_amount)) |
                            DynamicDecimalPipe:mainService.currency_data.currency_code)}}
                          </span>
                        </div>

                        <div class="second_amount">
                          <span class="fs-24 fw-800 color_change p-0 m-0"
                            *ngIf="planInfo && planInfo.contract_type != 6">recurring for
                            the
                            next</span>
                          <span class="color_change text-black ms-1 fs-23 fw-800 p-0 me-0 " *ngIf="planInfo">
                            <span class="fs-23 fw-800 color-blue-black me-0 month_count"
                              *ngIf="planInfo && planInfo.selected_plan && !((planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan.advance_interest_amount) && planInfo.contract_type != 6">
                              {{planInfo && planInfo.selected_plan &&
                              planInfo.selected_plan.month?(planInfo.selected_plan.month): '0'}}
                            </span>
                            <span class="fs-23 fw-800 color-blue-black month_count"
                              *ngIf="planInfo && (planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount && planInfo.contract_type != 6">
                              {{planInfo && planInfo.selected_plan &&
                              planInfo.selected_plan.month?(planInfo.selected_plan.month
                              - 1): '0'}}
                            </span>
                            <span [class.deffred]="planInfo.contract_type == 6"
                              class="mnth check">{{planInfo.contract_type !=6
                              ?
                              'months' : ' (During Deferred)'}}
                            </span>
                          </span>
                        </div>
                      </div>
                      <!-- <span>
                                      <button class="info_icon_btn px-0">
                                        <span class="info_icon ms-2">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" viewBox="0 0 20 20"
                                            fill="none">
                                            <path
                                              d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                                              stroke="#141616" stroke-width="1.5" stroke-linecap="round"
                                              stroke-linejoin="round" />
                                            <path d="M9.375 9.375H10V13.75H10.625" stroke="#141616" stroke-width="1.5"
                                              stroke-linecap="round" stroke-linejoin="round" />
                                            <path
                                              d="M10 7.5C10.5178 7.5 10.9375 7.08027 10.9375 6.5625C10.9375 6.04473 10.5178 5.625 10 5.625C9.48223 5.625 9.0625 6.04473 9.0625 6.5625C9.0625 7.08027 9.48223 7.5 10 7.5Z"
                                              fill="#141616" />
                                          </svg>
                                        </span>
                                        <span class="tooltip_box d-none color-gray-1 custom_tool_recurring tooltip_box__modify"
                                          *ngIf="planInfo">
                                          <div class="d-flex py-2 fs-14 align-items-center justify-content-between">
                                            <div class="d-flex flex-column text-start">
                                              <span class="color-gray fw-400">Recurring Amount</span>
                                              <span class="color-gray fw-400"
                                                *ngIf="planInfo && planInfo.contract_type ==6">(During
                                                Deferred)</span>
                                            </div>
                                            <div class="ps-2 text-end">
                                              <span class="color-dblue fw-800 text-end text-nowrap"
                                                style="max-width: calc(42%) !important;"><span
                                                  translate="no">{{mainService.currency_data.display_logo}}
                                                  {{(planInfo.recurring_amount ||
                                                  planInfo.selected_plan.recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span></span>
                                            </div>
                                          </div>
                                          <div class="d-flex py-2 fs-14 align-items-center justify-content-between"
                                            *ngIf="planInfo && planInfo.contract_type == 6 && ((planInfo.threshold_amount <= (planInfo.recurring_amount || planInfo.selected_plan.recurring_amount)) || (planInfo.threshold_amount <= (planInfo.recurring_amount || planInfo.selected_plan.next_recurring_amount)))"
                                            style="border-top: none !important">
                                            <span class="color-gray fw-400">Transaction Fee</span>
                                            <span class="color-dblue fw-800 ps-2" style="max-width: calc(42%) !important;">
                                              <span translate="no"> {{mainService.currency_data.display_logo}}
                                                {{(mainService.getCalculatedTransactionFee(planInfo,(planInfo.recurring_amount
                                                ||
                                                planInfo.selected_plan.recurring_amount),1))|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                                            </span>
                                          </div>
                                          <div class="d-flex py-2 fs-14 align-items-center justify-content-between"
                                            *ngIf="planInfo && planInfo.contract_type != 6 && (planInfo.threshold_amount > (planInfo.recurring_amount || planInfo.selected_plan.recurring_amount)) || (planInfo.threshold_amount > (planInfo.next_recurring_amount || planInfo.selected_plan.next_recurring_amount))">
                                            <span class="color-gray fw-400">Transaction Fee</span>
                                            <span class="color-dblue fw-800 ps-2" style="max-width: calc(42%) !important;">
                                              <span
                                                translate="no">{{mainService.currency_data.display_logo}}
                                                {{mainService.getCalculatedTransactionFee(planInfo,(planInfo.recurring_amount
                                                ||
                                                planInfo.selected_plan.recurring_amount),1) |DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                                            </span>
                                          </div>
                                          <div class="d-flex py-1 fs-14 align-items-center justify-content-between"
                                            *ngIf="planInfo && planInfo.contract_type ==6 && planInfo.selected_plan.month > planInfo.di_start_month">
                                            <div class="d-flex flex-column text-start">
                                              <span class="color-gray fw-400">Recurring Amount</span>
                                              <span class="color-gray fw-400">(After Deferred)</span>
                                            </div>
                                            <div class="ps-2 text-end">
                                              <span class="color-dblue fw-800" style="max-width: calc(42%) !important;">
                                                <span translate="no">{{mainService.currency_data.display_logo}}
                                                  {{(planInfo.next_recurring_amount ||
                                                  planInfo.selected_plan.next_recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span></span>
                                            </div>
                                          </div>
                                          <div class="d-flex py-2 fs-14 align-items-center justify-content-between"
                                            *ngIf="planInfo && planInfo.contract_type == 6 && planInfo.selected_plan.month > planInfo.di_start_month"
                                            [ngClass]="mainService.promotionalTransactionOffer ? 'transaction-fee' : ''">
                                            <span class="color-gray fw-400">Transaction Fee</span>
                                            <span class="color-dblue fw-800">
                                              <span translate="no">{{mainService.currency_data.display_logo}} {{planInfo &&
                                                (planInfo.selected_plan.next_recurring_amount || planInfo.next_recurring_amount)
                                                ?
                                                (mainService.getCalculatedTransactionFee(planInfo,planInfo.next_recurring_amount
                                                ||
                                                planInfo.selected_plan.next_recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code):
                                                '0.00'}}</span>
                                            </span>
                                          </div>
                
                
                
                                          <div class="d-flex py-2 fs-14 align-items-center justify-content-between"
                                            *ngIf="planInfo.is_ar_contract">
                                            <span class="color-gray fw-600">Account Setup Fee</span>
                                            <span class="color-dblue fw-800" style="max-width: calc(42%) !important;">
                                              <span translate="no"> {{mainService.currency_data.display_logo}} {{planInfo &&
                                                planInfo.plans_array &&
                                                (planInfo.plans_array[0].enrollment_fee ||
                                                planInfo.plans_array[0].enrollment_fee == 0 )?
                                                planInfo.plans_array[0].enrollment_fee : '30'}}</span>
                                            </span>
                                          </div>
                                          <div class="d-flex py-2 fs-14 align-items-center justify-content-between"
                                            *ngIf="planInfo && planInfo.contract_type != 6">
                                            <span class="color-gray fw-600">Total Recurring Amount </span>
                                            <span class="color-dblue fw-800" style="max-width: calc(42%) !important;"><span
                                                translate="no">{{mainService.currency_data.display_logo}}
                                                {{calculateTotalPayableAmount((planInfo.recurring_amount ||
                                                planInfo.selected_plan.recurring_amount),
                                                mainService.getCalculatedTransactionFee(planInfo,(planInfo.recurring_amount ||
                                                planInfo.selected_plan.recurring_amount))) + (planInfo.is_ar_contract
                                                ? 30 :0)| DynamicDecimalPipe:mainService.currency_data.currency_code}}</span></span>
                                          </div>
                                        </span>
                                      </button>
                                    </span> -->
                    </div>
                  </div>
                </div>
                <!-- Deffered Mobile view Pricing End -->
                <div class="row mt-4">
                  <div class="col-md-6 col-12 mb-3" *ngIf="planInfo && planInfo.contract_type == 6">
                    <div class="interest d-block invoice-box h-100 position-relative">
                      <div class="d-flex justify-content-between">
                        <div class="pe-2">
                          <p class="text-heads-def mb-0 fs-20 w-100 fw-700 mb-sm-2 mb-1">{{
                            planInfo.plans_array[0].month >
                            planInfo.deferred_duration ?
                            "First" : ""}}
                            {{planInfo.plans_array[0].month > planInfo.deferred_duration ? planInfo.deferred_duration :
                            planInfo.plans_array[0].month
                            }} Months</p>
                          <span class="text-white fs-14 fw-700 no-interest d-inline-block pay-interest-text">No
                            Interest</span>
                        </div>
                        <div class="pe-md-4 pt-sm-1">
                          <p class="mb-0 color-black fs-16 fw-400 mb-1">
                            Recurring
                          </p>
                          <span class="text-labels-def fs-18 fw-700 text--black"
                            *ngIf="planInfo && planInfo.selected_plan && mainService.getTransactionFee(planInfo, planInfo.selected_plan.recurring_amount)">
                            <span class="notranslate">{{mainService.currency_data.display_logo}} {{planInfo &&
                              planInfo.selected_plan &&
                              planInfo.selected_plan.recurring_amount
                              ?(planInfo.selected_plan.recurring_amount|DynamicDecimalPipe:mainService.currency_data.currency_code): '0.00'}}</span>
                            <span>/month</span>
                          </span>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div class="col-md-6 col-12 mb-3"
                    *ngIf="planInfo && planInfo.selected_plan && planInfo.contract_type == 6 && (planInfo.selected_plan.month > planInfo.deferred_duration)">
                    <div class="d-flex justify-content-between invoice-box h-100 position-relative">
                      <div class="pe-2">
                        <p class="text-heads-def mb-0 fs-20 w-100 fw-700 mb-sm-2 mb-1"> Remaining Months</p>
                        <p class="mb-0 fs-14 fw-400 d-flex pay-interest-text">Interest:
                          <span class="fw-700 fs-14 w-sm-auto w-100 d-sm-inline d-block"><span
                              translate="no">{{planInfo.selected_plan.interest_rate_to_show}}%</span>
                            <span class="notranslate">{{planInfo.selected_plan.interest_rate_type}}</span>
                          </span>
                        </p>
                      </div>
                      <div class="pe-md-2">
                        <p class="mb-0 color-black fs-16 fw-400 mb-1">
                          Recurring
                        </p>
                        <span class="text-labels-def fs-18 fw-700 text--black"
                          *ngIf="planInfo && planInfo.selected_plan && mainService.getTransactionFee(planInfo, planInfo.selected_plan.next_recurring_amount)">
                          <span class="notranslate"> {{mainService.currency_data.display_logo}} {{planInfo &&
                            planInfo.selected_plan &&
                            planInfo.selected_plan.next_recurring_amount
                            ?(planInfo.selected_plan.next_recurring_amount|DynamicDecimalPipe:mainService.currency_data.currency_code): '0.00'}}</span>

                          <span>/month</span>
                        </span>
                      </div>

                    </div>
                  </div>

                  <div class="col-sm-6 col-12 mb-3" *ngIf="plan">
                    <div class="interest position-relative">
                      <div class="text-center py-3 px-2 float-interest">
                        <div class="similar">Interest Rate:
                          <span class="plan_card_value fs-14">
                            <span class="color-dblue">{{plan && plan.interest_rate_to_show|| plan.interest_rate}}%
                              <sup>{{plan && plan.interest_rate_type}}</sup>
                            </span>
                          </span>
                        </div>
                      </div>
                      <div class="text-center py-3 px-2 transitfee"
                        *ngIf="mainService.getTransactionFee(planInfo,plan.recurring_amount)">
                        <div class="financing-labels col-6">Transaction Fee</div>
                        <div
                          *ngIf="planInfo.selected_plan && mainService.getTransactionFee(planInfo, planInfo.selected_plan.recurring_amount)"
                          class="text-end font-weight-bold f-s-14 col-6 text-colr">
                          <span *ngIf="mainService.promotionalTransactionOffer"
                            [innerText]="mainService.strike_transaction_fee"></span>
                          <div [ngClass]="mainService.promotionalTransactionOffer ? 'transaction-fee' : ''"
                            class="d-inline-block ms-2">
                            <!-- <span *ngIf="mainService.promotionaloffer">
                                          ${{mainService.promotionalofferValue}}
                                        </span> -->
                            <span>
                              {{mainService.getTransactionFee(planInfo,planInfo.selected_plan.recurring_amount,1)}}/
                              payment
                            </span>
                          </div>
                          <div *ngIf="mainService.promotionalTransactionOffer"
                            class="transaction-fee-popup pop-up-right">
                            Promo
                          </div>
                          <!--Commented code-->
                        </div>
                      </div>

                      <div
                        class="flex-grow-1 upfrontfee text-center py-3 px-2 color-dblue d-flex align-items-center justify-content-center flex-wrap"
                        *ngIf="plan && plan.advance_interest_amount">
                        <span *ngIf="planInfo.contract_type == 1 || planInfo.contract_type == 3">First Recurring Due
                          Today</span>
                        <span *ngIf="planInfo && planInfo.contract_type == 2" class="similar">
                          {{(planInfo.contract_type == 1 || planInfo.contract_type == 3)? 'First Recurring Due Today' :
                          'Upfront Fee'}}
                        </span>:
                        <div class="">
                          <span class="plan_card_value fs-14"><span
                              translate="no">{{mainService.currency_data.display_logo}}
                              {{plan.advance_interest_amount}}</span></span>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
                <div class="invoice-box first-invoice-box mt-3 firststep--viewwrap"
                  [ngClass]="planInfo && planInfo.contract_type == 6 ? 'deffred_show' : ''">
                  <div class="row align-items-center m-0 fee_avail">
                    <div class="col-md-4 py-md-3 px-md-2 d-md-none">
                      <span
                        class="d-flex flex-wrap mb-0 fs-16 fw-400 d-inline-block align-items-center text-nowrap transaction_fee firststep--viewwrap__card">
                        <span class="fee-amo">Down Payment</span>
                        <span class="ps-2 fee-plan-amo" translate="no">
                          {{mainService.currency_data.display_logo}}{{(planInfo && planInfo.downpayment_amount|DynamicDecimalPipe:mainService.currency_data.currency_code)}}
                        </span>
                      </span>
                    </div>
                    <div class="col-md-4 py-md-3 px-md-2">
                      <span
                        class="d-flex flex-wrap mb-0 fs-16 fw-400 d-inline-block align-items-center text-nowrap transaction_fee firststep--viewwrap__card">
                        <span class="fee-amo">Transaction fee:</span>
                        <span *ngIf="planInfo && planInfo.selected_plan"
                          class="ps-2 d-flex align-items-center title-value text-color position-relative">
                          <span *ngIf="mainService.promotionalTransactionOffer"
                            class="strike_through_class fs-20 fw-700 position-relative me-2"
                            [innerText]="mainService.getTransactionFeeStrike(planInfo,planInfo && planInfo.selected_plan && planInfo.selected_plan.recurring_amount,1)"
                            translate="no"></span>
                          <div [ngClass]="mainService.promotionalTransactionOffer ? 'transaction-fee fs-20 fw-700' : ''"
                            class="d-inline-flex">
                            <span class="fee-plan">
                              <span class="notranslate"> {{mainService.currency_data.display_logo}} {{planInfo &&
                                planInfo.selected_plan &&
                                planInfo.selected_plan.recurring_amount ?
                                (mainService.getCalculatedTransactionFee(planInfo,planInfo.selected_plan.recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code):
                                '0.00'}}/payment</span>
                            </span>
                            <div [ngClass]="mainService.promotionalTransactionOffer ? '' : ''"
                              *ngIf="mainService.promotionalTransactionOffer"
                              class="text-white fs-12 position-relative transaction-fee-popup pop-up-right popup-below-right fw-800 invoice-box-promo">
                              Promo
                            </div>
                          </div>
                        </span>
                      </span>
                    </div>
                    <div class="col-md-4 py-md-3 px-md-2">
                      <div class="d-flex h-100 justify-content-center no-deff-interest firststep--viewwrap__card">
                        <span class="mb-0 d-inline-block fee-amo">Interest Rate: </span>
                        <span class="ps-2 fee-plan-amo"><span translate="no">{{planInfo &&
                            planInfo.interest_rate_to_show ?
                            (planInfo.interest_rate_to_show + '%') :
                            planInfo && planInfo.interest_rate ? (planInfo.interest_rate + '%') : '0%'}}</span>
                          <span translate="no">{{planInfo && planInfo.interest_rate_type}}
                          </span>
                        </span>

                      </div>
                    </div>
                    <div class="col-md-4 py-md-3 px-md-2">
                      <div *ngIf="planInfo && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount"
                        class="flex-wrap transaction_fee no-deff-upfront d-flex align-items-center firststep--viewwrap__card">
                        <span class="mb-0 mb-0 me-2 fee-amo"> {{(planInfo.contract_type == 1 ||
                          planInfo.contract_type == 3)?
                          'First
                          Recurring Due
                          Today' :
                          'Upfront Fee:'}}
                        </span>
                        <span class="fee-plan-amo"><span translate="no">{{mainService.currency_data.display_logo}}
                            {{planInfo &&
                            planInfo.selected_plan &&
                            planInfo.selected_plan.advance_interest_amount ?
                            (planInfo.selected_plan.advance_interest_amount): '0.00'}}</span>
                        </span>
                      </div>
                    </div>
                    <div class="col-md-4 py-md-3 px-md-2 enroll_scanner">
                      <div class="d-flex align-items-center firststep--viewwrap__card">

                        <span class="fee-amo">
                          Enrollment Fee
                        </span>
                        <div class="amo-plan1-strike">
                          <span class="wrong-data me-md-2">
                            <span *ngIf="mainService.promotionalEnrollmentOffer" class="fee-plan-amo"
                              translate="no">{{mainService.currency_data.display_logo}}
                            </span>
                            <span *ngIf="mainService.promotionalEnrollmentOffer" class="fee-plan-amo"
                              [innerText]="mainService.strike_enrollment_fee" translate="no">
                            </span>
                          </span>
                          <div [ngClass]="mainService.promotionalEnrollmentOffer ? 'transaction-fee' :'' " class="">
                            <span class="notranslate">
                              {{mainService.currency_data.display_logo}}{{enrollmentFee}}</span>
                            <div *ngIf="mainService.promotionalEnrollmentOffer" class="recurring-percent">PROMO
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 py-md-3 px-md-2 payble_scanner">
                      <div class="d-flex align-items-center firststep--viewwrap__card">
                        <p class="fee-amo m-0">Total Payable Today </p>
                        <span>
                          <h5 class="fee-plan-amo">
                            <span translate="no">{{mainService.currency_data.display_logo}} {{planInfo &&
                              planInfo.plans_array &&
                              planInfo.plans_array[0] ? (planInfo.plans_array[0].total_payable_amount
                              |DynamicDecimalPipe:mainService.currency_data.currency_code)
                              :'0.00'}}</span>
                          </h5>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>



              </div>
            </div>

          </div>
          <div class="d-none d-md-flex text-center text-md-start align-items-center row first-screen-footerbtn">
            <div class="mb-3 mb-md-0 col-md-5">
              <span class="color-gray-2 fs-12 fw-400 ">
                F: Fixed Interest, C: Compound Interest
              </span>
            </div>
            <div class="col-md-7">
              <button class="mt-3 border-hover fs-16" (click)="ChangeArrows(1)" button-primary-auth type="submit"
                id="continue1">Continue</button>
            </div>
          </div>
          <!-- <span
            *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && !mainService.contractSupport"
            class="footer-help--wrap--modify">
            <span class="m-0 f-s-16 small-mob color-gray fw-700">
              <a class="" href="https://www.credee.com/support" target="_blank"><svg xmlns="http://www.w3.org/2000/svg"
                  width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_8693_20253)">
                    <path
                      d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 16C11.7348 16 11.4804 16.1054 11.2929 16.2929C11.1054 16.4804 11 16.7348 11 17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17C13 16.7348 12.8946 16.4804 12.7071 16.2929C12.5196 16.1054 12.2652 16 12 16ZM12 6.5C11.0386 6.5 10.1166 6.88192 9.43674 7.56174C8.75692 8.24156 8.375 9.16359 8.375 10.125C8.375 10.3902 8.48036 10.6446 8.66789 10.8321C8.85543 11.0196 9.10978 11.125 9.375 11.125C9.64022 11.125 9.89457 11.0196 10.0821 10.8321C10.2696 10.6446 10.375 10.3902 10.375 10.125C10.3753 9.83004 10.4559 9.54072 10.6082 9.28809C10.7604 9.03545 10.9786 8.82902 11.2392 8.69092C11.4998 8.55282 11.7932 8.48827 12.0877 8.50419C12.3822 8.52011 12.6669 8.61589 12.9111 8.78127C13.1553 8.94666 13.35 9.1754 13.4741 9.44297C13.5982 9.71054 13.6472 10.0069 13.6157 10.3001C13.5843 10.5934 13.4736 10.8726 13.2955 11.1078C13.1175 11.3429 12.8788 11.5252 12.605 11.635C11.929 11.905 11 12.597 11 13.75V14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14C13 13.756 13.05 13.634 13.261 13.53L13.348 13.49C14.1288 13.1759 14.776 12.6 15.1787 11.8609C15.5814 11.1219 15.7145 10.2658 15.5551 9.43938C15.3958 8.61299 14.9539 7.86776 14.3052 7.33147C13.6566 6.79518 12.8416 6.50122 12 6.5Z"
                      fill="#20A9D3" />
                  </g>
                  <defs>
                    <clipPath id="clip0_8693_20253">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg> Need Help</a>
            </span>
          </span> -->
        </div>
        <!--Mobile Footer footer hide from Tab -->
        <footer class="footer text-center footer-change chnge_align">
          <div class="mb-2 mb-md-0 col-md-5 d-md-none">
            <span class="fixed_interest">
              <div class="fixed_interest_f">
                <div>
                  <span>F:</span> <span>
                    Fixed Interest
                  </span>
                </div>
                <div>
                  <span>C:</span> <span> Compound Interest</span>
                </div>

              </div>
            </span>
          </div>
          <div class="col-md-7">
            <button class="mt-0 w-md-auto w-100 border-hover fs-16" (click)="ChangeArrows(1)" button-primary-auth
              type="submit">Continue</button>
          </div>
          <!-- <div class="col-12 mt-2 mt-sm-0 Powered form-powerd--wrap">
            <span
              *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && !mainService.contractSupport"
              class="footer-help--wrap--v2">
              <span class="m-0 f-s-16 small-mob color-gray fw-700">
                <a class="" href="https://www.credee.com/support" target="_blank"><svg
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_8693_20253)">
                      <path
                        d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 16C11.7348 16 11.4804 16.1054 11.2929 16.2929C11.1054 16.4804 11 16.7348 11 17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17C13 16.7348 12.8946 16.4804 12.7071 16.2929C12.5196 16.1054 12.2652 16 12 16ZM12 6.5C11.0386 6.5 10.1166 6.88192 9.43674 7.56174C8.75692 8.24156 8.375 9.16359 8.375 10.125C8.375 10.3902 8.48036 10.6446 8.66789 10.8321C8.85543 11.0196 9.10978 11.125 9.375 11.125C9.64022 11.125 9.89457 11.0196 10.0821 10.8321C10.2696 10.6446 10.375 10.3902 10.375 10.125C10.3753 9.83004 10.4559 9.54072 10.6082 9.28809C10.7604 9.03545 10.9786 8.82902 11.2392 8.69092C11.4998 8.55282 11.7932 8.48827 12.0877 8.50419C12.3822 8.52011 12.6669 8.61589 12.9111 8.78127C13.1553 8.94666 13.35 9.1754 13.4741 9.44297C13.5982 9.71054 13.6472 10.0069 13.6157 10.3001C13.5843 10.5934 13.4736 10.8726 13.2955 11.1078C13.1175 11.3429 12.8788 11.5252 12.605 11.635C11.929 11.905 11 12.597 11 13.75V14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14C13 13.756 13.05 13.634 13.261 13.53L13.348 13.49C14.1288 13.1759 14.776 12.6 15.1787 11.8609C15.5814 11.1219 15.7145 10.2658 15.5551 9.43938C15.3958 8.61299 14.9539 7.86776 14.3052 7.33147C13.6566 6.79518 12.8416 6.50122 12 6.5Z"
                        fill="#20A9D3" />
                    </g>
                    <defs>
                      <clipPath id="clip0_8693_20253">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg> Need Help</a>
              </span>
            </span>
            <div class="w-100 small-mob mt-2 mb-3">
              <span class="fs-14 ">Powered By <span class="text-primary ms-1"><img
                    src="assets/svg/logo_colored.svg"></span></span>
            </div>
          </div>
          <div class="text-big">
            <span
              *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && mainService.contractSupport">
              <span class="m-0 f-s-16 small-mob color-gray text-capitalize">
                In case of any additional queries, please contact your service provider
                <b>{{planInfo && planInfo.practice_name ? planInfo.practice_name : planInfo.doctor_first_name+'
                  '+planInfo.doctor_last_name | titlecase}}</b>
                <span *ngIf="(planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"> at </span>
                <a class="text-bold"
                  *ngIf="planInfo && (planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"
                  href="tel:{{planInfo && planInfo.practice_mobile ?planInfo.practice_mobile:planInfo.doctor_phone}}">
                  {{(planInfo && planInfo.practice_mobile ? (planInfo.practice_mobile) :
                  (planInfo.doctor_phone) ? (planInfo.doctor_phone) :
                  (planInfo.doctor_mobile)) | phoneNumber : "N.A"}}
                </a>
              </span>

            </span>
            <span class="small-mob footer-terms--date">
              &copy; {{date | date:'yyyy'}} - Credee
            </span>
          </div> -->
        </footer>
        <!-- <div class="row justify-content-center mt-md-4">
          <app-steps class="mt-3"></app-steps>
          <ng-container *ngIf="planInfo">
  
            <div class="col-12 py-3 text-center" style="margin-top: 65px;">
              <span class="rounded-pill border px-3 py-2 color-gray eta_button">
                Estimated Payment Plan
              </span>
            </div>
  
            <div class="col-12 text-center pt-3" *ngIf="planInfo && planInfo.treatment_amount">
              <span class="h1 fw-900">
                {{planInfo && planInfo.treatment_amount ?
                (planInfo.treatment_amount - planInfo.downpayment_amount |
                currency : '$') :'$0.00'}}
              </span>
            </div>
  
            <div class="col-12  finance-rows text-center py-2">
              <div class="financing-labels font-weight-bold h5 finance-values card-body">{{((planInfo &&
                planInfo.enrollment_enabled
                !=
                1) && !planInfo.is_ar_contract) ? 'Enrollment Fee:' : planInfo && planInfo.is_ar_contract == 1 ? 'Account
                Setup Fee:' : 'Enrollment Fee'}}
              </div>
              <div class="text-end font-weight-bold f-s-14 col-6 p-0 text-colr position-relative">
                <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"
                  [innerText]="mainService.strike_enrollment_fee"></span>
                <div [ngClass]="mainService.promotionalEnrollmentOffer ? 'transaction-fee' : ''" class=" d-inline-block ms-2">
                  ${{enrollment_fee}}</div>
                <div class="transaction-fee-popup pop-up-right">Promo</div>
              </div>
            </div>
  
            <div class="col-12 position-relative">
              <div class="d-flex justify-content-between align-items-center p-4 iframe-body fs-14 mt-4 rounded-top"
                style="border-bottom: 1px solid lightgrey;">
                <p class="p-0 m-0">
                  <span class="color-gray p-0 m-0 me-1">Service amount</span>
                  <span>
                    <button class="info_icon_btn">
                      <img src="assets\png\Icons.png" alt="" class="info_icon">
                      <span class="tooltip_box color-gray-1 show_div custom_tool_recurring d-none">
                        <div class="d-flex justify-content-between border-bottom p-2 align-items-center"
                        *ngFor="let service of contract_service_record">
                        <p class="color-gray p-0 m-0 fw-400 treatment_text" [tooltip]="service.service">{{service.service}}</p>
                        <p class="color-dblue fw-700 p-0 m-0">{{service && service.price ?
                          (service.price |
                          currency : '$') :'$0.00'}}</p>
                      </div>
                      </span>
                    </button>
                  </span>
                </p>
                <p class="color-dblue fw-700 p-0 m-0">{{mainService.currency_data.display_logo}} {{planInfo && planInfo.treatment_amount ? (planInfo.treatment_amount
                  |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</p>
              </div>
              
              <div class="d-flex justify-content-between align-items-center p-4 iframe-body fs-14 rounded-bottom"
                *ngIf="planInfo && planInfo.downpayment_amount > 0">
                <p class="color-gray p-0 m-0">Down payment</p>
                <p class="color-dblue fw-700 p-0 m-0">
                  {{mainService.currency_data.display_logo}} {{planInfo && planInfo.downpayment_amount ? (planInfo.downpayment_amount |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
                </p>
              </div>
            </div>
          </ng-container>
        </div> -->
        <!-- <div class="col-12 mt-2" style="position: sticky;top: 96vh;">
          <div class="w-100 text-center color-gray-light">
            <span>Powered By Credeee</span>
          </div>
        </div> -->
      </div>
      <ng-container *ngIf="planInfo">
        <!-- <div class="d-none bg-white view_plan_block p-3">
            <div class="d-flex align-items-center justify-content-between flex-wrap">
              <p class="color-gray fs-14">Estimated Payment Plan</p>
              <p class="h3 fw-900 text-black mb-0">
                {{planInfo && planInfo.treatment_amount ?
                (planInfo.treatment_amount - planInfo.downpayment_amount |
                currency : '$') :'$0.00'}}
              </p>
            </div>
          </div> -->
        <!-- <div class="col-12 block_hello_user_1" *ngIf="planInfo && planInfo.patient_first_name">
            <span class="fs-18 fw-700 text-capitalize">Hello, <span class="primary-blue">{{(planInfo.patient_first_name || '') + ' ' +
                (planInfo.patient_last_name || '') | titlecase}}</span></span>
            <div class="w-100 d-flex align-items-center justify-content-between pe-2 my-2">
              <span class="fs-16 color-gray-1">
                Please review the proposed service plan from  <span class="font-weight-bold color-gray text-capitalize">{{planInfo ?
                  planInfo.practice_name: ''}}</span> 
              </span>
            </div>
          </div> -->


        <!-- <div class="top_container">
            <p class="m-0 p-0 fs-14 fw-700 grey text-white para_class ">Unlock Benefits:</p>
            <marquee behavior="scroll" direction="left" scrollamount="5" class="markque_class">
  
              <div class="d-flex justify-content-between">
                <div>
                  <img src="\assets\png\Card.png" alt="">
                  <p class="d-inline-block align-middle mb-0 p-0">No Credit Checks </p>
                </div>
                <div>
                  <img src="\assets\png\Ticket Sale.png" alt="">
                  <p class="d-inline-block align-middle mb-0 p-0">Improve Credit Scores </p>
                </div>
                <div>
                  <img src="\assets\png\Graph Up.png" alt="">
                  <p class="d-inline-block align-middle mb-0 p-0">No Prepayment Penalties </p>
                </div>
                <div>
                  <img src="\assets\png\Ticket Sale.png" alt="">
                  <p class="d-inline-block align-middle mb-0 p-0">No Accrued Interest on Late Payments </p>
                </div>
                <div>
                  <img src="\assets\png\Bill Check.png" alt="">
                  <p class="d-inline-block align-middle mb-0 p-0">Social Payments</p>
                </div>
              </div>
            </marquee>
          </div> -->

        <!-- <div class="col-12 mt-4 container_plan_cards no_scroll" *ngIf="planInfo">
            <div class="form-check content_mid mb-2 px-0">
              <div class="col-12">
                <div class="row box-height">
                  <div class="col-6 border-first p-4">
                    <p class="text-heads mb-1 mt-3">Term Duration</p>
                    <p class="f-s-22-w-800">{{planInfo && planInfo.plans_array && planInfo.plans_array[0]
                      ? planInfo.plans_array[0].month: '3'}} Months
                    </p>
                  </div>
                  <div class="col-6 border-second p-4">
                    <p class="text-heads mb-1 mt-3">Total Payable Today</p>
                    <p class="f-s-22-w-800" style="color: #1581E5;">{{planInfo && planInfo.plans_array &&
                      planInfo.plans_array[0]
                      ? (planInfo.plans_array[0].total_payable_amount | currency : '$') :'$0.00'}}
                    </p>
                  </div>
                </div>
                <div class="row box-height">
                  <div class="col-6 border-first p-4">
                    <p class="text-heads mb-1 mt-3">Recurring Amount</p>
                    <p class="text-labels">{{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                      planInfo.selected_plan.recurring_amount && mainService.getCalculatedTransactionFee(planInfo,
                      planInfo.selected_plan.recurring_amount)
                      ?(planInfo.selected_plan.recurring_amount + mainService.getCalculatedTransactionFee(planInfo,
                      planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
                      <span style="color: #989DA3;">per month</span>
                    </p>
                  </div>
                  <div class="col-6 border-second p-4">
                    <p class="text-heads mb-1 mt-3">Interest Rate</p>
                    <p class="text-labels">{{planInfo && planInfo.interest_rate_to_show ?
                      (planInfo.interest_rate_to_show + '%') :
                      planInfo && planInfo.interest_rate ? (planInfo.interest_rate + '%') : '0%'}}
                      <sup>{{planInfo && !planInfo.interest_rate_to_show || (planInfo && planInfo.interest_rate ==
                        planInfo && planInfo.interest_rate_to_show) ? 'C' :'F'}}
                      </sup>
                    </p>
                  </div>
                </div>
                <div class="row box-height">
                  <div class="col-6 p-4">
                    <div class="financing-labels col-7">Transaction Fee</div>
                    <div class="text-end font-weight-bold f-s-14 col-5">
                      <div [ngClass]="mainService.promotionalTransactionOffer ? 'transaction-fee' : ''" class="d-inline-block ms-2">
                        <span *ngIf="mainService.promotionaloffer">
                                  ${{mainService.promotionalofferValue}}
                                </span>
                        <span>{{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                          planInfo.selected_plan.recurring_amount ?
                          (mainService.getCalculatedTransactionFee(planInfo,planInfo.selected_plan.recurring_amount)
                          |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
                        </span>
                      </div>
                  
                      <div *ngIf="mainService.promotionalTransactionOffer" class="transaction-fee-popup pop-up-right">Promo</div>
                    </div>
                  </div>
                  <div class="col-6 p-4 border-second" style="border-bottom: unset !important;"
                    *ngIf="planInfo && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount">
                    <p class="text-heads mb-1 mt-3"> {{(planInfo.contract_type == 1 || planInfo.contract_type == 3)? 'First
                      Recurring Due
                      Today' :
                      'Upfront Fee'}}
                    </p>
                    <p class=" text-labels">{{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                      planInfo.selected_plan.advance_interest_amount ?
                      (planInfo.selected_plan.advance_interest_amount |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
                    </p>
                  </div>
                </div>
              </div>
  
              <div class="interest" *ngIf="plan">
                <div class="flex-grow-1 text-center py-3 px-2">
                  <div class="similar">Interest Rate: <span class="plan_card_value fs-14"><span class="color-dblue">{{plan
                        &&
                        plan.interest_rate_to_show||
                        plan.interest_rate}}%
                        <sup>{{!plan.interest_rate_to_show || (plan.interest_rate == plan.interest_rate_to_show) ? 'C'
                          :
                          'F'}}</sup>
                      </span></span></div>
                </div>
                <div class="flex-grow-1 text-center py-3 px-2"
                  *ngIf="mainService.getTransactionFee(planInfo,plan.recurring_amount)">
                  <div class="financing-labels col-6">Transaction Fee</div>
                  <div *ngIf="planInfo.selected_plan && mainService.getTransactionFee(planInfo, planInfo.selected_plan.recurring_amount)"
                    class="text-end font-weight-bold f-s-14 col-6 text-colr">
                    <span *ngIf="mainService.promotionalTransactionOffer" [innerText]="mainService.strike_transaction_fee"></span>
                    <div [ngClass]="mainService.promotionalTransactionOffer ? 'transaction-fee' : ''" class=" d-inline-block ms-2">
                      <span *ngIf="mainService.promotionaloffer">
                                  ${{mainService.promotionalofferValue}}
                                </span> 
                      <span>
                        {{mainService.getTransactionFee(planInfo,planInfo.selected_plan.recurring_amount,1)}}/ payment
                      </span>
                    </div>
                    <div *ngIf="mainService.promotionalTransactionOffer" class="transaction-fee-popup pop-up-right">Promo</div>
                    Commented code
                  </div>
                </div>
  
                <div
                  class="flex-grow-1 text-center py-3 px-2 color-dblue ng-star-inserted d-flex align-items-center justify-content-center flex-wrap"
                  *ngIf="plan && plan.advance_interest_amount">
                  <span *ngIf="planInfo.contract_type == 1 || planInfo.contract_type == 3">First Recurring Due
                    Today</span>
                  <span *ngIf="planInfo && planInfo.contract_type == 2" class="similar">
                    {{(planInfo.contract_type == 1 || planInfo.contract_type == 3)? 'First Recurring Due Today' :
                    'Upfront Fee'}}
                  </span>:
                  <div class="">
                    <span class="plan_card_value fs-14">{{plan.advance_interest_amount | currency :'$'}}</span>
                  </div>
                </div>
              </div>
            </div>
  
          </div> -->

        <!-- <div class="col mt-3 w-100 px-3 pt-2 pb-3 button_continue">
            <span class="color-gray-2 fs-12 fw-400">
              F: Fixed Interest, C: Compound Interest
            </span>
           
          </div> -->

      </ng-container>

      <!-- </div> -->
    </div>
    <!-- <div class="d-md-none" *ngIf="planInfo">
      <div style="background: #F4F5F7;">
        <div style="margin:0px 15px;padding: 15px 0;">
          <div class="icons-container">
            <span class="line-span active ms-0" style="margin-right: -80px;"></span>
            <div class="icon-container text-center">
              <div class="verification-icons active">
                <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.3468 1L4.23337 7.875L1 4.75" stroke="black" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
              <p class="icon-info-text animated fadeIn m-0 mt-1 verified-text">Choose plan</p>
            </div>
            <span class="line-span active"></span>
            <div class="icon-container text-center">
              <div class="verification-icons">
                <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.3468 1L4.23337 7.875L1 4.75" stroke="black" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
              <p class="icon-info-text animated fadeIn m-0 mt-1">Add Payment Method</p>
            </div>
            <span class="line-span"></span>
            <div class="icon-container text-center">
              <div class="verification-icons inactive">
                <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.3468 1L4.23337 7.875L1 4.75" stroke="black" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
              <p class="icon-info-text animated fadeIn m-0 mt-1 inactive">Add Personal Details</p>
            </div>
            <span class="line-span me-0" style="margin-left: -80px;"></span>
          </div>
        </div>
      </div>
  
      <div class="payment-card-1" *ngIf="opened_step == 0">
        <div class="accordion-header">
          Contract Information
        </div>
        <div *ngIf="opened_step == 0" style="padding: 10px 0px;">
          <div class="row col-12 m-0 p-0 mb-2">
            <div class="financing-labels col-6 p-0">Service Amount</div>
            <div class="text-end font-weight-bold f-s-14 col-6 p-0 text-colr">{{mainService.currency_data.display_logo}} {{planInfo.treatment_amount |DynamicDecimalPipe:mainService.currency_data.currency_code}}</div>
          </div>
          <div class="row col-12 m-0 p-0 mb-2">
            <div class="financing-labels col-6 p-0">Payment Plan Amount</div>
            <div class="text-end font-weight-bold f-s-14 col-6 p-0 text-colr">
              {{mainService.currency_data.display_logo}} {{(planInfo.treatment_amount - (planInfo.downpayment_amount || 0)) |DynamicDecimalPipe:mainService.currency_data.currency_code}}
            </div>
          </div>
          <div class="row col-12 m-0 p-0 mb-2">
            <div class="financing-labels col-6 p-0">Down Payment</div>
            <div class="text-end font-weight-bold f-s-14 col-6 p-0 text-colr">
              {{mainService.currency_data.display_logo}} {{planInfo && planInfo.downpayment_amount?(planInfo.downpayment_amount |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
            </div>
          </div>
          <div class="row col-12 m-0 p-0 mb-2"
            *ngIf="planInfo && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount">
            <div class="financing-labels col-6 p-0">
              {{(planInfo.contract_type == 1 || planInfo.contract_type == 3)? 'First Recurring Due Today' :
              'Upfront Fee'}}
            </div>
            <div class="text-end font-weight-bold f-s-14 col-6 p-0 text-colr">
              {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount ?
              (planInfo.selected_plan.advance_interest_amount |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
            </div>
          </div>
          <div class="row col-12 m-0 p-0 mb-2" *ngIf="planInfo && planInfo.enrollment_enabled != 1">
            <div class="financing-labels col-6 p-0">Enrollment Fee</div>
            <div class="text-end font-weight-bold f-s-14 col-6 p-0 text-colr position-relative">
              <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"
                [innerText]="mainService.strike_enrollment_fee"></span>
              <div [ngClass]="mainService.promotionalEnrollmentOffer ? 'transaction-fee' : ''" class=" d-inline-block ms-2"> ${{enrollment_fee}}</div>
              <div class="transaction-fee-popup pop-up-right">Promo</div>
            </div>
          </div>
          <div class="row col-12 m-0 p-0 mb-2">
            <div class="financing-labels col-6 p-0">Recurring Payment</div>
            <div class="text-end font-weight-bold f-s-14 col-6 p-0 text-colr">
              {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
              planInfo.selected_plan.recurring_amount 
              ?(planInfo.selected_plan.recurring_amount + mainService.getCalculatedTransactionFee(planInfo,
              planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
              <i class="fa fa-info-circle" [tooltip]="'Your recurring amount includes a transaction fee'"></i>
            </div>
          </div>
          <div class="row col-12 m-0 p-0 mb-2">
            <div class="financing-labels col-6 p-0">Interest Rate</div>
            <div class="text-end font-weight-bold f-s-14 col-6 p-0 text-colr">{{planInfo.interest_rate_to_show ?
              (planInfo.interest_rate_to_show + '%') :
              planInfo.interest_rate ? (planInfo.interest_rate + '%') : '0%'}}
              <sup>{{!planInfo.interest_rate_to_show || (planInfo.interest_rate ==
                planInfo.interest_rate_to_show) ? 'C' :'F'}}</sup>
            </div>
          </div>
          <div class="row d-md-none blank-space" style="min-height: 3px;"></div>
          <div class="col-12 next-pay-btn mt-2" (click)="ChangeArrows(1)">Continue</div>
        </div>
      </div>
      <div class="payment-card-1" *ngIf="opened_step != 4 && opened_step != 0">
        <div class="accordion-header" (click)="ChangeArrows(1)">
          <p class="m-0">
            Payment Today
            <label class="pull-right opened-arrow" *ngIf="opened_step == 1">></label>
            <label class="pull-right closed-arrow" *ngIf="opened_step != 1">></label>
            <span class="pull-right me-2"> {{mainService.currency_data.display_logo}} {{planInfo.selected_plan && planInfo.selected_plan.total_payable_amount
              ? (planInfo.selected_plan.total_payable_amount |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</span>
          </p>
          <p class="m-0 f-s-12" *ngIf="selected_dp_card && selected_dp_card.last4">
            Payment method added successfully
          </p>
          <p class="m-0 f-s-12">
            <label class="m-0" *ngIf="selected_dp_card && selected_dp_card.last4">
              <i class="fa fa-credit-card lightGreyIcon me-2" *ngIf="selected_dp_card.payment_source_type != 1"></i>
              <i class="fa fa-bank lightGreyIcon me-2"
                *ngIf="selected_dp_card.payment_source_type == 1"></i>{{selected_dp_card.last4}}
            </label>
          </p>
        </div>
        <div *ngIf="opened_step == 1" style="padding: 10px 0px;">
          <div class="row col-12 m-0 p-0 mb-2" *ngIf="!planInfo.is_ar_contract">
            <div class="financing-labels col-6 p-0">Down Payment</div>
            <div class="text-end font-weight-bold f-s-14 col-6 p-0 text-colr">{{mainService.currency_data.display_logo}} {{planInfo &&
              planInfo.downpayment_amount?(planInfo.downpayment_amount |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</div>
          </div>
          <div class="row mb-2" *ngIf="planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount">
            <div *ngIf="(planInfo.contract_type == 1 || planInfo.contract_type == 3)" class="financing-labels col-6">
              First
              Recurring Due
              Today</div>
            <div *ngIf="planInfo.contract_type == 2 || planInfo.contract_type == 4 || planInfo.contract_type == 5" class="financing-labels col-6">
              {{planInfo.is_ar_contract == 1 ? 'Upfront Payment' :'Upfront Fee'}}
            </div>
            <div class="text-end font-weight-bold f-s-14 col-6 text-colr">{{mainService.currency_data.display_logo}} {{planInfo.selected_plan &&
              planInfo.selected_plan.advance_interest_amount?(planInfo.selected_plan.advance_interest_amount |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</div>
          </div>
          <div class="row mb-2" *ngIf="planInfo.enrollment_enabled!=1">
            <div class="financing-labels col-6">{{planInfo.is_ar_contract == 1? 'Account Setup Fee' : 'Enrollment
              Fee'}}
              <img src="assets/svg/offer.svg" width="20px"
                tooltip="{{'If you instantly pay your payment today using bank, you will get $' + enrollment_fee + ' off on your contract enrollment fee!'}}"
                *ngIf="planInfo.enrollment_waiver == 1 && planInfo.selected_payment_matrix.primary_type == 3 && planInfo.enrollment_enabled == 0">
            </div>
            <del class="text-end font-weight-bold f-s-14 col-6 financing-labels col-6 text-colr" *ngIf="is_waived">${{enrollment_fee}}</del>
            <div class="text-end font-weight-bold f-s-14 col-6 text-colr" *ngIf="!is_waived">${{enrollment_fee}}</div>
          </div>
          <div class="row mb-2">
            <div class="financing-labels col-6">Transaction Fee</div>
            <div
              *ngIf="planInfo.selected_plan && mainService.getTransactionFee(planInfo, planInfo.selected_plan.recurring_amount)"
              class="text-end font-weight-bold f-s-14 col-6 text-colr">
              <span *ngIf="mainService.promotionalTransactionOffer" [innerText]="mainService.strike_transaction_fee"></span>
              <div [ngClass]="mainService.promotionalTransactionOffer ? 'transaction-fee' : ''" class=" d-inline-block ms-2">
                <span>
                  {{mainService.getTransactionFee(planInfo,planInfo.selected_plan.recurring_amount,1)}}/ payment
                </span>
              </div>
              <div *ngIf="mainService.promotionalTransactionOffer" class="transaction-fee-popup pop-up-right">Promo</div>
            </div>
          </div>
          <div class="row d-md-none blank-space" style="min-height: 3px;"></div>
          <div class="row VHAlign" style="padding: 10px 0;">
            <div class="font-weight-bold h5 col-6 m-0 same-line">Total Payment</div>
            <div class="text-end font-weight-bold f-s-14 col-6 m-0 text-colr">
              {{mainService.currency_data.display_logo}} {{planInfo.selected_plan && planInfo.selected_plan.total_payable_amount
              ? (planInfo.selected_plan.total_payable_amount |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
            </div>
          </div>
          <div class="row d-md-none blank-space" style="min-height: 3px;"></div>
          <div class="row pt-3 pb-3">
            <div class="col-12">
              <label>Please add your payment method</label>
            </div>
            <div class="col-12 text-center row m-0">
              <button class="mt-2 mt-lg-0 btn btn-primary  px-2 f-s-12 mobile_blink_me me-1 mob-add-card col"
                (click)="openAddBankPopup()"
                *ngIf="patientData && (patientData.plaid_access_token == null || !patientData.plaid_access_token) && planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.primary_type == 1 || planInfo.selected_payment_matrix.primary_type == 3)">
                Add Bank Account
                <img src="assets/svg/offer.svg" width="20px"
                  *ngIf="planInfo.enrollment_waiver == 1 && planInfo.selected_payment_matrix.primary_type == 3 && planInfo.enrollment_enabled == 0">
              </button>
              <button class="mt-2 mt-lg-0 btn btn-primary  px-2 f-s-12 mob-add-card col"
                (click)="cards_array = patientData.primary_sources; add_card_source_id = dp_source_id; addMobileNewCardModal.show()"
                [ngClass]="{'mobile_blink_me': primary_card_added == 0}"
                *ngIf="planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.primary_type == 2 || planInfo.selected_payment_matrix.primary_type == 3 || !(patientData && (patientData.plaid_access_token == null || !patientData.plaid_access_token)))">
                Add Card
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row d-md-none blank-space" style="min-height: 5px;" *ngIf="opened_step != 4 && opened_step != 0"></div>
      <div class="payment-card-1" *ngIf="opened_step != 4 && opened_step != 0">
        <div class="accordion-header" (click)="ChangeArrows(2)" [ngClass]="{'disabled': !dp_source_id}">
          Recurring Payments
          <label class="pull-right opened-arrow" *ngIf="opened_step == 2">></label>
          <label class="pull-right closed-arrow" *ngIf="opened_step != 2">></label>
          <span class="pull-right me-2"> {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
            planInfo.selected_plan.recurring_amount 
            ?(planInfo.selected_plan.recurring_amount + mainService.getCalculatedTransactionFee(planInfo,
            planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</span>
          <br>
          <label class="m-0" *ngIf="selected_recurring_card && selected_recurring_card.last4">
            <i class="fa fa-credit-card lightGreyIcon me-2"
              *ngIf="selected_recurring_card.payment_source_type != 1"></i>
            <i class="fa fa-bank lightGreyIcon me-2"
              *ngIf="selected_recurring_card.payment_source_type == 1"></i>{{selected_recurring_card.last4}}
          </label>
        </div>
        <div *ngIf="opened_step == 2" style="padding: 10px 0px;">
          <div class="row col-12 m-0 p-0 mb-3 mt-1">
            <div class="financing-labels col-6 p-0">Recurring Amount</div>
            <div class="text-end font-weight-bold f-s-14 col-6 p-0">
              {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
              planInfo.selected_plan.recurring_amount?((planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code):
              '$0.00'}}
            </div>
          </div>
          <div class="row mb-3 mt-1">
            <div class="financing-labels col-7">Transaction Fee</div>
            <div class="text-end font-weight-bold f-s-14 col-5">
              <div [ngClass]="mainService.promotionalTransactionOffer ? 'transaction-fee' : ''" class="d-inline-block ms-2">
                <span>
                  {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                planInfo.selected_plan.recurring_amount ?
                (mainService.getCalculatedTransactionFee(planInfo,planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</span>
              </div>
             
              <div *ngIf="mainService.promotionalTransactionOffer" class="transaction-fee-popup pop-up-right">Promo</div>
            </div>
          </div>
          <div class="row mb-2" *ngIf="planInfo.disable_recurring == 1">
            <div class="financing-labels col-6">Starting Date</div>
            <div class="text-end font-weight-bold f-s-14 col-6">
              {{paymentDetails.recurringDate | date: 'MM-dd-yyyy'}}
            </div>
          </div>
          <div class="row d-md-none blank-space" style="min-height: 3px;"></div>
          <div class="row VHAlign" style="padding: 10px 0;">
            <div class="font-weight-bold f-s-14 col-6 m-0 same-line">Total Payment</div>
            <div class="text-end font-weight-bold f-s-14 col-6 m-0">
              {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
              planInfo.selected_plan.recurring_amount 
              ?(planInfo.selected_plan.recurring_amount + mainService.getCalculatedTransactionFee(planInfo,
              planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
            </div>
          </div>
          <div class="row d-md-none blank-space" style="min-height: 3px;"></div>
          <div class="row pt-3 pb-3">
            <div class="col-12 row pe-0 VHAlign mb-3" *ngIf="planInfo.disable_recurring == 0">
              <div class="col-6">
                Next Payment date
              </div>
              <div class="col-6 pe-0">
                <div class="input-group">
                  <input type="text" required #dob="ngModel" name="recurringDate" readonly
                    class="form-control date-picker" placeholder="Select Date" [bsConfig]="bsConfig"
                    [(ngModel)]="paymentDetails.recurringDate" #recurringDp1="bsDatepicker" bsDatepicker
                    [maxDate]="planInfo.max_date" [minDate]="planInfo.min_date" style="border-color: #017A9F;">
                  <div class="input-group-append" tappable (click)="recurringDp1.toggle()">
                    <span class="input-group-text" style="border-color: #017A9F;background-color: #ffffff;">
                      <i class="fa fa-calendar" style="color: #017A9F !important;"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <label>Please add your payment method</label>
            </div>
            <div class="col-12 text-center row m-0">
              <button class="mt-2 mt-lg-0 btn btn-primary  px-2 f-s-12 mobile_blink_me me-1 mob-add-card col"
                (click)="openAddBankPopup()"
                *ngIf="patientData && (patientData.plaid_access_token == null || !patientData.plaid_access_token) && planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.recurring_type == 1 || planInfo.selected_payment_matrix.recurring_type == 3)">
                Add Bank Account
              </button>
              <button class=" mt-2 mt-lg-0 btn btn-primary  px-2 f-s-12 mob-add-card col"
                (click)="cards_array = patientData.recurring_sources; add_card_source_id = recurring_source_id; addMobileNewCardModal.show()"
                [ngClass]="{'mobile_blink_me': recurring_card_added == 0}"
                *ngIf="planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.recurring_type == 2 || planInfo.selected_payment_matrix.recurring_type == 3 || !(patientData && (patientData.plaid_access_token == null || !patientData.plaid_access_token)))">
                Add Card
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row d-md-none blank-space" style="min-height: 5px;" *ngIf="opened_step != 4 && opened_step != 0"></div>
      <div class="payment-card-1" *ngIf="opened_step != 4 && opened_step != 0">
        <div class="accordion-header" (click)="ChangeArrows(3)" [ngClass]="{'disabled': !recurring_source_id}">
          Backup Payment Method
          <span
            *ngIf="planInfo && planInfo.selected_payment_matrix && planInfo.selected_payment_matrix.backup_required == 0">(Optional)</span>
          <label class="pull-right opened-arrow" *ngIf="opened_step == 3">></label>
          <label class="pull-right closed-arrow" *ngIf="opened_step != 3">></label>
          <br>
          <label class="m-0" *ngIf="selected_backup_card && selected_backup_card.last4">
            <i class="fa fa-credit-card lightGreyIcon me-2"
              *ngIf="selected_backup_card.payment_source_type != 1"></i>
            <i class="fa fa-bank lightGreyIcon me-2"
              *ngIf="selected_backup_card.payment_source_type == 1"></i>{{selected_backup_card.last4}}
          </label>
        </div>
        <div *ngIf="opened_step == 3" style="padding: 10px 0px;">
          <div class="row">
            <div class="col-12">
              <label>
                Set up an alternative payment method that can be used if your primary method fails for any reason.
                <i class="fa fa-info-circle text-colr" (click)="backupNotesModal.show()"></i>
              </label>
            </div>
          </div>
          <div class="row d-md-none blank-space" style="min-height: 3px;"></div>
          <div class="row pt-3 pb-3">
            <div class="col-12">
              <label>Please add your payment method</label>
            </div>
            <div class="col-12 text-center row m-0">
              <button class="mt-2 mt-xl-0 btn btn-primary  px-2 f-s-12 mobile_blink_me me-1 mob-add-card col"
                (click)="openAddBankPopup()"
                *ngIf="patientData && (patientData.plaid_access_token == null || !patientData.plaid_access_token) && planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.backup_type == 1 || planInfo.selected_payment_matrix.backup_type == 3)">
                Add Bank Account
              </button>
              <button class="mt-2 mt-xl-0 btn btn-primary  px-2 f-s-12 mob-add-card col"
                (click)="cards_array = patientData.backup_sources; add_card_source_id = backup_source_id; addMobileNewCardModal.show()"
                [ngClass]="{'mobile_blink_me': backup_card_added == 0}"
                *ngIf="planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.backup_type == 2 || planInfo.selected_payment_matrix.backup_type == 3 || !(patientData && (patientData.plaid_access_token == null || !patientData.plaid_access_token)))">
                Add Card
              </button>
            </div>
          </div>
          <div class="row d-md-none blank-space" style="min-height: 3px;"></div>
          <div class="col-12 next-pay-btn mt-2" (click)="nextStep()"
            *ngIf="planInfo.selected_payment_matrix.backup_required == 0 && !backup_source_id">
            {{planInfo.selected_payment_matrix.backup_required == 0 && !backup_source_id ? 'Skip' : 'Next'}}
          </div>
        </div>
      </div>
      <div class="payment-steps" [hidden]="payment_step != 4">
        <div class="row">
          <div class="col-12 col-md-8 offset-md-2">
            <div style="padding: 0px 15px 10px 15px;">
              <div class="mt-0 mb-0 pt-4 pb-4">
                <span>
                  Please review your payment details for a contract of <span
                    class="text-bold">${{planInfo.financed_amount | DynamicDecimalPipe:mainService.currency_data.currency_code}}</span> for
                  <span class="text-bold"
                    *ngIf="planInfo && planInfo.selected_plan && !((planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan.advance_interest_amount)">
                    {{planInfo && planInfo.selected_plan && planInfo.selected_plan.month?(planInfo.selected_plan.month):
                    '0'}}
                  </span>
                  <span class="text-bold"
                    *ngIf="planInfo && (planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount">
                    {{planInfo && planInfo.selected_plan && planInfo.selected_plan.month?(planInfo.selected_plan.month -
                    1):
                    '0'}}
                  </span>
                  months.
                </span>
              </div>
              <div style="margin: 10px;">
                <div class="row mb-2" *ngIf="selected_dp_card">
                  <div class="col-1">
                    <i class="fa fa-check-circle"></i>
                  </div>
                  <div class="col-7 col-sm-7">
                    <span class="text-bold">Payment Today</span>
                    <br>
                    <div class="same-line faded-card-details">
                      (<i class="fa fa-credit-card lightGreyIcon"
                        *ngIf="selected_dp_card.payment_source_type != 1"></i>
                      <i class="fa fa-bank lightGreyIcon" *ngIf="selected_dp_card.payment_source_type == 1"></i>
                      {{selected_dp_card.last4}}
                      <span *ngIf="selected_dp_card.payment_source_type == 1 && dp_source_id == -1">-Verification
                        Pending</span>)
                    </div>
                  </div>
                  <div class="col-3 col-sm-3 p-0 text-end text-bold"
                    style="margin-left: -5px;white-space: nowrap; color: #3791e5;">
                    {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                    planInfo.selected_plan.total_payable_amount?(planInfo.selected_plan.total_payable_amount |DynamicDecimalPipe:mainService.currency_data.currency_code):
                    '$0.00'}}
                  </div>
                </div>
                <hr *ngIf="selected_recurring_card">
                <div class="row mb-2" *ngIf="selected_recurring_card">
                  <div class="col-1">
                    <i class="fa fa-check-circle"></i>
                  </div>
                  <div class="col-7 col-sm-7">
                    <span class="text-bold">Recurring Payment Starting on
                      <span style="white-space: nowrap;">{{paymentDetails.recurringDate | date: 'MM-dd-yyyy'}}</span>
                    </span>
                    <br>
                    <div class="same-line faded-card-details">
                      (<i class="fa fa-credit-card lightGreyIcon"
                        *ngIf="selected_recurring_card.payment_source_type != 1"></i>
                      <i class="fa fa-bank lightGreyIcon"
                        *ngIf="selected_recurring_card.payment_source_type == 1"></i>
                      {{selected_recurring_card.last4}}
                      <span
                        *ngIf="selected_recurring_card.payment_source_type == 1 && recurring_source_id == -1">-Verification
                        Pending</span>)
                    </div>
                  </div>
                  <div class="col-3 col-sm-3 p-0 text-end text-bold"
                    style="margin-left: -5px;white-space: nowrap; color: #3791e5;">
                    {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                    planInfo.selected_plan.recurring_amount
                    ?(planInfo.selected_plan.recurring_amount + mainService.getCalculatedTransactionFee(planInfo,
                    planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
                  </div>
                </div>
                <hr *ngIf="selected_backup_card">
                <div class="row mb-2" *ngIf="selected_backup_card">
                  <div class="col-1">
                    <i class="fa fa-check-circle"></i>
                  </div>
                  <div class="col-8 col-sm-8">
                    <span class="text-bold">Backup Payment Source</span>
                    <br>
                    <div class="same-line faded-card-details">
                      (<i class="fa fa-credit-card lightGreyIcon"
                        *ngIf="selected_backup_card.payment_source_type != 1"></i>
                      <i class="fa fa-bank lightGreyIcon" *ngIf="selected_backup_card.payment_source_type == 1"></i>
                      {{selected_backup_card.last4}}
                      <span *ngIf="selected_backup_card.payment_source_type == 1 && backup_source_id == -1">-Verification
                        Pending</span>)
                    </div>
                  </div>
                  <div class="col-2 col-sm-2 p-0 text-end text-bold">
                    -
                  </div>
                </div>
                <hr>
              </div>
              <div class="row d-md-none blank-space" style="min-height: 5px;"></div>
              <div class="form-group mb-4 row m-0 mt-2">
                <div class="w-100">
                  <label>Draw your "signature" below
                  </label>
                  <span class="pull-right" (click)="clearSign()">
                    <i class="fa fa-repeat me-1" style="color: #6F6969;"></i><span style="color: #3791e5;">Clear</span>
                  </span>
                </div>
  
                <div class="p-0 col-12" #canvasDiv id="canvasDiv" style="position: relative"
                  style="border: solid 1px #dce5eb;height: 200px;border-radius: 10px;" *ngIf="is_mobile_screen">
                  <signature-pad style="display:table" [options]="signaturePadOptions" (onEndEvent)="drawComplete()">
                  </signature-pad>
                </div>
              </div>
              <div class="mt-1 mb-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" name="terms" [(ngModel)]="terms" id="terms">
                  <label class="custom-control-label" for="terms">
                    I’ve read & agreed to the <a style="color: #017A9F !important;" target="_blank" [routerLink]="['/tila']">TILA
                      Disclosure</a>,
                    <a style="color: #017A9F !important;" target="_blank" [routerLink]="['/consentForm']">Payment Authorization
                      Agreement&nbsp;and&nbsp;HIPAA Disclosure</a>.
                    </label>
                </div>
                <div class="custom-control custom-checkbox"
                  *ngIf="split_request_data[0].buss_terms_link && split_request_data[0].show_buss_terms">
                  <input type="checkbox" class="custom-control-input" name="check_business_terms" [(ngModel)]="check_business_terms"
                    id="check_business_terms">
                  <label class="custom-control-label" for="check_business_terms">
                    I hereby read & accept the terms and conditions of
                    <a href="javascript:void(0)" (click)="goToLink(split_request_data[0].buss_terms_link)"
                      *ngIf="split_request_data[0].buss_terms_link && split_request_data[0].show_buss_terms"
                      rel="noopener noreferrer">{{split_request_data[0].practice_name || (split_request_data[0].doctor_first_name + ' ' + split_request_data[0].doctor_last_name) || 'Business Terms'}}.</a>
                  </label>
                </div>
              </div>
              <div class="col-12 next-pay-btn mt-2" (click)="nextStep()">Confirm & Pay</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 col-md-12" style="font-size: 12px;" *ngIf="payment_step == 0">
        <p class="m-0 px-2" style="margin-bottom: 25px !important;">F: Fixed Interest, C: Compound Interest</p>
      </div>
    </div>
    <div class="d-none d-md-block p-4">
      <app-steps></app-steps>
      <div class="mt-4">
        <div class="card-body p-1" *ngIf="planInfo">
          <p class="h5 mt-1 px-2 py-2 text-center text-muted steps-inner d-none d-sm-block"
            *ngIf="payment_step != 0 && payment_step != 4">
            <span class="text-bold" [ngClass]="{'link-primary':payment_step == 1}">Payment Today</span>
            <i class="fa fa-chevron-right mx-2"></i>
            <span class="text-bold" [ngClass]="{'link-primary':payment_step == 2}">Recurring Payments</span>
            <i class="fa fa-chevron-right mx-2"></i>
            <span class="text-bold" [ngClass]="{'link-primary':payment_step == 3}">Backup Payment Source</span>
          </p>
          <div class="col-12 step-heading d-sm-none text-bold" style="border-radius: 10px 10px 0px 0px; font-size: 15px;">
            <div class="row">
              <div class="col-12">Payment Link</div>
            </div>
          </div>
          <div class="outer-step-body">
            <div class="">
              <div class="payment-steps" *ngIf="payment_step == 0">
                <div class="row">
                  <div class="col-12 col-md-6 offset-md-3">
                    <div>
                      <p *ngIf="planInfo.doctor_id" class="mt-4 mb-0 px-2 f-s-16-w-400">
                        Hello <span class="text-new-wrap text-capitalize">{{planInfo.patient_first_name + ' ' +
                          planInfo.patient_last_name}},</span>
                      </p>
                      <p *ngIf="planInfo.doctor_id" class="mt-0 mb-4 px-2 f-s-16-w-400"
                        [hidden]="planInfo && planInfo.is_ar_contract == 1">Please review
                        the proposed contract from
                        <span class="text-new-wrap text-capitalize">{{planInfo && planInfo.practice_name ?
                          planInfo.practice_name : planInfo.doctor_first_name ? (planInfo.doctor_first_name + ' ' +
                          planInfo.doctor_last_name)
                          :''}}</span>
                        below:
                      </p>
                    </div>
                    <div class="payment-breakdown" style="background: #f8f8f8;">
                      <h4 class="text-start contract-info recurring-title">
                        <span class="text-bold">Contract Information</span>
                      </h4>
                      <ul type="circle" class="ps-4 list-clear" *ngIf="planInfo">
                        <li>
                          <span class="text-muted">Service Amount</span>
                          <span class="float-end font-weight-bold f-s-14 text-colr">
                            {{mainService.currency_data.display_logo}} {{planInfo.treatment_amount |DynamicDecimalPipe:mainService.currency_data.currency_code}}
                          </span>
                        </li>
                        <li>
                          <span class="text-muted">Payment Plan Amount</span>
                          <span class="float-end font-weight-bold f-s-14 text-colr">{{mainService.currency_data.display_logo}}
                            {{(planInfo.treatment_amount - (planInfo.downpayment_amount || 0)) |DynamicDecimalPipe:mainService.currency_data.currency_code}}
                          </span>
                        </li>
                        <li>
                          <span class="text-muted">Down Payment</span>
                          <span class="float-end font-weight-bold f-s-14 text-colr">{{mainService.currency_data.display_logo}}{{planInfo &&
                            planInfo.downpayment_amount?(planInfo.downpayment_amount |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</span>
                        </li>
                        <li *ngIf="planInfo && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount">
                          <span class="text-muted">
                            {{(planInfo.contract_type == 1 || planInfo.contract_type == 3)? 'First Recurring Due Today' :
                            'Upfront Fee'}}
                          </span>
                          <span class="float-end font-weight-bold f-s-14 text-colr">
                            {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount ?
                            (planInfo.selected_plan.advance_interest_amount |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
                          </span>
                        </li>
                        <li *ngIf="planInfo && planInfo.enrollment_enabled!=1">
                          <span class="text-muted">Enrollment Fee
                          </span>
                          <span class="float-end font-weight-bold f-s-14 text-colr position-relative"><span *ngIf="mainService.promotionalEnrollmentOffer" 
                              [innerText]="mainService.strike_enrollment_fee" class="strike_through_class"></span> 
                              <div [ngClass]="mainService.promotionalEnrollmentOffer ? 'transaction-fee' : ''"  class=" d-inline-block ms-2"> ${{enrollment_fee}}</div>
                              <div  *ngIf="mainService.promotionalEnrollmentOffer" class="transaction-fee-popup pop-up-right">Promo</div>
                                </span>
                        </li>
                        <li>
                          <span class="text-muted">Recurring Payment</span>
                          <span class="float-end font-weight-bold f-s-14 text-colr"> {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                            planInfo.selected_plan.recurring_amount 
                            ?(planInfo.selected_plan.recurring_amount + mainService.getCalculatedTransactionFee(planInfo,
                            planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
                            <i class="fa fa-info-circle" [tooltip]="'Your recurring amount includes a transaction fee'"></i>
                          </span>
                        </li>
                        <li>
                          <span class="text-muted">Interest Rate</span>
                          <span class="float-end font-weight-bold f-s-14 text-colr">
                            {{planInfo.interest_rate_to_show ? (planInfo.interest_rate_to_show + '%') :
                            planInfo.interest_rate ? (planInfo.interest_rate + '%') : '0%'}}
                            <sup>{{!planInfo.interest_rate_to_show || (planInfo.interest_rate ==
                              planInfo.interest_rate_to_show) ? 'C' :'F'}}</sup>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="payment-steps" *ngIf="payment_step == 1">
                <h3 class="step-header-text f-s-24-w-700 d-none d-sm-block">How Much You'll Pay Today</h3>
                <div class="col-12 step-heading d-none d-sm-block">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <span class="font-weight-bold h5">${{planInfo.financed_amount | DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                      at
                      <span class="font-weight-bold h5">{{planInfo.interest_rate_to_show ? (planInfo.interest_rate_to_show
                        + '%') :
                        planInfo.interest_rate ? (planInfo.interest_rate + '%') : ''}}
                        <sup>{{!planInfo.interest_rate_to_show || (planInfo.interest_rate ==
                          planInfo.interest_rate_to_show) ? 'C' :
                          'F'}}</sup>
                      </span>
                      promotional interest rate
                    </div>
                    <div class="col-md-6 col-12 hide-mob">
                      <span class="font-weight-bold h5 me-1"> {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                        planInfo.selected_plan.recurring_amount
                        ?(planInfo.selected_plan.recurring_amount + mainService.getCalculatedTransactionFee(planInfo,
                        planInfo.selected_plan.recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</span>
                      <i class="fa fa-info-circle" [tooltip]="'Your recurring amount includes a transaction fee'"></i>
                      Recurring payment amount for the next
                      <span class="font-weight-bold h5"
                        *ngIf="planInfo && planInfo.selected_plan && !((planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan.advance_interest_amount)">
                        {{planInfo && planInfo.selected_plan &&
                        planInfo.selected_plan.month?(planInfo.selected_plan.month): '0'}}
                      </span>
                      <span class="font-weight-bold h5"
                        *ngIf="planInfo && (planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount">
                        {{planInfo && planInfo.selected_plan && planInfo.selected_plan.month?(planInfo.selected_plan.month
                        - 1): '0'}}
                      </span>
                      months
                    </div>
                  </div>
                </div>
                <div class="step-body">
                  <div class="row">
                    <div class="col-lg-5 col-md-6 col-12">
                      <div class="payment-breakdown" style="background: #f8f8f8;">
                        <h4 class="text-start recurring-title">
                          <span class="text-bold f-s-18">Total Payment Today</span>
                          <span class="float-end font-weight-bold  f-s-20">{{mainService.currency_data.display_logo}}{{planInfo && planInfo.selected_plan &&
                            planInfo.selected_plan.total_payable_amount?(planInfo.selected_plan.total_payable_amount |DynamicDecimalPipe:mainService.currency_data.currency_code):
                            '$0.00'}}
                          </span>
                        </h4>
                        <ul type="circle" class="ps-4 list-clear">
                          <li *ngIf="planInfo">
                            <span class="text-muted">Down Payment</span> <span
                              class="float-end font-weight-bold f-s-14 text-colr">{{mainService.currency_data.display_logo}} {{planInfo &&
                              planInfo.downpayment_amount?(planInfo.downpayment_amount |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</span>
                          </li>
                          <li
                            *ngIf="planInfo && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount">
                            <span *ngIf="planInfo && (planInfo.contract_type == 1 || planInfo.contract_type == 3)"
                              class="text-muted">First Recurring Due
                              Today</span>
                            <span *ngIf="planInfo && (planInfo.contract_type == 2 || planInfo.contract_type == 4 || planInfo.contract_type == 5)" class="text-muted">
                              {{planInfo && planInfo.is_ar_contract == 1 ? 'Upfront Payment' :'Upfront Fee'}}
                            </span>
                            <span class="float-end font-weight-bold f-s-14 text-colr">{{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                              planInfo.selected_plan.advance_interest_amount?(planInfo.selected_plan.advance_interest_amount
                              | DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</span>
                          </li>
                          <li *ngIf="planInfo && planInfo.enrollment_enabled!=1">
                            <span class="text-muted">{{planInfo && planInfo.is_ar_contract == 1? 'Account Setup Fee' :
                              'Enrollment
                              Fee'}}
                              <img src="assets/svg/offer.svg" width="20px"
                                tooltip="{{'If you instantly pay your payment today using bank, you will get $' + enrollment_fee + ' off on your contract enrollment fee!'}}"
                                *ngIf="planInfo.enrollment_waiver == 1 && planInfo.selected_payment_matrix.primary_type == 3 && planInfo.enrollment_enabled == 0">
                            </span>
                            <del class="float-end font-weight-bold f-s-14 text-muted text-colr" *ngIf="is_waived">${{enrollment_fee ? enrollment_fee: '30'}}</del>
                            <span class="float-end font-weight-bold f-s-14 text-colr position-relative" *ngIf="!is_waived"> <span  *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"
                                [innerText]="mainService.strike_enrollment_fee"></span><div [ngClass]="mainService.promotionalEnrollmentOffer ? 'transaction-fee' : ''"  class="d-inline-block ms-2" >  ${{enrollment_fee ? enrollment_fee: '30'}}</div>
                                <div *ngIf="mainService.promotionalEnrollmentOffer"  class="transaction-fee-popup pop-up-right">Promo</div>
                              </span>
                          </li>
                          <li>
                            <span class="text-muted">Transaction Fee</span>
                            <span
                              *ngIf="planInfo && planInfo.selected_plan"
                              class="float-end font-weight-bold f-s-14 text-colr position-relative">
                              <span *ngIf="mainService.promotionalTransactionOffer"  class="strike_through_class" [innerText]="mainService.getTransactionFeeStrike(planInfo,planInfo.selected_plan.recurring_amount,1)" >
  
                              </span> 
                              
                              <div [ngClass]="mainService.promotionalTransactionOffer ? 'transaction-fee' : ''" class="d-inline-block ms-2">
                                
                                <span>
                                  {{mainService.getTransactionFee(planInfo,planInfo.selected_plan.recurring_amount,1)}}
                                </span>
                              </div>
                              <div *ngIf="mainService.promotionalTransactionOffer"   class="transaction-fee-popup pop-up-right">Promo</div>
                            
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-lg-7 col-md-6 col-12 mt-5 mt-md-0">
                      <div class="primary-card-section" style="background: #f8f8f8;">
                        <div class="row show-mob-only">
                          <div class="col-md-6 col-12">
                            <span class="font-weight-bold h5 me-1"> {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                              planInfo.selected_plan.recurring_amount 
                              ?(planInfo.selected_plan.recurring_amount +
                              mainService.getCalculatedTransactionFee(planInfo,
                              planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</span>
                            <i class="fa fa-info-circle" [tooltip]="'Your recurring amount includes a transaction fee'"></i>
                            Recurring payment amount for the next
                            <span class="font-weight-bold h5"
                              *ngIf="planInfo && planInfo.selected_plan && !((planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan.advance_interest_amount)">
                              {{planInfo && planInfo.selected_plan &&
                              planInfo.selected_plan.month?(planInfo.selected_plan.month):
                              '0'}}
                            </span>
                            <span class="font-weight-bold h5"
                              *ngIf="planInfo && (planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount">
                              {{planInfo && planInfo.selected_plan &&
                              planInfo.selected_plan.month?(planInfo.selected_plan.month - 1):
                              '0'}}
                            </span>
                            months
                          </div>
  
                        </div>
                        <div class="row mt-3 mt-md-0">
                          <div class="pe-0 f-s-13"
                            [ngClass]="{'col-sm-8':planInfo.selected_payment_matrix.primary_type != 3, 'col-sm-5':planInfo.selected_payment_matrix.primary_type == 3}">
                            <span *ngIf="planInfo.selected_payment_matrix.primary_type == 1">Please add your bank to make
                              the
                              payment
                              today</span>
                            <span *ngIf="planInfo.selected_payment_matrix.primary_type == 2">Please add your card to make
                              the
                              payment
                              today</span>
                            <span *ngIf="planInfo.selected_payment_matrix.primary_type == 3">How would you like to make
                              today's
                              payment?</span>
                          </div>
                          <div class="col-12 col-sm-7 ps-0 text-end pt-2 pt-sm-0"
                            [ngClass]="{'col-lg-4':planInfo.selected_payment_matrix.primary_type != 3, 'col-lg-7':planInfo.selected_payment_matrix.primary_type == 3}">
                            <button
                              class="ms-3 ms-lg-1  mt-2 mt-lg-0 btn btn-primary  px-2 f-s-12 blink_me me-1"
                              (click)="openAddBankPopup()" style="background:#1581E5 !important"
                              *ngIf="patientData && (patientData.plaid_access_token == null || !patientData.plaid_access_token) && planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.primary_type == 1 || planInfo.selected_payment_matrix.primary_type == 3)">
                              Add Bank Account
                              <img src="assets/svg/offer.svg" width="20px"
                                *ngIf="planInfo.enrollment_waiver == 1 && planInfo.selected_payment_matrix.primary_type == 3 && planInfo.enrollment_enabled == 0">
                            </button>
                            <button class="ms-3 ms-lg-1 mt-2 mt-lg-0 btn btn-primary  px-2 f-s-12"
                              (click)="addNewCardModal.show()" [ngClass]="{'card_blink_me': primary_card_added == 0}"
                              *ngIf="planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.primary_type == 2 || planInfo.selected_payment_matrix.primary_type == 3)">
                              Add Card
                            </button>
                          </div>
                        </div>
                        <div class="vertical-center">
                          <div
                            *ngIf="!(patientData && patientData.primary_sources && patientData.primary_sources.length > 0)"
                            class="text-muted">
                            No payment method added
                          </div>
                          <div
                            *ngIf="patientData && patientData.primary_sources && patientData.primary_sources.length > 0"
                            class="card-partition mt-3">
                            <div class="card-block" *ngFor="let source of patientData.primary_sources">
                              <label class="col-12 card-label"
                                [ngClass]="{'active-card': source.source_id == dp_source_id }"
                                [ngClass]="{'primary-card-label': !(source.payment_source_type == 1 && source.source_id > 0)}"
                                [ngStyle]="{'padding-bottom': !(source.payment_source_type == 1 && source.source_id > 0) ? '7px' : ''}">
                                <div>
                                  <input type="radio" [value]="source.source_id" class="card-radio" name="dp_source_id"
                                    [(ngModel)]="dp_source_id"
                                    (change)="primaryCardChanged(source.payment_source_type,source.source_id)"
                                    [disabled]="source && source.bank_status && source.bank_status == 'reauthenticate'" />
                                  &nbsp;&nbsp;
                                  <i class="fa fa-credit-card lightGreyIcon"
                                    *ngIf="source.payment_source_type != 1"></i>
                                  <i class="fa fa-bank lightGreyIcon" *ngIf="source.payment_source_type == 1"></i>
                                  &nbsp;&nbsp;XXXX-XXXX-{{source.payment_source_type != 1 ? 'XXXX-' : ''}}{{source.last4}}
                                  <span *ngIf="source.source_id == -1" class="pull-right text-danger me-2">Verification
                                    Pending</span>
                                  <span *ngIf="source && source.bank_status && source.bank_status == 'reauthenticate' "
                                    class="pull-right text-danger me-2">
                                    <a (click)="reAuthenticatePlaid()">Reauthentication Required</a>
                                  </span>
                                </div>
                                <div class="offer-strip"
                                  *ngIf="planInfo.enrollment_waiver == 1 && planInfo.selected_payment_matrix.primary_type == 3 && planInfo.enrollment_enabled == 0 && source.payment_source_type == 1 && source.source_id > 0">
                                  Offer available: Get ${{enrollment_fee}} off on your contract enrollment fee!
                                </div>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="mt-3 ms-3 text-colr"
                        *ngIf="planInfo.selected_payment_matrix.primary_type == 1 || planInfo.selected_payment_matrix.primary_type == 3">
                        Note: <br>
                        In case of payment failure from your bank, we will attempt to charge your backup payment method to
                        successfully create your contract.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="payment-steps" *ngIf="payment_step == 2">
                <h3 class="step-header-text text-bold text-muted d-none d-sm-block">Your Recurring Payments</h3>
                <div class="col-12 step-heading d-none d-sm-block">
                  <div class="row">
                    <div class="col-md-6 col-12" *ngIf="planInfo">
                      <span class="font-weight-bold h5">${{planInfo.financed_amount | DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                      at
                      <span class="font-weight-bold h5">{{planInfo.interest_rate_to_show ? (planInfo.interest_rate_to_show
                        + '%') :
                        planInfo.interest_rate ? (planInfo.interest_rate + '%') : ''}}
                        <sup>{{!planInfo.interest_rate_to_show || (planInfo.interest_rate ==
                          planInfo.interest_rate_to_show) ? 'C' :
                          'F'}}</sup>
                      </span>
                      promotional interest rate
                    </div>
                    <div class="col-md-6 col-12 hide-mob">
                      <span class="font-weight-bold h5 me-1"> {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                        planInfo.selected_plan.recurring_amount
                        ?(planInfo.selected_plan.recurring_amount + mainService.getCalculatedTransactionFee(planInfo,
                        planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</span>
                      <i class="fa fa-info-circle" [tooltip]="'Your recurring amount includes a transaction fee'"></i>
                      Recurring payment amount for the next
                      <span class="font-weight-bold h5"
                        *ngIf="planInfo && planInfo.selected_plan && !((planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan.advance_interest_amount)">
                        {{planInfo && planInfo.selected_plan &&
                        planInfo.selected_plan.month?(planInfo.selected_plan.month): '0'}}
                      </span>
                      <span class="font-weight-bold h5"
                        *ngIf="planInfo && (planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount">
                        {{planInfo && planInfo.selected_plan && planInfo.selected_plan.month?(planInfo.selected_plan.month
                        - 1): '0'}}
                      </span>
                      months
                    </div>
  
                  </div>
                </div>
                <div class="step-body">
  
                  <div class="row">
                    <div class="col-md-6 col-lg-5 col-12">
                      <div class="payment-breakdown" style="background: #f8f8f8;">
                        <h4 class="text-start recurring-title">
                          <span class="text-bold f-s-18">Recurring Payment</span>
                          <span class="float-end font-weight-bold h5">
                            {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                            planInfo.selected_plan.recurring_amount
                            ?(planInfo.selected_plan.recurring_amount + mainService.getCalculatedTransactionFee(planInfo,
                            planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
                          </span>
                        </h4>
                        <ul type="circle" class="ps-4 list-clear">
                          <li>
                            <span class="text-muted">Recurring Amount</span>
                            <span class="float-end font-weight-bold f-s-14 text-colr">
                              {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                              planInfo.selected_plan.recurring_amount?((planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code):
                              '$0.00'}}
                            </span>
                          </li>
                          <li>
                            <span class="text-muted">Transaction Fee</span>
                            <span class="float-end font-weight-bold f-s-14 text-colr position-relative"> 
                              <span class="strike_through_class" *ngIf="mainService.promotionalTransactionOffer" [innerText]="mainService.calculateTransactionFeeStrike(planInfo.selected_plan.recurring_amount,planInfo.threshold_amount)"></span>
                              <div [ngClass]="mainService.promotionalTransactionOffer ? 'transaction-fee' : ''" class="d-inline-block ms-2">
                                
                                <span>
                                  {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                                    planInfo.selected_plan.recurring_amount ?
                                    (mainService.getCalculatedTransactionFee(planInfo,planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
                                </span>
                              </div>  
                              
                                
                                  <div *ngIf="mainService.promotionalTransactionOffer"  class="transaction-fee-popup pop-up-right">Promo</div>
                            </span>
                          </li>
                          <li>
                            <span class="text-muted">Total Recurring Amount</span>
                            <span class="float-end font-weight-bold f-s-14 text-colr">
                              {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                              planInfo.selected_plan.recurring_amount 
                              ?(planInfo.selected_plan.recurring_amount +
                              mainService.getCalculatedTransactionFee(planInfo,
                              planInfo.selected_plan.recurring_amount) |
                              DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
                            </span>
                          </li>
                          <li *ngIf="planInfo.disable_recurring == 1">
                            <span class="text-muted">Starting Date</span>
                            <span class="float-end font-weight-bold f-s-14 text-colr">
                              {{paymentDetails.recurringDate | date: 'MM-dd-yyyy'}}
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div class="row mt-4 vertical-center" *ngIf="planInfo.disable_recurring == 0">
                        <div class="col-xl-6 col-md-12 col-sm-12">
                          Choose Starting date
                        </div>
                        <div class="col-xl-6 col-md-12 col-sm-12">
                          <div class="input-group">
                            <input type="text" required #dob="ngModel" name="recurringDate" readonly
                              class="form-control date-picker" placeholder="Select Date" [bsConfig]="bsConfig"
                              [(ngModel)]="paymentDetails.recurringDate" #recurringDp="bsDatepicker" bsDatepicker
                              [maxDate]="planInfo.max_date" [minDate]="planInfo.min_date" style="border-color: #017A9F;">
                            <div class="input-group-append" tappable (click)="recurringDp.toggle()">
                              <span class="input-group-text" style="border-color: #017A9F;background-color: #ffffff;">
                                <i class="fa fa-calendar" style="color: #017A9F !important;"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-7 col-12 mt-5 mt-md-0">
                      <div class="primary-card-section" style="background: #f8f8f8;">
                        <div class="row show-mob-only">
                          <div class="col-md-6 col-12">
                            <span class="font-weight-bold h5 me-1"> {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                              planInfo.selected_plan.recurring_amount 
                              ?(planInfo.selected_plan.recurring_amount +
                              mainService.getCalculatedTransactionFee(planInfo,
                              planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</span>
                            <i class="fa fa-info-circle" [tooltip]="'Your recurring amount includes a transaction fee'"></i>
                            Recurring payment amount for the next
                            <span class="font-weight-bold h5"
                              *ngIf="planInfo && planInfo.selected_plan && !((planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan.advance_interest_amount)">
                              {{planInfo && planInfo.selected_plan &&
                              planInfo.selected_plan.month?(planInfo.selected_plan.month):
                              '0'}}
                            </span>
                            <span class="font-weight-bold h5"
                              *ngIf="planInfo && (planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount">
                              {{planInfo && planInfo.selected_plan &&
                              planInfo.selected_plan.month?(planInfo.selected_plan.month - 1):
                              '0'}}
                            </span>
                            months
                          </div>
                        </div>
                        <div class="row mt-3 mt-md-0">
                          <div class="pe-0 f-s-13"
                            [ngClass]="{'col-lg-8':planInfo.selected_payment_matrix.recurring_type != 3, 'col-lg-5':planInfo.selected_payment_matrix.recurring_type == 3}">
                            <span *ngIf="planInfo.selected_payment_matrix.recurring_type == 1">Please add your bank for
                              the
                              recurring
                              payments</span>
                            <span *ngIf="planInfo.selected_payment_matrix.recurring_type == 2">Please add your card for
                              the
                              recurring
                              payments</span>
                            <span *ngIf="planInfo.selected_payment_matrix.recurring_type == 3">How would you like to pay
                              for
                              your
                              recurring payments?</span>
                          </div>
                          <div class="ps-0 text-end pt-2 pt-sm-0"
                            [ngClass]="{'col-lg-4':planInfo.selected_payment_matrix.recurring_type != 3, 'col-lg-7':planInfo.selected_payment_matrix.recurring_type == 3}">
                            <button
                              class="ms-3 ms-lg-1  mt-2 mt-lg-0 btn btn-primary  px-2 f-s-12 blink_me me-1"
                              (click)="openAddBankPopup()" style="background:#1581E5 !important"
                              *ngIf="patientData && (patientData.plaid_access_token == null || !patientData.plaid_access_token) && planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.recurring_type == 1 || planInfo.selected_payment_matrix.recurring_type == 3)">
                              Add Bank Account
                            </button>
                            <button class="ms-3 ms-lg-1 mt-2 mt-lg-0 btn btn-primary  px-2 f-s-12"
                              (click)="addNewCardModal.show()" [ngClass]="{'card_blink_me': recurring_card_added == 0}"
                              *ngIf="planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.recurring_type == 2 || planInfo.selected_payment_matrix.recurring_type == 3)">
                              Add Card
                            </button>
                          </div>
                        </div>
                        <div class="vertical-center">
                          <div
                            *ngIf="!(patientData && patientData.recurring_sources && patientData.recurring_sources.length > 0)"
                            class="text-muted">
                            No payment method added
                          </div>
                          <div
                            *ngIf="patientData && patientData.recurring_sources && patientData.recurring_sources.length > 0"
                            class="card-partition mt-3">
                            <div class="card-block" *ngFor="let source of patientData.recurring_sources">
                              <label class="col-12 card-label"
                                [ngClass]="{'active-card': source.source_id == recurring_source_id}">
                                <input type="radio" [value]="source.source_id" class="card-radio"
                                  name="recurring_source_id" [(ngModel)]="recurring_source_id"
                                  [disabled]="source && source.bank_status && source.bank_status == 'reauthenticate'" />
                                &nbsp;&nbsp;
                                <i class="fa fa-credit-card lightGreyIcon"
                                  *ngIf="source.payment_source_type != 1"></i>
                                <i class="fa fa-bank lightGreyIcon" *ngIf="source.payment_source_type == 1"></i>
                                &nbsp;&nbsp;XXXX-XXXX-{{source.payment_source_type != 1 ? 'XXXX-' : ''}}{{source.last4}}
                                <span *ngIf="source.source_id == -1" class="pull-right text-danger me-2">Verification
                                  Pending</span>
                                <span *ngIf="source && source.source_id && source.bank_status == 'reauthenticate' "
                                  class="pull-right text-danger me-2">
                                  <a (click)="reAuthenticatePlaid()">Reauthentication Required</a>
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="mt-3 ms-3">
                        <b>Note:</b> <br>
                        If the selected payment method fails, we will attempt to charge your backup card.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="payment-steps" *ngIf="payment_step == 3">
                <h3 class="step-header-text text-bold text-muted d-none d-sm-block"></h3>
                <div class="col-12 step-heading d-none d-sm-block">
                  <div class="row">
                    <div class="col-md-6 col-12" *ngIf="planInfo">
                      <span class="font-weight-bold h5">${{planInfo.financed_amount | DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                      at
                      <span class="font-weight-bold h5">{{planInfo.interest_rate_to_show ? (planInfo.interest_rate_to_show
                        + '%') :
                        planInfo.interest_rate ? (planInfo.interest_rate + '%') : ''}}
                        <sup>{{!planInfo.interest_rate_to_show || (planInfo.interest_rate ==
                          planInfo.interest_rate_to_show) ? 'C' :
                          'F'}}</sup>
                      </span>
                      promotional interest rate
                    </div>
                    <div class="col-md-6 col-12 hide-mob">
                      <span class="font-weight-bold h5 me-1"> {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                        planInfo.selected_plan.recurring_amount 
                        ?(planInfo.selected_plan.recurring_amount + mainService.getCalculatedTransactionFee(planInfo,
                        planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}</span>
                      <i class="fa fa-info-circle" [tooltip]="'Your recurring amount includes a transaction fee'"></i>
                      Recurring payment amount for the next
                      <span class="font-weight-bold h5"
                        *ngIf="planInfo && planInfo.selected_plan && !((planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan.advance_interest_amount)">
                        {{planInfo && planInfo.selected_plan &&
                        planInfo.selected_plan.month?(planInfo.selected_plan.month): '0'}}
                      </span>
                      <span class="font-weight-bold h5"
                        *ngIf="planInfo && (planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount">
                        {{planInfo && planInfo.selected_plan && planInfo.selected_plan.month?(planInfo.selected_plan.month
                        - 1): '0'}}
                      </span>
                      months
                    </div>
  
                  </div>
                </div>
                <div class="step-body">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <div class="text-start">
                        <h5 class="col-12 f-s-16-w-400 mt-sm-4 mt-md-0 p-0">
                          Set up an alternative payment method that can be used if your primary method fails for any
                          reason.
                          <i class="fa fa-info-circle text-colr" (click)="backupNotesModal.show()"></i>
                        </h5>
                      </div>
                    </div>
                    <div class="col-md-6 col-12 mt-sm-5 mt-md-0">
                      <div class="primary-card-section step-3" style="background: #f8f8f8;">
                        <div class="row">
                          <div class="pe-0 f-s-13 col-xl-6">
                            <span>Add a Backup Payment Method</span>
                          </div>
                          <div class="ps-0 text-end pt-2 pt-sm-0 col-xl-6">
                            <button
                              class="ms-3 ms-xl-1 mt-2 mt-xl-0 btn btn-primary  px-2 f-s-12 blink_me me-1"
                              (click)="openAddBankPopup()"
                              *ngIf="patientData && (patientData.plaid_access_token == null || !patientData.plaid_access_token) && planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.backup_type == 1 || planInfo.selected_payment_matrix.backup_type == 3)">
                              Add Bank Account
                            </button>
                            <button class="ms-3 ms-xl-1 mt-2 mt-xl-0 btn btn-primary  px-2 f-s-12"
                              (click)="addNewCardModal.show()" style="color: #000000;"
                              *ngIf="planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.backup_type == 2 || planInfo.selected_payment_matrix.backup_type == 3)">
                              Add Card
                            </button>
                          </div>
                        </div>
                        <div class="vertical-center">
                          <div
                            *ngIf="!(patientData && patientData.backup_sources && patientData.backup_sources.length > 0)"
                            class="text-muted ms-0 mt-3">
                            No payment method added
                          </div>
                          <div *ngIf="patientData && patientData.backup_sources && patientData.backup_sources.length > 0"
                            class="card-partition mt-3">
                            <div class="card-block" *ngFor="let source of patientData.backup_sources">
                              <label class="col-12 card-label px-0" *ngIf="source.source_id != recurring_source_id"
                                [ngClass]="{'active-card': source.source_id == backup_source_id}">
                                <input type="radio" [value]="source.source_id" class="card-radio" name="backup_source_id"
                                  [(ngModel)]="backup_source_id"
                                  [disabled]="source && source.bank_status && source.bank_status == 'reauthenticate'" />
                                &nbsp;&nbsp;
                                <i class="fa fa-credit-card lightGreyIcon"
                                  *ngIf="source.payment_source_type != 1"></i>
                                <i class="fa fa-bank lightGreyIcon" *ngIf="source.payment_source_type == 1"></i>
                                &nbsp;&nbsp;XXXX-XXXX-{{source.payment_source_type != 1 ? 'XXXX-' : ''}}{{source.last4}}
                                <span *ngIf="source.source_id == -1" class="pull-right text-danger me-2">Verification
                                  Pending</span>
                                <span *ngIf="source && source.bank_status && source.bank_status == 'reauthenticate' "
                                  class="pull-right text-danger me-2">
                                  <a (click)="reAuthenticatePlaid()">Reauthentication Required</a>
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="payment-steps" [hidden]="payment_step != 4">
                <div class="row">
                  <div class="col-12 col-md-8 offset-md-2">
                    <div class="payment-breakdown">
                      <h4 class="text-start contract-info recurring-title p-3">
                        <span class="text-bold">Payment Details & Your Signature</span>
                      </h4>
                      <div class="summary-heading">
                        <span>
                          Please review your payment details for a contract of <span
                            class="text-bold">${{planInfo.treatment_amount | DynamicDecimalPipe:mainService.currency_data.currency_code}}</span> for
                          <span class="text-bold"
                            *ngIf="planInfo && planInfo.selected_plan && !((planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan.advance_interest_amount)">
                            {{planInfo && planInfo.selected_plan &&
                            planInfo.selected_plan.month?(planInfo.selected_plan.month): '0'}}
                          </span>
                          <span class="text-bold"
                            *ngIf="planInfo && (planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount">
                            {{planInfo && planInfo.selected_plan &&
                            planInfo.selected_plan.month?(planInfo.selected_plan.month - 1):
                            '0'}}
                          </span>
                          months.
                        </span>
                      </div>
                      <div style="margin: 0 10px;">
                        <div class="row mb-2" *ngIf="selected_dp_card">
                          <div class="col-1">
                            <i class="fa fa-check-circle"></i>
                          </div>
                          <div class="col-7 col-sm-7">
                            <span class="text-bold">Payment Today</span>
                            <br>
                            <div class="same-line">
                              (<i class="fa fa-credit-card lightGreyIcon"
                                *ngIf="selected_dp_card.payment_source_type != 1"></i>
                              <i class="fa fa-bank lightGreyIcon"
                                *ngIf="selected_dp_card.payment_source_type == 1"></i>
                              {{selected_dp_card.last4}}
                              <span *ngIf="selected_dp_card.payment_source_type == 1 && dp_source_id == -1">-Verification
                                Pending</span>)
                            </div>
                          </div>
                          <div class="col-3 col-sm-3 p-0 text-end text-bold text-colr"
                            style="margin-left: -5px;white-space: nowrap;">
                            ${{planInfo.plans_array[0].to_pay_today}}
                          </div>
                        </div>
                        <hr *ngIf="selected_recurring_card">
                        <div class="row mb-2" *ngIf="selected_recurring_card">
                          <div class="col-1">
                            <i class="fa fa-check-circle"></i>
                          </div>
                          <div class="col-7 col-sm-7">
                            <span class="text-bold">Recurring Payment Starting on
                              <span style="white-space: nowrap;">{{paymentDetails.recurringDate | date:
                                'MM-dd-yyyy'}}</span>
                            </span>
                            <br>
                            <div class="same-line">
                              (<i class="fa fa-credit-card lightGreyIcon"
                                *ngIf="selected_recurring_card.payment_source_type != 1"></i>
                              <i class="fa fa-bank lightGreyIcon"
                                *ngIf="selected_recurring_card.payment_source_type == 1"></i>
                              {{selected_recurring_card.last4}}
                              <span
                                *ngIf="selected_recurring_card.payment_source_type == 1 && recurring_source_id == -1">-Verification
                                Pending</span>)
                            </div>
                          </div>
                          <div class="col-3 col-sm-3 p-0 text-end text-bold text-colr"
                            style="margin-left: -5px;white-space: nowrap;">
                            {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                            planInfo.selected_plan.recurring_amount 
                            ?(planInfo.selected_plan.recurring_amount + mainService.getCalculatedTransactionFee(planInfo,
                            planInfo.selected_plan.recurring_amount) |DynamicDecimalPipe:mainService.currency_data.currency_code): '$0.00'}}
                          </div>
                        </div>
                        <hr *ngIf="selected_backup_card">
                        <div class="row mb-2" *ngIf="selected_backup_card">
                          <div class="col-1">
                            <i class="fa fa-check-circle"></i>
                          </div>
                          <div class="col-8 col-sm-8">
                            <span class="text-bold">Backup Payment Source</span>
                            <br>
                            <div class="same-line">
                              (<i class="fa fa-credit-card lightGreyIcon"
                                *ngIf="selected_backup_card.payment_source_type != 1"></i>
                              <i class="fa fa-bank lightGreyIcon"
                                *ngIf="selected_backup_card.payment_source_type == 1"></i>
                              {{selected_backup_card.last4}}
                              <span
                                *ngIf="selected_backup_card.payment_source_type == 1 && backup_source_id == -1">-Verification
                                Pending</span>)
                            </div>
                          </div>
                          <div class="col-2 col-sm-2 p-0 text-end text-bold">
                            -
                          </div>
                        </div>
                      </div>
                      <div class="p-15 form-group mb-5 row m-0 mt-4">
                        <h4>Your Signature:</h4>
                        <div class="overflow-hidden">
                          <div class="p-0 col-12" #canvasDiv1 id="canvasDiv1" style="position: relative"
                            style="border: solid 1px #dce5eb;height: 200px;border-radius: 10px;" *ngIf="!is_mobile_screen">
                            <signature-pad style="display:table" [options]="signaturePadOptions" (onEndEvent)="drawComplete()">
                            </signature-pad>
                            <span class="eraser" (click)="clearSign()" placement="right" tooltip='Clear'>
                              <i class="fa fa-eraser"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="mt-1 mb-3">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" name="terms" [(ngModel)]="terms" id="terms">
                          <label class="custom-control-label" for="terms">
                            I’ve read & agreed to the <a style="color: #017A9F !important;" target="_blank" [routerLink]="['/tila']">TILA
                              Disclosure</a>,
                            <a style="color: #017A9F !important;" target="_blank" [routerLink]="['/consentForm']">Payment Authorization
                              Agreement&nbsp;and&nbsp;HIPAA Disclosure</a>.
                          </label>
                        </div>
                        <div class="custom-control custom-checkbox"
                          *ngIf="split_request_data[0].buss_terms_link && split_request_data[0].show_buss_terms">
                          <input type="checkbox" class="custom-control-input" name="check_business_terms" [(ngModel)]="check_business_terms" id="check_business_terms">
                          <label class="custom-control-label" for="check_business_terms">
                            I hereby read & accept the terms and conditions of
                             <a href="javascript:void(0)" (click)="goToLink(split_request_data[0].buss_terms_link)"
                              *ngIf="split_request_data[0].buss_terms_link && split_request_data[0].show_buss_terms"
                              rel="noopener noreferrer">{{split_request_data[0].practice_name || (split_request_data[0].doctor_first_name + ' ' + split_request_data[0].doctor_last_name) || 'Business Terms'}}</a>.
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center my-4">
                <button class="btn btn-secondary  px-4 me-3" *ngIf="payment_step != 0" (click)="back()">
                  Back
                </button>
                <button class="ms-1 btn btn-primary  px-4" (click)="nextStep()"
                  [disabled]="(payment_step == 1 && !dp_source_id) || (payment_step == 2 && !recurring_source_id) || (payment_step == 3 && !backup_source_id && planInfo.selected_payment_matrix.backup_required == 1)"
                  *ngIf="payment_step == 0 || payment_step == 1 || payment_step == 2 || payment_step == 3 || payment_step == 4">
                  {{payment_step == 3 && planInfo.selected_payment_matrix.backup_required == 0 && !backup_source_id ?
                  'Skip' : (payment_step == 4 && !show_closure_form ? 'Confirm & Pay' : 'Next')}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 col-md-12" style="font-size: 12px;" *ngIf="payment_step != 4">
        <p class="m-0 px-2" style="margin-bottom: 25px !important;">F: Fixed Interest, C: Compound Interest</p>
      </div>
    </div> -->
  </div>
  <div class="scanner" *ngIf="(scanner_continue || manual_continue) && (opened_step == 3 || opened_step == 4)"
    [class.manual-continue]="manual_continue">
    <img src="assets/png/arrow-left.png" alt="" (click)="changeScreen()" *ngIf="opened_step == 4">
    <div>
      <p>{{opened_step == 3 ? "Recurring Details": opened_step == 4 ? "Make Payment" : ''}}</p>
    </div>
    <img (click)="redirectBack()" style="right: 20px;" src="assets/svg/close-circle.svg" alt="close-icon"
      class="close-icon-desktop">
  </div>
  <div class="bg_gray payment-fixed payment-details-block" *ngIf="opened_step != 0" (change)="detect($event)">
    <div class="panel-outer--mainwrapper" [ngClass]="{borderBottom: stepHeader}">
      <div class="sidebar_plan_details showing-plan"
        [ngClass]="{'showing-plan' : mainService.current_step > 1 , 'fivesteping' : opened_step == 5 } "
        *ngIf="(!scanner_continue || !manual_continue)" [class.manual]="manual_continue || scanner_continue">
        <app-steps (triggerChangeScreen)="changeScreen()"></app-steps>
        <!-- <div class="mt-auto">
        <div class="estimate-plan">
          <div class="estimate-plan-invoice m-0">
            <div class="author-name2">
              <p class="-rounded-pill eta_button m-0">
                Estimated Payment Plan
              </p>
              <p class="h1 fw-900" *ngIf="planInfo && planInfo.treatment_amount">
                <span translate="no">{{mainService.currency_data.display_logo}} {{planInfo && planInfo.treatment_amount ?
                  (planInfo.treatment_amount - planInfo.downpayment_amount|DynamicDecimalPipe:mainService.currency_data.currency_code) :'0.00'}}</span>
              </p>
            </div>
          </div>
          <div class="footer-part sidebar-footer">
            <div class="finance-rows " *ngIf="planInfo ">
              <span class="financing-labels font-weight-bold h5 finance-values card-body service-amount b-0">
                <div>{{((planInfo
                  &&
                  planInfo.enrollment_enabled
                  !=
                  1) && !planInfo.is_ar_contract) ? 'Enrollment Fee:' : planInfo && planInfo.is_ar_contract == 1 ?
                  'Account
                  Setup Fee:' : ''}}</div>
                <div class="f-s-18-w-800 finance-values position-relative">
                  <div class="d-flex align-items-baseline">
                    <div>
                      <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"><span
                          translate="no">{{mainService.currency_data.display_logo}}</span></span>
                      <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"><span
                          class="notranslate">{{mainService.strike_enrollment_fee}}</span></span>
                    </div>
                    <div [ngClass]="mainService.promotionalEnrollmentOffer ? 'transaction-fee' :'' "
                      class=" d-inline-block ms-2 fs-14 text-white"><span class="notranslate">
                        {{mainService.currency_data.display_logo}} {{(enrollment_fee || enrollment_fee == '0') ?
                        enrollment_fee: '30'}}</span>
                    </div>
                  </div>
                  <div *ngIf="mainService.promotionalEnrollmentOffer" class="transaction-fee-popup pop-up-right">
                    Promo
                  </div>
                </div>
              </span>
            </div>
  
            <div class="">
              <div class=" fs-14 rounded-bottom service-amount">
                <p class="color-gray p-0 m-0">Down payment:</p>
                <p class="color-dblue fw-700 p-0 m-0 ms-2"><span translate="no">{{mainService.currency_data.display_logo}}
                    {{(planInfo.downpayment_amount|DynamicDecimalPipe:mainService.currency_data.currency_code)}}</span></p>
              </div>
            </div>
  
            <div class=" " *ngIf="contract_service_record && contract_service_record.length > 0">
              <div class="rounded-top service-amount" [ngClass]="mainService.current_step >= 2 ? 'amo-serve' : ''">
                <p class="p-0 m-0"><span class="card-body p-0 m-0 me-1">Service amount:</span><span>
                    <button class="info_icon_btn service-amount-btn">
                      <img src="assets\png\Icons.png" alt="" class="info_icon">
                      <span class="tooltip_box  color-gray-1 show_div custom_tool_recurring d-none">
                        <div class="d-flex justify-content-between border-bottom p-2 align-items-center"
                          *ngFor="let service of contract_service_record">
                          <p class="color-gray p-0 m-0 fw-400 treatment_text">
                            {{service.service}}</p>
                          <p class="card-block p-0 m-0"><span translate="no">{{mainService.currency_data.display_logo}}
                              {{service
                              &&
                              service.price ?
                              (service.price|DynamicDecimalPipe:mainService.currency_data.currency_code) :'0.00'}}</span></p>
                        </div>
                      </span>
                    </button>
                  </span></p>
                <p class="color-dblue fw-700 p-0 m-0"><span translate="no">{{mainService.currency_data.display_logo}}
                    {{planInfo.treatment_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span></p>
              </div>
            </div>
  
          </div>
        </div>
  
      </div> -->
        <!-- <div class="mt-auto w-100 text-center footer_outside_in -footer_plans align-self-baseline">
        <footer class="footer text-center">
          <div class="text-big" style="text-align: start;">
            <span
              *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && mainService.contractSupport">
              <span class="m-0 f-s-16 small-mob color-gray">
                In case of any additional queries, please contact your service provider
                <b>{{planInfo && planInfo.practice_name ? planInfo.practice_name : planInfo.doctor_first_name+'
                  '+planInfo.doctor_last_name}}</b>
                <span *ngIf="(planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"> at </span>
                <a class="text-bold"
                  *ngIf="planInfo && (planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"
                  href="tel:{{planInfo && planInfo.practice_mobile ?planInfo.practice_mobile:planInfo.doctor_phone}}">
                  {{planInfo && planInfo.practice_mobile ?(planInfo.practice_mobile | phoneNumber) :
                  (planInfo.doctor_phone | phoneNumber) ? (planInfo.doctor_phone | phoneNumber) :
                  (planInfo.doctor_mobile | phoneNumber)}}
                </a>
              </span>
  
            </span>
            <span
              *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && !mainService.contractSupport">
              <span class="m-0 f-s-12 small-mob color-gray fw-700">
                Need Help? <br> <a class="text-bold" style="color: #fff; text-decoration: underline;"
                  href="https://www.credee.com/support" target="_blank">Click Here</a> to contact Credee
                Support
              </span>
            </span>
          </div>
        </footer>
  
        <div class="col-12 mt-2 Powered">
          <div class="w-100 text-center small-mob">
            <span class="fs-14 ">Powered By <span class="text-primary ms-1"><img
                  src="assets/svg/logo_colored.svg"></span></span>
          </div>
        </div>
      </div> -->
      </div>

      <div class="screen_manager" *ngIf="opened_step!=6">
        <!-- Back Button outside Initial -->
        <div class="progress-main--wrapper row">
          <!-- <span class="flex-grow-1">
          <span
            class="p-2 button_back_round d-flex align-items-center jusitfy-content-center bg-white border rounded-circle"
            role="button_close" *ngIf="opened_step != 0" (click)="changeScreen()">
            <img src="assets/svg/back_arrow.svg" alt="" />
          </span>
        </span>
        <span class="flex-grow-1 text-center">
          <ul class="list-unstyled form-wizard-steps clearfix mb-0">
            <li class="active"><span>1</span>Payment Plan</li>
            <li [ngClass]="{'active' : opened_step > 2}"><span>2</span>Personal Details</li>
            <li [ngClass]="{'active' : opened_step > 3}"><span>3</span>Recurring Details</li>
            <li><span>4</span>Make Payment</li>
          </ul>
        </span>
        <span class="flex-grow-1 text-end">
          <app-steps closeOnly="true" api="true"></app-steps>
        </span> -->
          <div class="make_sticky progress-main--wrapper__left col-md-3 d-none d-md-block"
            [ngClass]="{'bottom-stick' :mainService.current_step == 2 || mainService.current_step == 3 || mainService.current_step == 4 , 'fivesteps' : opened_step === 5}">
            <!-- <span class="flex-grow-1">
            
          </span> -->
            <span class="flex-grow-1 text-center" style="max-width: -webkit-fill-available;"
              *ngIf="mainService.current_step == 2 || mainService.current_step == 3 || mainService.current_step == 4">
              <ul class="list-unstyled form-wizard-steps clearfix mb-0 mx-auto">
                <li *ngIf="!routeStep" class="activeted"
                  [ngClass]="mainService.current_step == 1 ? 'active' :mainService.current_step == 2||3||4? 'completeData':''"
                  (click)="backToPayment()" [class.disabled]="mainService.current_step == 5  || opened_step == 5">
                  Payment Plan</li>
                <li *ngIf="!routeStep"
                  [ngClass]=" mainService.current_step == 2 ? 'active' :mainService.current_step == 3||4? 'completeData':''"
                  class="activeted" (click)="mainService.current_step = 2; opened_step = 2"
                  [class.disabled]="mainService.current_step == 5 || opened_step == 5">Personal Details</li>
                <li
                  [ngClass]=" mainService.current_step == 3 ? 'active' :mainService.current_step == 4? 'completeData':''"
                  class="activeted" (click)="mainService.current_step = 3; opened_step = 3"
                  [class.disabled]="mainService.current_step == 5 || opened_step == 5">Recurring Details</li>
                <li class="activeted" [ngClass]=" mainService.current_step == 4 ? 'active' : ''"
                  (click)="mainService.current_step = 3; opened_step = 3"
                  [class.disabled]="mainService.current_step == 5 || opened_step == 5 ">Make Payment</li>
              </ul>
            </span>
            <div class="button_back_inside position-absolute" *ngIf="mainService.current_step == 4 || !routeStep">
              <span [ngClass]="mainService.current_step == 5 ? 'fivesteps' : ''">
                <span class="left-back-btn" (click)="changeScreen()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M14 17L9.5 12.5L14 8" stroke="#646C70" stroke-width="1.8" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  Previous Step
                </span>
              </span>
            </div>
            <!-- <span class="flex-grow-1 text-end" [ngClass]="mainService.current_step > 1 ? 'steps-outside' : ''">
            <ng-container> <app-steps closeOnly="true" api="true"></app-steps></ng-container>
          </span> -->
          </div>
          <!-- Back Button Insied second -->
          <div class="progress-main--wrapper__right col-md-9" [ngClass]="opened_step == 5 ? 'step-five--enable' : '' ">
            <div class="container-fluid reduce_top_padding bg-white h-100">
              <ng-container>
                <!-- <div
                class="w-100 px-5 py-3 d-none justify-content-between align-items-center button_back_inside position-absolute">
                <span [ngClass]="opened_step == 5 ? 'fivesteps' : ''">
                  <span
                    class="p-2 d-flex align-items-center jusitfy-content-center bg-white border rounded-circle left-back-btn"
                    role="button_close" (click)="changeScreen()">
                    <img src="assets/svg/back_arrow.svg" alt="" />
                  </span>
                </span>
                <span>
                  <span class="fs-16 color-gray" *ngIf="mainService.current_step == 2">
                    Personal Details
                  </span>
                  <span class="fs-16 color-gray" *ngIf="mainService.current_step == 3">
                    Recurring Details
                  </span>
                  <span class="fs-16 color-gray" *ngIf="mainService.current_step == 4">
                    Make Payment
                  </span>
                </span>
                <span [ngClass]="mainService.current_step == 2 ? 'steps-outside' : ''">
                  <app-steps closeOnly="true" api="true"></app-steps>
                </span>
              </div> -->

              </ng-container>
              <div class="p-0 bg-white -box_personal_info pay-box-personal">
                <!-- Back Button Insied second -->
                <!-- <ng-container>
            <div class="w-100 px-5 py-3 d-none justify-content-between align-items-center button_back_inside">
              <span>
                <span class="p-2 d-flex align-items-center jusitfy-content-center bg-white border rounded-circle"
                  role="button_close" (click)="changeScreen()">
                  <img src="assets/svg/back_arrow.svg" alt="" />
                </span>
              </span>
              <span>
                <span class="fs-16 color-gray" *ngIf="opened_step == 2">
                  Personal Details
                </span>
                <span class="fs-16 color-gray" *ngIf="opened_step == 3">
                  Recurring Details
                </span>
                <span class="fs-16 color-gray" *ngIf="opened_step == 4">
                  Make Payment
                </span>
              </span>
              <span>
                <app-steps closeOnly="true" api="true"></app-steps>
              </span>
            </div>
          </ng-container> -->


                <div class="" [ngClass]="{'deff h-100 align-items-center justify-content-center': (opened_step == 5)}">
                  <!-- *ngIf="getNumber(mod_step) == 2" -->
                  <ng-container *ngIf="opened_step == 2">
                    <div class="input_containers_head fw-700 fs-16 mb-0 color-gray px-4 d-md-none">
                      <div class="button_back_inside">
                        <span>
                          <span *ngIf="!routeStep" class="left-back-btn" (click)="changeScreen()">
                            <!-- <img src="assets/png/arrow-left.png" alt=""> -->
                            <!-- Previous Step -->
                          </span>
                        </span>
                      </div>
                      <span class="data_personal">Personal details</span>
                    </div>
                    <div class="form-inside px-xl-4 px-2">
                      <form class="row -form-inside fex-grow-1" (submit)="addAddressFn(patient_address)"
                        [ngClass]="opened_step == 2 ? 'doc-id' : ''" autocomplete="off">
                        <!-- First Name -->
                        <ng-container [formGroup]="patient_address">
                          <div class="input_container col-md-6">
                            <div class="flex-grow-1">
                              <!-- inputContainer -->
                              <div class="custom-form-v5 flex-grow-1">
                                <input type="text" class="input_field px-3 pt-3" formControlName="patient_first_name"
                                  name="patient_first_name" required maxlength="100" [ngClass]="{
                                'black-border': patient_address.value.patient_first_name,
                                'normal-border': !patient_address.value.patient_first_name,
                                'has-error': (!patient_address.value.patient_first_name || this.patient_address.value.patient_first_name.trim().length == 0) && showError
                            }" autocomplete="off" />
                                <label for="text" class="label-name">
                                  <span class="content-name_1 f-c-p-3">
                                    First Name
                                  </span>
                                </label>
                              </div>
                            </div>
                            <p class="mat-error"
                              *ngIf="(!patient_address.value.patient_first_name || this.patient_address.value.patient_first_name.trim().length == 0) && showError">
                              Please enter First Name</p>
                          </div>
                          <!-- last Name -->
                          <div class="input_container col-md-6 mt-4 mt-md-0">
                            <div class="flex-grow-1">
                              <div class="custom-form-v5 flex-grow-1">
                                <input type="text" class="input_field px-3 pt-3" formControlName="patient_last_name"
                                  name="patient_last_name" required maxlength="100" [ngClass]="{
                                'black-border': patient_address.value.patient_last_name,
                                'normal-border': !patient_address.value.patient_last_name,
                                'has-error':(!patient_address.value.patient_last_name || this.patient_address.value.patient_last_name.trim().length == 0) && showError
                            }" autocomplete="off" />
                                <label for="text" class="label-name">
                                  <span class="content-name_1 f-c-p-3">
                                    Last Name
                                  </span>
                                </label>
                              </div>
                            </div>
                            <p class="mat-error"
                              *ngIf="(!patient_address.value.patient_last_name || this.patient_address.value.patient_last_name.trim().length == 0) && showError">
                              Please enter Last Name</p>
                          </div>
                          <!-- Email Address -->
                          <div class="input_container col-md-12 mt-4">
                            <div class="flex-grow-1">
                              <div class="custom-form-v5 flex-grow-1">
                                <input type="text" class="input_field px-3 pt-3" formControlName="patient_email"
                                  name="patient_email" required maxlength="100"
                                  [ngClass]="{'black-border': patient_address.value.patient_email}"
                                  autocomplete="off" />
                                <label for="text" class="label-name">
                                  <span class="content-name_1 f-c-p-3">
                                    Email Address
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <!-- language -->
                          <div class="input_container col-md-12 mt-4">
                            <div class="flex-grow-1">
                              <div class="custom-form-v5 flex-grow-1">
                                <select class="input_field col-12 language-chnge" formControlName="language_preffered"
                                  [ngClass]="{
                                'black-border': patient_address.value.language_preffered,
                                'normal-border': !patient_address.value.language_preffered
                            }">
                                  <option *ngFor="let lang of language_data; let i=index" [value]="lang.lan_code">
                                    {{lang.lan_name}}</option>
                                </select>
                                <label for="text" class="label-name">
                                  <span class="content-name f-c-p-3"
                                    style="font-size: 12px; bottom: 7px; top: 8px;left: 16px;">
                                    Select Preferred Communication Language (Email/SMS)
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>

                          <!-- Phone Number  -->
                          <div class="input_container col-md-12 mt-4">
                            <div class="flex-grow-1">
                              <div class="custom-form-v5 flex-grow-1" [ngClass]="{
                            'black-border': patient_address.value.patient_mobile,
                            'normal-border': !patient_address.value.patient_mobile,
                            'has-error': (!patient_address.value.patient_mobile || patient_address.value.patient_mobile.length == 0 || showMobError) && showError
                        }">
                                <!-- <span
                            *ngIf="patient_address.controls && patient_address.controls.patient_mobile && patient_address.controls.patient_mobile &&  (patient_address.controls.patient_mobile.value !== null && patient_address.controls.patient_mobile.value !== '')"
                            class="fs-17 fw-800" style="position: absolute;left: 14px;bottom: 11px;">+1
                          </span> -->
                                <mat-select id="img_logo_emp"
                                  class="flag_dropdown input_field font-weight-bold m-h-52 h-100 w-100"
                                  formControlName="patient_mobile_country_code">
                                  <mat-select-trigger>
                                    <!-- <img style="width: 2.5rem;" src="assets/svg/country_flag/{{flag_code}}_flag.svg" > -->
                                    <span> {{this.patient_address.controls.patient_mobile_country_code.value}} </span>
                                  </mat-select-trigger>
                                  <mat-option *ngFor="let option of mainService.mobile_code_arr;let i=index"
                                    [value]="option">
                                    <!-- <img style="width: 1.33333333em;" src="assets/svg/country_flag/{{option.country_code | lowercase}}_flag.svg" > -->
                                    <span class="ps-2" style="color: #8c8989;">{{option}}</span>
                                  </mat-option>
                                </mat-select>
                                <input type="text" class="input_field pe-3 pt-3 mobile-field-patient"
                                  [ngStyle]="{'padding-left':'1rem'}" formControlName="patient_mobile"
                                  name="patient_mobile" required [maxlength]="phone_length" [minlength]="min_phone_length" autocomplete="off"
                                  (input)="checkMobVal()" [mask]="mask" />
                                <label for="text" class="label-name">
                                  <span style="left: 75px" class="content-name_1 f-c-p-3">
                                    Phone Number
                                  </span>
                                </label>
                              </div>

                            </div>
                            <p class="mat-error"
                              *ngIf="(!patient_address.value.patient_mobile || patient_address.value.patient_mobile.length == 0 || showMobError) && showError">
                              Please enter {{patient_address.value.patient_mobile ? 'valid' : ''}} Phone Number</p>

                          </div>
                          <!-- Address -->
                          <div class="col-12 col-sm-12 col-md-12 mt-4 google-api" [ngClass]="{
                            'google-black': patient_address.value.address,
                            'after-field': !patient_address.value.address,
                            'google-has-error': (!patient_address.value.address || patient_address.value.address.trim().length == 0) && showError
                        }">

                            <app-google-api (setAddress)="selectZip($event,1)" [t]="1"
                              [customClass]="['custom-form-v5']" [isRequired]="true" id="zipPostalCode"
                              name="zipPostalCode" [model]="patient_address.value.address" ngDefaultControl
                              [defaultzip]="zipCode" autocomplete="off">
                            </app-google-api>
                            <p class="mat-error"
                              *ngIf="(!patient_address.value.address || patient_address.value.address.trim().length == 0) && showError">
                              Please enter a address</p>

                          </div>

                          <div class="input_container col-md-12 mt-4">
                            <div class="flex-grow-1">
                              <div class="custom-form-v5 flex-grow-1">
                                <input type="text" class="input_field px-3 pt-3" formControlName="address_2"
                                  name="address_2" maxlength="100"
                                  [ngClass]="{'black-border': patient_address.value.address_2}" autocomplete="off" />
                                <label for="text" class="label-name">
                                  <span class="content-name_1 f-c-p-3">
                                    Address Line 2 (Optional)
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>

                        </ng-container>

                        <!-- other Part -->
                        <ng-container [formGroup]="patient_address">
                          <!-- ZIP -->
                          <div class="input_container col-md-12 mt-4">
                            <div class="flex-grow-1">
                              <div class="custom-form-v5 flex-grow-1">
                                <input type="text" class="input_field px-3 pt-3" formControlName="zip" name="address"
                                  required maxlength="100" [ngClass]="{
                                'black-border': patient_address.value.zip,
                                'normal-border': !patient_address.value.zip,
                                'has-error': (!patient_address.value.zip || patient_address.value.zip.length == 0) && showError
                            }" autocomplete="off" disabled />
                                <label for="text" class="label-name">
                                  <span class="content-name_1 f-c-p-3">
                                    Zip/Postal Code
                                  </span>
                                </label>
                              </div>

                            </div>
                            <p class="mat-error"
                              *ngIf="(!patient_address.value.zip || patient_address.value.zip.length == 0) && showError">
                              Please enter zip/postal code</p>
                          </div>
                          <!-- State -->
                          <div class="input_container col-md-6 mt-4">
                            <div class="flex-grow-1">
                              <div class="custom-form-v5 flex-grow-1">
                                <input type="text" class="input_field px-3 pt-3" formControlName="state_name"
                                  name="state_name" required maxlength="100" disabled [ngClass]="{
                                'black-border': patient_address.value.state_name,
                                'normal-border': !patient_address.value.state_name,
                                'has-error': (!patient_address.value.state_name || patient_address.value.state_name.trim().length == 0) && showError
                            }" autocomplete="off" />
                                <label for="text" class=""
                                  [ngClass]="(!patient_address.controls.state_name.value && (patient_address.value.zipSelected)) ? '' : 'label-name'">
                                  <span class="content-name_1 f-c-p-3">
                                    State
                                  </span>
                                </label>
                              </div>
                              <p class="mat-error"
                                *ngIf="(!patient_address.value.state_name || patient_address.value.state_name.trim().length == 0) && showError">
                                Please enter state</p>

                            </div>
                          </div>
                          <!-- City -->
                          <div class="input_container input_container1 col-md-6 mt-4">
                            <div class="flex-grow-1">
                              <div class="custom-form-v5 flex-grow-1">
                                <input type="text" class="input_field px-3 pt-3" formControlName="city" name="city"
                                  required maxlength="100" disabled [ngClass]="{
                                'black-border': patient_address.value.city,
                                'normal-border': !patient_address.value.city,
                                'has-error': (!patient_address.value.city || patient_address.value.city.trim().length == 0) && showError
                            }" autocomplete="off" />
                                <label for="text" class=""
                                  [ngClass]="(!patient_address.controls.city.value && (patient_address.value.zipSelected)) ? '' : 'label-name'">
                                  <span class="content-name_1 f-c-p-3">
                                    City
                                  </span>
                                </label>
                              </div>
                            </div>
                            <p class="mat-error"
                              *ngIf="(!patient_address.value.city || patient_address.value.city.trim().length == 0) && showError">
                              Please enter city</p>

                          </div>
                          <!-- SSN -->
                          <div class="input_container col-md-12 mt-4" *ngIf="showSSNfields">
                            <div class="flex-grow-1">
                              <div class="custom-form-v5 flex-grow-1">

                                <!-- <input *ngIf="patientSsn != '' " type="text" class="input_field px-3 pt-3"
                                  formControlName="patient_ssn" name="patient_ssn"
                                  onKeyPress="if(this.value.length==9) return false;" minlength="9" required
                                  autocomplete="off" />

                                <input *ngIf="mainService.document_label == 'SSN/EIN' && patientSsn == '' "
                                  type="number" class="input_field px-3 pt-3" formControlName="patient_ssn"
                                  name="patient_ssn" onKeyPress="if(this.value.length==9) return false;" required
                                  [ngClass]="{
                                'black-border': patient_address.value.patient_ssn,
                                'normal-border': !patient_address.value.patient_ssn,
                                'has-error': patient_address.controls.patient_ssn.touched && patient_address.controls.patient_ssn.invalid
                            }" autocomplete="off"
                                  oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1')" />
                                <input *ngIf="mainService.document_label != 'SSN/EIN' && patientSsn == '' " type="text"
                                  class="input_field px-3 pt-3" formControlName="patient_ssn" name="patient_ssn"
                                  required [ngClass]="{
                                'black-border': patient_address.value.patient_ssn,
                                'normal-border': !patient_address.value.patient_ssn,
                                'has-error': patient_address.controls.patient_ssn.touched && patient_address.controls.patient_ssn.invalid
                            }" autocomplete="off" />
                                <label for="text" class="label-name">
                                  <span class="content-name_1 f-c-p-3">
                                    
                                    {{mainService.document_label}}
                                  </span>
                                </label> -->

                                <input type="text" class="input_field px-3 pt-3" formControlName="patient_ssn"
                                  name="patient_ssn" required maxlength="9" [ngClass]="{
                              'black-border': patient_address.value.patient_ssn,
                              'normal-border': !patient_address.value.patient_ssn,
                              'has-error': errorMsg && showvalidation
                          }" autocomplete="off" (input)="checkSSn()"
                                  oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1')" />
                                <span *ngIf="errorMsg && showvalidation"
                                  class="text-danger name-invalid">{{errorMsg}}</span>
                                <label for="text" class="label-name">
                                  <span class="content-name_1 f-c-p-3" [class.show-error]="showvalidation">
                                    <!-- Social Security Number -->
                                    {{mainService.document_label}}
                                  </span>
                                </label>
                                <div *ngIf="mainService.document_ids_list" class="document_id">
                                  <button type="button" class="info_icon_btn">
                                    <img src="assets\png\Icons.png" alt="" class="info_icon">
                                    <span class="tooltip_box  color-gray-1 show_div document_id_toottip d-none">
                                      <p class="p-0 m-0 fw-400 -treatment_text" style="color: #646c70;">
                                        {{mainService.document_ids_list}}
                                      </p>
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <!-- Continue Button -->
                        <div class="col-12 personal-continue mt-3">
                          <button class="mt-2 blue-btn fs-16 -
                          blue-btn-v2" button-primary-auth type="submit" id="continue2">Continue</button>
                        </div>
                      </form>
                    </div>

                  </ng-container>

                  <!-- *ngIf="getNumber(mod_step) == 3" -->
                  <ng-container *ngIf="opened_step == 3 && planInfo">
                    <div class="input_containers_head fw-700 fs-16 mb-0 color-gray px-4 d-md-none">
                      <div class="button_back_inside d-md-none">
                        <span>
                          <span *ngIf="!routeStep" class="left-back-btn" (click)="changeScreen()">
                            <!-- <img src="assets/png/arrow-left.png" alt=""> -->
                            <!-- Previous Step -->
                          </span>
                        </span>
                      </div>
                      <span class="data_personal">Recurring Details</span>
                    </div>
                    <div class="form-inside px-xl-4 px-2 recure-form form-mob-space">
                      <div class="mt-2 mb-2 recurring_new">
                        <div class="position-relative d-inline-block recure-form-innr">
                          <div class="start_amount color_change">
                            <span class="rec_amount" *ngIf="!manual_continue">Recurring Amount:</span>
                            <div class="first_amount">
                              <span class="recuring-price text-black block_classes fw-900 m-0"
                                *ngIf="planInfo.contract_type == 6" translate="no">
                                {{ mainService.currency_data.display_logo }}
                                {{ (planInfo.recurring_amount || planInfo.selected_plan.recurring_amount + (customerSelection?planInfo?.credit_report_amount:0)) |
                                DynamicDecimalPipe:mainService.currency_data.currency_code }}
                              </span>
                              <span class="recuring-price text-black block_classes fw-900 m-0"
                                *ngIf="planInfo.contract_type != 6" translate="no">
                                {{mainService.currency_data.display_logo}} {{((planInfo.recurring_amount ||
                                planInfo.selected_plan.recurring_amount + (customerSelection?planInfo?.credit_report_amount:0)) +
                                mainService.getCalculatedTransactionFee(planInfo,(planInfo.recurring_amount ||
                                planInfo.selected_plan.recurring_amount))  |
                                DynamicDecimalPipe:mainService.currency_data.currency_code)}}
                              </span>
                            </div>

                            <div class="second_amount">
                              <span class="fs-24 fw-800 color_change p-0 m-0" *ngIf="planInfo.contract_type != 6"><span
                                  class="d-md-none">recurring</span> for
                                the
                                next</span>
                              <span class="color_change text-black ms-1 fs-23 fw-800 p-0 me-0 " *ngIf="planInfo">
                                <span class="fs-23 fw-800 color-blue-black me-0 month_count"
                                  *ngIf="planInfo && planInfo.selected_plan && !((planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan.advance_interest_amount) && planInfo.contract_type != 6">
                                  {{planInfo && planInfo.selected_plan &&
                                  planInfo.selected_plan.month?(planInfo.selected_plan.month): '0'}}
                                </span>
                                <span class="fs-23 fw-800 color-blue-black month_count"
                                  *ngIf="planInfo && (planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount && planInfo.contract_type != 6">
                                  {{planInfo && planInfo.selected_plan &&
                                  planInfo.selected_plan.month?(planInfo.selected_plan.month
                                  - 1): '0'}}
                                </span>
                                <span [class.deffred]="planInfo.contract_type == 6" class="mnth">
                                  <!-- {{planInfo.contract_type !=6
                                  ?
                                  'months' : ' Amount (During Deferred)'}} -->
                                  <span *ngIf="planInfo.contract_type !=6">
                                    months
                                  </span>
                                  <span class="mnth d-md-none" *ngIf="planInfo.contract_type ==6">
                                    Recurring Amount
                                  </span>
                                  <span *ngIf="planInfo.contract_type ==6">
                                    (During Deferred)
                                  </span>
                                </span>
                              </span>
                            </div>
                          </div>
                          <span [ngClass]="{'manual_flow_tooltip': manual_continue}">
                            <button class="info_icon_btn px-0">
                              <!-- <img src="assets/svg/info_blue.svg" alt="" class="info_icon ms-2"> -->
                              <span class="info_icon ms-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" viewBox="0 0 20 20"
                                  fill="none">
                                  <path
                                    d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                                    stroke="#141616" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M9.375 9.375H10V13.75H10.625" stroke="#141616" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                  <path
                                    d="M10 7.5C10.5178 7.5 10.9375 7.08027 10.9375 6.5625C10.9375 6.04473 10.5178 5.625 10 5.625C9.48223 5.625 9.0625 6.04473 9.0625 6.5625C9.0625 7.08027 9.48223 7.5 10 7.5Z"
                                    fill="#141616" />
                                </svg>
                              </span>
                              <span class="tooltip_box d-none color-gray-1 custom_tool_recurring tooltip_box__modify"
                                *ngIf="planInfo" [ngClass]="{'def_modify': planInfo && planInfo.contract_type == 6}">
                                <div class="d-flex py-2 fs-14 align-items-center justify-content-between">
                                  <div class="d-flex flex-column text-start">
                                    <span class="color-gray fw-400">Recurring Amount</span>
                                    <span class="color-gray fw-400"
                                      *ngIf="planInfo && planInfo.contract_type ==6">(During
                                      Deferred)</span>
                                  </div>
                                  <div class="ps-2 text-end">
                                    <span class="color-dblue fw-800 text-end text-nowrap"
                                      style="max-width: calc(42%) !important;"><span
                                        translate="no">{{mainService.currency_data.display_logo}}
                                        {{(planInfo.recurring_amount ||
                                        planInfo.selected_plan.recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span></span>
                                  </div>
                                </div>
                                <div class="d-flex py-2 fs-14 align-items-center justify-content-between" *ngIf="customerSelection">
                                  <div class="d-flex flex-column text-start">
                                    <span class="color-gray fw-400">Credee Reporting Fee</span>
                                    
                                  </div>
                                  <div class="ps-2 text-end">
                                    <span class="color-dblue fw-800 text-end text-nowrap"
                                      style="max-width: calc(42%) !important;"><span
                                        translate="no">{{mainService.currency_data.display_logo}}
                                        {{(planInfo.credit_report_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span></span>
                                  </div>
                                </div>
                                <div class="d-flex py-2 fs-14 align-items-center justify-content-between"
                                  *ngIf="planInfo && planInfo.contract_type == 6 && ((planInfo.threshold_amount <= (planInfo.recurring_amount || planInfo.selected_plan.recurring_amount)) || (planInfo.threshold_amount <= (planInfo.recurring_amount || planInfo.selected_plan.next_recurring_amount)))"
                                  style="border-top: none !important">
                                  <span class="color-gray fw-400">Transaction Fee</span>
                                  <span class="color-dblue fw-800 ps-2" style="max-width: calc(42%) !important;">
                                    <span translate="no"> {{mainService.currency_data.display_logo}}
                                      {{(mainService.getCalculatedTransactionFee(planInfo,(planInfo.recurring_amount
                                      ||
                                      planInfo.selected_plan.recurring_amount),1))}}</span>
                                  </span>
                                </div>
                                <div class="d-flex py-2 fs-14 align-items-center justify-content-between"
                                  *ngIf="planInfo && planInfo.contract_type != 6 && (planInfo.threshold_amount > (planInfo.recurring_amount || planInfo.selected_plan.recurring_amount)) || (planInfo.threshold_amount > (planInfo.next_recurring_amount || planInfo.selected_plan.next_recurring_amount))">
                                  <span class="color-gray fw-400">Transaction Fee</span>
                                  <span class="color-dblue fw-800 ps-2" style="max-width: calc(42%) !important;">
                                    <span translate="no">{{mainService.currency_data.display_logo}}
                                      {{(mainService.getCalculatedTransactionFee(planInfo,(planInfo.recurring_amount
                                      ||
                                      planInfo.selected_plan.recurring_amount),1)| DynamicDecimalPipe:mainService.currency_data.currency_code)}}</span>
                                  </span>
                                </div>
                                <div class="d-flex py-1 fs-14 align-items-center justify-content-between"
                                  *ngIf="planInfo && planInfo.contract_type ==6 && planInfo.selected_plan.month > planInfo.di_start_month">
                                  <div class="d-flex flex-column text-start">
                                    <span class="color-gray fw-400">Recurring Amount</span>
                                    <span class="color-gray fw-400">(After Deferred)</span>
                                  </div>
                                  <div class="ps-2 text-end">
                                    <span class="color-dblue fw-800" style="max-width: calc(42%) !important;">
                                      <span translate="no">{{mainService.currency_data.display_logo}}
                                        {{((planInfo.next_recurring_amount) ||
                                        (planInfo.selected_plan.next_recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code)}}</span></span>
                                  </div>
                                </div>
                                <div class="d-flex py-2 fs-14 align-items-center justify-content-between"
                                  *ngIf="planInfo && planInfo.contract_type == 6 && planInfo.selected_plan.month > planInfo.di_start_month"
                                  [ngClass]="mainService.promotionalTransactionOffer ? 'transaction-fee' : ''">
                                  <span class="color-gray fw-400">Transaction Fee</span>
                                  <span class="color-dblue fw-800">
                                    <span translate="no">{{mainService.currency_data.display_logo}} {{planInfo &&
                                      (planInfo.selected_plan.next_recurring_amount || planInfo.next_recurring_amount)
                                      ?
                                      (mainService.getCalculatedTransactionFee(planInfo,planInfo.next_recurring_amount
                                      ||
                                      planInfo.selected_plan.next_recurring_amount)| DynamicDecimalPipe:mainService.currency_data.currency_code):
                                      '0.00'}}</span>
                                  </span>
                                </div>



                                <div class="d-flex py-2 fs-14 align-items-center justify-content-between"
                                  *ngIf="planInfo.is_ar_contract">
                                  <span class="color-gray fw-600">Account Setup Fee</span>
                                  <span class="color-dblue fw-800" style="max-width: calc(42%) !important;">
                                    <span translate="no"> {{mainService.currency_data.display_logo}} {{planInfo &&
                                      planInfo.plans_array &&
                                      (planInfo.plans_array[0].enrollment_fee ||
                                      planInfo.plans_array[0].enrollment_fee == 0 )?
                                      planInfo.plans_array[0].enrollment_fee : '30'}}</span>
                                  </span>
                                </div>
                                <div class="d-flex py-2 fs-14 align-items-center justify-content-between"
                                  *ngIf="planInfo && planInfo.contract_type != 6">
                                  <span class="color-gray fw-600">Total Recurring Amount </span>
                                  <span class="color-dblue fw-800" style="max-width: calc(42%) !important;">
                                    <span translate="no">{{mainService.currency_data.display_logo}}
                                      {{calculateTotalPayableAmount((planInfo.recurring_amount ||
                                      planInfo.selected_plan.recurring_amount),
                                      mainService.getCalculatedTransactionFee(planInfo,(planInfo.recurring_amount ||
                                      planInfo.selected_plan.recurring_amount))).toFixed(2) + (planInfo.is_ar_contract
                                      ? 30 : 0)| DynamicDecimalPipe:mainService.currency_data.currency_code}}
                                    </span>
                                  </span>
                                </div>
                              </span>
                            </button>
                          </span>
                        </div>
                      </div>
              <div class="" *ngIf="creditReportOption && plans?.doctor_country_currency_info?.country?.country_id == 1">
                <div class="credit-option" [ngClass]="{'active': customerSelection}">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <input type="checkbox" [checked]="customerSelection" class="credit-checkbox"
                        (click)="animationStart? '' :toggleCreditOption(0); $event.stopPropagation()" />
                      <span (click)="animationStart? '' :toggleCreditOption(0)" class="ms-2">Build credit with your on-time payments</span>
                    </div>
                  </div>
                  <div class="text-start mt-2" *ngIf="customerSelection"><span class="fw-600">
                      {{mainService.currency_data.display_logo}}{{planInfo?.credit_report_amount |
                      DynamicDecimalPipe:mainService.currency_data.currency_code}}
                    </span>
                    <span>/mo- we’ll report this plan’s payments to major credit bureaus to help build positive history. Cancel anytime.</span>
                  </div>
                  <div class="text-start mt-2" *ngIf="!customerSelection"><span class="fw-600">
                      Heads up: </span>
                    <span>Turning this off means your on-time payments for this plan won’t be reported - and won’t help build credit history.
                      <span class="keepText" (click)="animationStart? '' :toggleCreditOption(0)">Keep Credit Reporting</span>
                    </span>
                  </div>


                </div>
                <!-- <div *ngIf="!item.creditReportOption" class="credit-description mt-2">
                  <p class="fw-600" style="color:#9A59FF">*What is better credit worth to you?</p>
                  <p class="m-0" style="color:#9959ffee">
                    Reporting your payments to the credit bureaus ensures your good payment habits are rewarded.
                  </p>
                </div> -->
              </div>
                      <div class="pt-3 pb-0 recuring-plan">
                        <h6 class="color-black fs-16 fw-700 mb-1">Choose starting date for recurring payments*</h6>
                        <div class="row h-100">
                          <div class="col-12">
                            <div class="">
                              <div class="pointer custom-form-v5 flex-grow-1" class='custom-form-v5 mt-2'>

                                <input name="date_of_birth" class="pointer input_field px-3 pt-3 dob-input-field"
                                  [max]="planInfo.max_date" [min]="planInfo.min_date"
                                  [(ngModel)]="paymentDetails.recurringDate" (click)="picker.open()"
                                  (focus)="picker.open()" [matDatepicker]="picker" readonly id="recurring_date">
                                <label style="bottom: -11px; left: 15px; font-size: 12px;" for="text"
                                  class="dob-label-name" [ngClass]="[paymentDetails.recurringDate ? 'label-name':'']">
                                  <span style="color: #8E979B;" class="dob-content f-c-p-3">
                                    Select Date
                                  </span>
                                  <span style="position: absolute;right: 0;transform: translate(-28px, 14px)">
                                    <img src="assets/svg/calender-2.svg" />
                                    <!-- <mat-datepicker-toggle matSuffix [for]="picker" class="d-none">
                            </mat-datepicker-toggle> -->
                                    <mat-datepicker #picker startView="multi-year">
                                    </mat-datepicker>
                                    <!-- <img src="assets/svg/calender2.svg" class="pointer" alt=""> -->
                                  </span>
                                </label>
                              </div>


                              <!-- Payment Add column -->
                              <div class="w-100 mt-md-2 mt-4" *ngIf="!recurring_source_id">
                                <!-- <h6 class="mt-4 fw-700 color-black fs-16 mb-2">
                                  Recurring method <span class="mat-error">*</span>
                                </h6> -->

                                <div class="add_card_button_1 pt-2">
                                  <button class="w-100 border-0 py-3" (click)="openModal_1(2,addNewPaymentMethodModal)"
                                    id="recurring_card">+ Add Recurring Payment
                                    Method</button>
                                </div>
                              </div>

                              <div class="w-100" *ngIf="recurring_source_id">
                                <h6 class="recurring_pay">
                                  Recurring payment method*
                                </h6>

                                <div class="add_card_button_1 add_card_button_2 mt-2 recure-payment">
                                  <form
                                    class="d-flex mb-2 align-items-center justify-content-between px-3 py-2 card_show_box mb-0"
                                    autocomplete="off">
                                    <span for="'card'+i" class="mb-0 color-dblue fs-14 fw-700 pe-2">
                                      <img
                                        [ngStyle]="{'width':getMyCard(recurring_source_id,'recurring_sources').payment_source == 'Bank' ? '24px' :'30px'}"
                                        class="me-2"
                                        [src]="getMyCard(recurring_source_id,'recurring_sources').payment_source == 'Bank' ? 'assets/svg/bank.svg' : getMyCard(recurring_source_id,'recurring_sources').brand?'assets/svg/card-type/'+getMyCard(recurring_source_id,'recurring_sources').brand.toLowerCase()+'.svg':'assets/svg/card-type/no_card.svg'"
                                        *ngIf="getMyCard(recurring_source_id,'recurring_sources') && getMyCard(recurring_source_id,'recurring_sources').brand;else no_card " />
                                        <!-- // card name change on live -->
                                        <!-- getMyCard(recurring_source_id,'recurring_sources') && (getMyCard(recurring_source_id,'recurring_sources').brand=='MasterCard' || getMyCard(recurring_source_id,'recurring_sources').brand=='Discover' || getMyCard(recurring_source_id,'recurring_sources').brand=='JCB' || getMyCard(recurring_source_id,'recurring_sources').brand=='Visa' || getMyCard(recurring_source_id,'recurring_sources').brand=='American Express' || getMyCard(recurring_source_id,'recurring_sources').payment_source == 'Bank');else no_card  -->
                                      <ng-template #no_card>
                                        <img style="width:24px;" [src]="'assets/svg/card-type/no_card.svg'">
                                      </ng-template>
                                      XXXX XXXX {{getMyCard(recurring_source_id,'recurring_sources').payment_source_type
                                      !=
                                      1 ?
                                      "XXXX
                                      ":""}}{{getMyCard(recurring_source_id,'recurring_sources').last4}}
                                    </span>
                                    <span>
                                      <span class="custom-radio-box position-relative custom-radio-checkobx">
                                        <input type="radio" name="recurring_card" class="position-absolute" checked
                                          [value]="recurring_source_id" autocomplete="off" />
                                        <label class="radio-label"></label>
                                      </span>
                                    </span>
                                  </form>
                                  <div class="mt-1 w-25">
                                    <span class="fw-700 color-blue" style="cursor: pointer;"
                                      (click)="openModal_1(2,addNewPaymentMethodModal);gettingCard = false;">+
                                      Update</span>
                                  </div>
                                </div>



                              </div>
                              <div>
                                <h6 class="recurring_pay" *ngIf="backup_source_id">
                                  Backup Payment Method
                                </h6>
                                <div class="add_backup_card mt-3" *ngIf="!backup_source_id">
                                  <button class="w-100 button-login-100 border-0" [disabled]="!recurring_source_id"
                                    [ngStyle]="{'cursor': !recurring_source_id ? 'no-drop' :'pointer', 'background-color': !recurring_source_id? '#f8f9fa' :'#E9FAFF', 'color': !recurring_source_id? '#808080' :'#017A9F'}"
                                    (click)="openModal_1(3,addNewPaymentMethodModal)">
                                    + Add Backup Payment Method</button>
                                </div>

                                <div class="add_card_button_1 add_card_button_2 mt-2" *ngIf="backup_source_id">

                                  <form
                                    class="d-flex mb-2 align-items-center justify-content-between px-3 py-2 card_show_box mb-0">
                                    <span for="'card'+i" class="mb-0 color-dblue fs-14 fw-700 px-2">
                                      <img
                                        [ngStyle]="{'width':getMyCard(backup_source_id,'backup_sources').payment_source == 'Bank' ? '24px' :'30px'}"
                                        class="me-2"
                                        [src]="getMyCard(backup_source_id,'backup_sources').payment_source == 'Bank' ? 'assets/svg/bank.svg' : getMyCard(backup_source_id,'backup_sources').brand?'assets/svg/card-type/'+getMyCard(backup_source_id,'backup_sources').brand.toLowerCase()+'.svg':'assets/svg/card-type/no_card.svg'"
                                        *ngIf="getMyCard(backup_source_id,'backup_sources')?.brand;else no_card " />
                                        <!-- // card name change on live -->
                                        <!-- getMyCard(backup_source_id,'backup_sources').brand=='MasterCard' || getMyCard(backup_source_id,'backup_sources').brand=='Discover' || getMyCard(backup_source_id,'backup_sources').brand=='JCB' || getMyCard(backup_source_id,'backup_sources').brand=='Visa' || getMyCard(backup_source_id,'backup_sources').brand=='American Express' || getMyCard(backup_source_id,'backup_sources').payment_source == 'Bank';else no_card  -->
                                      <ng-template #no_card>
                                        <img style="width:24px;" class="me-2"
                                          [src]="'assets/svg/card-type/no_card.svg'">
                                      </ng-template>
                                      XXXX XXXX {{getMyCard(backup_source_id,'backup_sources').payment_source_type != 1
                                      ? "XXXX
                                      ":""}}{{getMyCard(backup_source_id,'backup_sources').last4}}
                                    </span>
                                    <span>
                                      <span>
                                        <img class="me-2 mb-2" src="assets/svg/delete-icon.svg"
                                          style="width: 20px; cursor: pointer;" (click)="backup_source_id = null">
                                      </span>
                                      <span>
                                        <label class="mb-0">
                                          <input type="radio" name="recurring_card" checked
                                            [value]="recurring_source_id" /></label>
                                      </span>
                                    </span>
                                  </form>
                                  <div class="mt-1 w-25" *ngIf="backup_source_id">
                                    <span class="fw-700 color-blue" style="cursor: pointer;"
                                      (click)="openModal_1(3,addNewPaymentMethodModal);gettingCard = false;">+Update</span>
                                  </div>
                                </div>



                              </div>
                            </div>

                            <div class="button_continue_payment_method py-0">
                              <button button-primary-auth class="blue-btn fs-16 blue-btn-v2"
                                (click)="signature=null;switchForm()" [disabled]="!recurring_source_id"
                                id="continue4">Continue</button>
                            </div>
                            <div class="w-100 color-gray-1 mt-4 notes_section">
                              <span class="font-weight-bold fs-14 color-gray">
                                Note:
                              </span>
                              <ul>
                                <li>If the selected payment method fails, we will attempt to charge your backup
                                  card.</li>
                                <!-- <br> -->
                                <!-- <li >As part of our card verification process <span class="notranslate">{{mainService.currency_data.display_logo}}1 </span>will be deducted which will be refunded once your card has been validated.</li> -->
                                <li hideIfDecimal>You will be charged <span
                                    class="notranslate">{{mainService.currency_data.display_logo}}1 </span> or
                                  1%(whichever is higher) extra transaction fee if use a
                                  non-{{mainService.currency_data.country_code}} debit/credit card.</li>
                              </ul>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                  </ng-container>

                  <!-- current step == 4 -->
                  <ng-container *ngIf="opened_step == 4 && planInfo">
                    <div class="input_containers_head fw-700 fs-16 mb-0 color-gray px-4 dsk-hide d-md-none"
                      *ngIf="!scanner_continue && !manual_continue">
                      <div class="button_back_inside">
                        <span>
                          <span class="left-back-btn" (click)="changeScreen()">
                            <!-- <img src="assets/png/arrow-left.png" alt=""> -->
                            <!-- Previous Step -->
                          </span>
                        </span>
                      </div>
                      <span class="data_personal">Make Payment</span>
                    </div>
                    <div class="form-inside px-xl-4 px-2 form-mob-space payable-info">
                      <div class="recurring_new_today">
                        <h2 class="mb-0 fw-800 fs-24 text-center recure-form-innr">
                          <div>
                            <span class="text-black fs-24 fw-800 recuring-price mt-lg-0 mt-2">
                              <span class="notranslate">
                                {{mainService.currency_data.display_logo}} {{
                                planInfo.selected_plan.total_payable_amount + ((planInfo?.contract_type == 1 || planInfo?.contract_type == 3) && planInfo?.payment_reserve_on_pay_new_ten && customerSelection?planInfo?.credit_report_amount:0)
                                |DynamicDecimalPipe:mainService.currency_data.currency_code}}
                              </span>
                            </span>
                            <span class="total_pay_today">Total Payable Today</span>
                          </div>
                          <button class="info_icon_btn service-amount-btn">
                            <span class="info_icon_btn_img">
                              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" viewBox="0 0 20 20"
                                fill="none">
                                <path
                                  d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                                  stroke="#141616" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.375 9.375H10V13.75H10.625" stroke="#141616" stroke-width="1.5"
                                  stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                  d="M10 7.5C10.5178 7.5 10.9375 7.08027 10.9375 6.5625C10.9375 6.04473 10.5178 5.625 10 5.625C9.48223 5.625 9.0625 6.04473 9.0625 6.5625C9.0625 7.08027 9.48223 7.5 10 7.5Z"
                                  fill="#141616" />
                              </svg>
                            </span>
                            <span class="tooltip_box">
                              <div class="col-12 mx-auto px-0 mt-3 mb-0" *ngIf="planInfo">
                                <ul style="list-style-type: none;" class="px-0 service_viewer no_scroll">
                                  <li
                                    class="d-flex align-items-center justify-content-between flex-wrap service_list_item">
                                    <span class="color-gray fs-14">
                                      {{(planInfo.contract_type == 1 || planInfo.contract_type == 3)? 'First Recurring
                                      Due
                                      Today' :
                                      'Upfront Fee'}}
                                    </span>
                                    <span class="fw-700 fs-14 color-dblue">
                                      <span class="notranslate">
                                        {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan
                                        &&
                                        planInfo.selected_plan.advance_interest_amount?(planInfo.selected_plan.advance_interest_amount):
                                        '0.00'}}</span>
                                    </span>
                                  </li>
                                  <li *ngIf="(planInfo?.contract_type == 1 || planInfo?.contract_type == 3) && planInfo?.payment_reserve_on_pay_new_ten && customerSelection"
                                    class="d-flex align-items-center justify-content-between flex-wrap service_list_item">
                                    <span class="color-gray fs-14">
                                     Credit Reporting Fee
                                    </span>
                                    <span class="fw-700 fs-14 color-dblue">
                                      <span class="notranslate">
                                        {{mainService.currency_data.display_logo}} {{planInfo?.credit_report_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                                    </span>
                                  </li>
                                  <li class="d-flex align-items-center justify-content-between service_list_item">
                                    <span class="color-gray fs-14">
                                      {{planInfo && planInfo.is_ar_contract == 1? 'Account Setup Fee' :
                                      'Enrollment
                                      Fee'}}
                                      <img src="../../../../assets/svg/offer.svg" width="20px"
                                        tooltip="{{'If you instantly pay your payment today using bank, you will get '+ mainService.currency_data.display_logo  + planInfo.plans_array[0].enrollment_fee + 'off on your contract enrollment fee!'}}"
                                        *ngIf="planInfo.plans_array[0] && planInfo.enrollment_waiver == 1 && planInfo.selected_payment_matrix.primary_type == 3 && planInfo.enrollment_enabled == 0">
                                    </span>
                                    <del class="text-end font-weight-bold fs-14 col-6 financing-labels col-6 text-colr"
                                      *ngIf="is_waived"><span
                                        class="notranslate">{{mainService.currency_data.display_logo}}{{enrollment_fee|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span></del>
                                    <span class="fw-700 fs-14 color-dblue" *ngIf="!is_waived"><span
                                        class="notranslate">{{mainService.currency_data.display_logo}}{{enrollment_fee|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                                    </span>
                                  </li>
                                  <li class="d-flex align-items-center justify-content-between service_list_item"
                                    *ngIf="planInfo && planInfo.downpayment_amount > 0">
                                    <span class="color-gray fs-14">
                                      Down Payment
                                    </span>
                                    <span *ngIf="planInfo && planInfo.downpayment_amount > 0"
                                      class="float-end font-weight-bold fs-14 text-colr"><span
                                        class="notranslate">{{mainService.currency_data.display_logo}}{{planInfo
                                        && planInfo.downpayment_amount ?
                                        (planInfo.downpayment_amount|DynamicDecimalPipe:mainService.currency_data.currency_code): '0.00'}}</span>
                                    </span>
                                  </li>
                                  <li
                                    class="d-flex align-items-center justify-content-between service_list_item pay-now-finance">
                                    <span class="-financing-labels color-gray fs-14">Transaction Fee</span>
                                    <span
                                      *ngIf="planInfo.selected_plan && planInfo.selected_plan && mainService.getTransactionFee(planInfo, planInfo.selected_plan.recurring_amount)"
                                      class="fw-700 color-dblue position-relative">
                                      <div>
                                        <span *ngIf="mainService.promotionalTransactionOffer"
                                          [ngClass]="mainService.promotionalTransactionOffer ? 'strike_through_class' : ''">
                                          <span class="notranslate">
                                            {{mainService.getTransactionFeeStrike(planInfo,
                                            planInfo.selected_plan.recurring_amount)}}
                                          </span>
                                        </span>
                                        <div
                                          [ngClass]="mainService.promotionalTransactionOffer ? 'transaction-fee' : ''"
                                          class=" d-inline-block ms-2">
                                          <span class="fs-14 text-colr">
                                            <span class="notranslate">
                                              {{mainService.getTransactionFee(planInfo,planInfo.selected_plan.recurring_amount,1)}}
                                            </span>/ payment
                                          </span>
                                        </div>
                                      </div>
                                      <div *ngIf="mainService.promotionalTransactionOffer"
                                        class="transaction-fee-popup pop-up-top position-absolute">
                                        Promo
                                      </div>
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </span>
                          </button>
                        </h2>
                      </div>
                      <div class="Select_payment_method pt-4">
                        <span class="recurring_pay" *ngIf="dp_source_id">Today's payment method*</span>

                        <div class="add_backup_card mt-3" *ngIf="!dp_source_id">
                          <button class="w-100 button-login-100 border-0 py-3"
                            (click)="openModal_1(1,addNewPaymentMethodModal)">+
                            Add Today Payment Method</button>
                        </div>


                        <ng-container *ngIf="dp_source_id">

                          <div class="add_card_button_1 add_card_button_2 mt-2">
                            <form
                              class="d-flex mb-0 align-items-center justify-content-between px-3 py-2 card_show_box mb-0">
                              <span for="" class="mb-0 color-dblue fs-14 fw-700 px-2" id="today_payment">
                                <img
                                  [ngStyle]="{'width':getMyCard(dp_source_id,'primary_sources').payment_source == 'Bank' ? '24px' :'30px'}"
                                  class="me-2"
                                  [src]="getMyCard(dp_source_id,'primary_sources').payment_source == 'Bank' ? 'assets/svg/bank.svg' : getMyCard(dp_source_id,'primary_sources').brand?'assets/svg/card-type/'+getMyCard(dp_source_id,'primary_sources')?.brand.toLowerCase()+'.svg':'assets/svg/card-type/no_card.svg'"
                                  *ngIf="getMyCard(dp_source_id,'primary_sources')?.brand;else no_card " />
                                  <!-- // card name change on live -->
                                  <!-- getMyCard(dp_source_id,'primary_sources').brand=='MasterCard' || getMyCard(dp_source_id,'primary_sources').brand=='Discover' || getMyCard(dp_source_id,'primary_sources').brand=='JCB' || getMyCard(dp_source_id,'primary_sources').brand=='Visa' || getMyCard(dp_source_id,'primary_sources').brand=='American Express' || getMyCard(dp_source_id,'primary_sources').payment_source == 'Bank';else no_card -->
                                <ng-template #no_card>
                                  <img style="width:24px;" class="me-2" [src]="'assets/svg/card-type/no_card.svg'">
                                </ng-template>
                                XXXX XXXX {{getMyCard(dp_source_id,'primary_sources').payment_source_type != 1 ? "XXXX
                                ":""}}{{getMyCard(dp_source_id,'primary_sources').last4}}
                              </span>
                              <span>

                                <div class="custom-radio-box position-relative custom-radio-checkobx">
                                  <input type="radio" name="dp_card" checked [value]="dp_source_id" />
                                  <label class="radio-label"></label>
                                </div>

                              </span>
                            </form>
                            <div class="mt-3 w-25">
                              <span class="fw-700 " role="link" style="cursor: pointer;"
                                (click)="openModal_1(1,addNewPaymentMethodModal);gettingCard = false;">+Update</span>
                            </div>
                          </div>


                        </ng-container>
                      </div>

                      <div class="signature_pad_block mt-3">
                        <span class="color-black fw-700 fs-16">
                          Your Signature
                        </span>
                        <div class="p-0 col-12 overflow-hidden mt-3 w-100 position-relative" #canvasDiv id="canvasDiv"
                          style="background: #FFFFFF;box-sizing: border-box;border-radius: 7px;max-width: none;">
                          <!-- <signature-pad class="signature-pad" [options]="signaturePadOptions"
                            (onEndEvent)="drawComplete()" #signaturePad1>
                          </signature-pad> -->
                          <app-signature-pad (signatureSaved)="drawComplete($event)"
                            [parentWidth]="getParentDivWidth()"></app-signature-pad>
                          <span class="eraser" (click)="clearSign()" placement="right" [tooltip]="'Clear'">
                            <img src="assets/svg/eraser.svg" alt="">
                          </span>
                        </div>
                      </div>

                      <div class="terms pb-2 mb-4">
                        <div class="custom-control custom-checkbox mt-3 pay-check d-flex">
                          <input default-checkbox type="checkbox" class="form-check-input" name="terms"
                            [(ngModel)]="terms" id="terms">
                          <ng-container *ngIf="from_mobile; else from_web">
                            <label class="pointer form-check-label" for="terms">
                              I've read & agreed to the
                              <!-- <a href="javascript:void(0)" target="_blank" [routerLink]="['/terms']"
                                                                      [queryParams]="{token: contractToken}">Terms & Conditions</a>, -->
                            </label>
                            <span>
                              <span>
                                <span *ngIf="show_closure_form">
                                  <span style="color: #176a87;" (click)="openTila()" class="color-blue f-700 pointer">
                                    {{mainService.currency_data.country_code == 'US' ? 'TILA Disclosure' : 'Disclosure
                                    Statement'}}</span>,
                                </span>
                                <span style="color: #176a87;" (click)="openHipaa()" style="line-break: auto;"
                                  class="color-blue f-700 d-inline-block pointer">
                                  Payment
                                  Authorization Agreement&nbsp;and&nbsp;HIPAA Disclosure. </span>
                              </span>
                            </span>
                          </ng-container>
                          <ng-template #from_web>
                            <label class="pointer form-check-label" for="terms">
                              <span id="pre-custom">I've read </span>& agreed to the <!-- <a href="javascript:void(0)" target="_blank" [routerLink]="['/terms']"
                                              [queryParams]="{token: contractToken}">Terms & Conditions</a>, -->
                              <span>
                                <span>
                                  <span *ngIf="show_closure_form">
                                    <a href="javascript:void(0)" target="_blank" [routerLink]="['/tila']"
                                      class="color-blue f-700">
                                      {{mainService.currency_data.country_code == 'US' ? 'TILA Disclosure' : 'Disclosure
                                      Statement'}}</a>,
                                  </span>
                                  <a href="javascript:void(0)" target="_blank" [routerLink]="['/consentForm']"
                                    [queryParams]="{token: contractToken}" style="line-break: auto;"
                                    class="color-blue f-700">
                                    Payment
                                    Authorization Agreement&nbsp;and&nbsp;HIPAA Disclosure. </a>
                                </span>
                              </span>
                            </label>
                          </ng-template>
                        </div>
                        <div class="custom-control custom-checkbox mt-3 pay-check"
                          *ngIf="split_request_data[0].buss_terms_link && split_request_data[0].show_buss_terms">
                          <input default-checkbox type="checkbox" class="form-check-input" name="check_business_terms"
                            [(ngModel)]="check_business_terms" id="check_business_terms">
                          <label class="form-check-label" for="check_business_terms">
                            <span id="pre-custom">
                              I hereby read & accept the terms and conditions of&nbsp;</span>

                            <a href="javascript:void(0)" (click)="goToLink(split_request_data[0].buss_terms_link)"
                              *ngIf="split_request_data[0].buss_terms_link && split_request_data[0].show_buss_terms"
                              rel="noopener noreferrer" role="link" class="color-dblue f-700">
                              <span>
                                <span class="notranslate">{{split_request_data[0].practice_name ||
                                  (split_request_data[0].doctor_first_name + ' ' +
                                  split_request_data[0].doctor_last_name)
                                  ||
                                  'Business
                                  Terms'}}</span>
                              </span>
                            </a>.
                          </label>
                        </div>
                      </div>

                      <!--button continue -->
                      <div class="button_continue btn--continue position-static">
                        <!-- createContract -->
                        <button button-primary-auth class="px-5 fs-16" (click)="uploadBusinessSignature()"
                          [disabled]="((patientData && patientData.total_automation_business && patientData.total_automation_business.length <= 0) ? !signature:'') || !terms || !dp_source_id || (split_request_data[0].show_buss_terms && !check_business_terms)"
                          id="continue5">Make
                          Payment</button>
                      </div>

                      <div class="w-100 mt-4">
                        <!-- Note -->
                        <div hideIfDecimal class="w-100 color-gray-1 mt-4 notes_section">
                          <span class="font-weight-bold fs-14 color-gray">
                            Note:
                          </span>
                          <ul>

                            <li>You will be charged <span
                                class="notranslate">{{mainService.currency_data.display_logo}}1 </span> or 1%(whichever
                              is
                              higher) extra transaction fee if use a non-{{mainService.currency_data.country_code}}
                              debit/credit card.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="opened_step == 5 && planInfo">
                    <div
                      class="form-inside px-xl-4 px-2 paynow--final__step onestep-modal h-100 d-flex align-items-center"
                      id="open-step">
                      <div class="modal-body p-0">
                        <div class="modal-data">
                          <div class="success-animation success-md-animation">
                            <img src="assets\png\check-icon.png" alt="">
                          </div>
                          <div class="head_contents py-3 text-center h5 fw-700 fs-18">
                            Your payment has been made successfully.
                            <p class="fs-12 fw-700 contract_id_grey"
                              *ngIf="split_request_data && split_request_data.length > 0">
                              CONTRACT ID: {{split_request_data[0]['contract_code'] || contract_code || 'Not
                              Available'}}
                            </p>
                          </div>
                        </div>

                        <div class="body_content px-4 text-center">
                          <div class="w-100 pay-plan p-0">
                            <div class="plans--commit d-flex align-items-center flex-grow-1">
                              <div class="flex-grow-1 successfull">
                                <p class="plans-commit-text m-0 fs-18 fw-400 mb-1 text-start">
                                  Payment Plan
                                </p>
                                <p class="fs-20 fw-800 m-0 text-start" *ngIf="planInfo">
                                  <span class="notranslate"> {{mainService.currency_data.display_logo}} {{planInfo &&
                                    planInfo.treatment_amount ?
                                    ((planInfo.treatment_amount - (planInfo.downpayment_amount || 0))) :'0.00'}}</span>
                                </p>
                              </div>
                            </div>
                            <div
                              class="flex-grow-1 plans--commit info-card-two plan-left-border d-flex align-items-center "
                              *ngIf="planInfo && planInfo.selected_plan && planInfo.contract_type != 6">
                              <div class="flex-grow-1 plans--commit-innr successfull">
                                <p class="plans-commit-text m-0 fs-18 fw-400 text-start">{{planInfo &&
                                  planInfo.selected_plan
                                  &&
                                  planInfo.selected_plan.month}} Months</p>
                                <div class="per_month card-track2 text-start fs-20 fw-800 ">
                                  <span class="notranslate"> {{mainService.currency_data.display_logo}} {{planInfo &&
                                    (planInfo.recurring_amount || planInfo.selected_plan.recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}} </span>
                                  <span class="card-track1 fs-14 fw-400"> /month</span>
                                </div>
                              </div>
                            </div>
                            <div class="flex-grow-1 plans--commit-innr"
                              *ngIf="planInfo && planInfo.selected_plan && planInfo.contract_type == 6">
                              <div class="flex-grow-1 plans--commit-innr">
                                <div class="flex-grow-1 plans--commit plan-left-border d-flex align-items-center">
                                  <div class="flex-grow-1">
                                    <p class="plans-commit-text m-0 fs-18 fw-400 text-start"> {{
                                      planInfo.selected_plan.month > planInfo.deferred_duration ?
                                      "First" : "" }}
                                      {{planInfo.deferred_duration}}
                                      Months</p>
                                    <div class="per_month py-2 fs-20 fw-800 text-start">
                                      <span class="notranslate"> {{mainService.currency_data.display_logo}} {{planInfo
                                        &&
                                        (planInfo.recurring_amount || planInfo.selected_plan.recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}} </span>
                                      <span class="card-track1 fw-400 fs-14 text-start">/ month</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex-grow-1 plans--commit plan-left-border d-flex align-items-center"
                                  *ngIf="planInfo.deferred_duration < planInfo.plans_array[0].month">
                                  <div class="flex-grow-1">
                                    <p class="plans-commit-text m-0 fs-18 fw-400 text-start">Remaining Months</p>
                                    <div class="per_month py-2 fs-20 fw-800 text-start">
                                      <span class="notranslate"> {{mainService.currency_data.display_logo}} {{planInfo
                                        &&
                                        (planInfo.next_recurring_amount ||
                                        planInfo.selected_plan.next_recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}}
                                      </span>
                                      <span class="card-track1 fw-400 fs-14 text-start">/ month</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="w-100 recurring text-center"
                            [ngClass]="{'defferd-recurring-time': planInfo.contract_type ==6}">
                            <span class="card-body first-occur">First Recurring Payment Date</span>
                            <p class="date_column h3 mt-2 fw-700"> <span
                                class="notranslate">{{mainService.getDatePlan(paymentDetails.recurringDate)}}</span>
                            </p>
                          </div>

                          <!-- <div class="botton_continue">
                          <button button-primary-auth class="px-5 adding-bnk" (click)="gotoThanksPage()">Continue</button>
                        </div> -->
                          <div class="w-100 d-flex button__Wrapper" style=" justify-content: space-between;">
                            <div class="text-end mt-md-3 flex-grow-1 contract-wrap pe-sm-2">
                              <button class=" pointer btn w-100 download--contract__cta"
                                (click)="downloadContract()">Download Contract</button>
                            </div>
                            <div class="text-start mt-md-3 flex-grow-1 contract-wrap1 ps-md-3 ps-sm-2">
                              <button class="pointer btn w-100 dashboard__cta" (click)="continueLogin()">Login to
                                Dashbord</button>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <!-- <ng-container *ngIf="opened_step == 5 && planInfo">
              <div class="successpage ">
                <div class="">
                  <div class="head_content color-blue back-light-blue px-3 py-3 text-center h5 fw-700">
                    <img src="" alt="">
                    Your payment has been made successfully.
                  </div>
                  <div class="body_content px-4 text-center">
                    <span class="fs-12 fw-700 contract_id_grey" style="color: #C3C8CD !important"
                      *ngIf="split_request_data && split_request_data.length > 0">
                      CONTRACT ID: {{split_request_data[0]['contract_code'] || contract_code || 'Not Available'}}
                    </span>
          
                    <div class="w-100">
          
                      <p class="fs-16 fw-700 pt-4 pb-1 m-0 card-body">
                        Payment Plan
                      </p>
                      <div>
                        <p class="h2 text-black  fw-900 " style="font-size: 40px;margin-bottom: 34px;">
                          {{mainService.currency_data.display_logo}} {{planInfo &&
                          planInfo.treatment_amount ?
                          ((planInfo.treatment_amount - (planInfo.downpayment_amount || 0))|DynamicDecimalPipe:mainService.currency_data.currency_code) :'0.00'}}</p>
                      </div>
                      <div class="mt-4" *ngIf="planInfo && planInfo.selected_plan">
                        <p class="text-black h4 fw-900 m-0 " style=" font-size: 24px; ">{{planInfo && planInfo.selected_plan &&
                          planInfo.selected_plan.month}} Months</p>
                        <div class="per_month h3 py-2">
                          {{mainService.currency_data.display_logo}} {{planInfo && (planInfo.recurring_amount ||
                          planInfo.selected_plan.recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}}
                          <span class="color-gray-2">per month</span>
                        </div>
          
                      </div>
          
                    </div>
          
          
                    <div class="">
                      <hr class="my-5" style="  border: dashed #DFDFDF 1px;" />
                    </div>
          
                    <div class="w-100 text-center">
                      <span class="fs-16 fw-700 py-3 card-body">First Recurring Payment Date</span>
                      <p class="date_column h3 fw-900 mt-3 color-blue">{{paymentDetails.recurringDate | date:'MM/dd/yyyy'}}</p>
                    </div>
          
                    <div class="botton_continue" style="padding: 25px 0px 0px !important; ">
                      <button button-primary-auth class="px-5" (click)="gotoThanksPage()">Continue</button>
                    </div>
          
                  </div>
                </div>
              </div>
            </ng-container> -->

                </div>

                <!-- footer ---------------- footer  -->
                <div class="col-12 text-center footer_insied_out d-none bg-white py-3 mb-2">
                  <footer class="footer px-3 mb-4 mt-md-2 text-center">
                    <div class="text-big">
                      <span
                        *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && mainService.contractSupport">
                        <span class="m-0 f-s-16 small-mob color-gray">
                          In case of any additional queries, please contact your service provider
                          <b>{{planInfo && planInfo.practice_name ? planInfo.practice_name :
                            planInfo.doctor_first_name+'
                            '+planInfo.doctor_last_name}}</b>
                          <span *ngIf="(planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)">
                            at
                          </span>
                          <a class="text-bold"
                            *ngIf="planInfo && (planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"
                            href="tel:{{planInfo && planInfo.practice_mobile ?planInfo.practice_mobile:planInfo.doctor_phone}}">
                            {{planInfo && planInfo.practice_mobile ?(planInfo.practice_mobile | phoneNumber) :
                            (planInfo.doctor_phone | phoneNumber) ? (planInfo.doctor_phone | phoneNumber) :
                            (planInfo.doctor_mobile | phoneNumber)}}
                          </a>
                        </span>

                      </span>
                      <span
                        *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && !mainService.contractSupport">
                        <span class="m-0 f-s-16 small-mob color-gray fw-700">
                          Need Help? <a class="text-bold" style="color: #1581E5" href="https://www.credee.com/support"
                            target="_blank">Click Here</a> to contact Denefits
                          Support
                        </span>
                      </span>
                      <!-- <span class="color-gray fw-700">
                  &copy; {{date | date:'yyyy'}} - {{settingsData &&
                  settingsData.brand?settingsData.brand.name:'Denefits'}}
                </span> -->
                    </div>
                  </footer>
                </div>
              </div>
            </div>
            <!-- <span
              *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && !mainService.contractSupport"
              class="footer-help--wrap--modify">
              <span class="m-0 f-s-16 small-mob color-gray fw-700">
                <a class="" href="https://www.credee.com/support" target="_blank"><svg
                    xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_8693_20253)">
                      <path
                        d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 16C11.7348 16 11.4804 16.1054 11.2929 16.2929C11.1054 16.4804 11 16.7348 11 17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17C13 16.7348 12.8946 16.4804 12.7071 16.2929C12.5196 16.1054 12.2652 16 12 16ZM12 6.5C11.0386 6.5 10.1166 6.88192 9.43674 7.56174C8.75692 8.24156 8.375 9.16359 8.375 10.125C8.375 10.3902 8.48036 10.6446 8.66789 10.8321C8.85543 11.0196 9.10978 11.125 9.375 11.125C9.64022 11.125 9.89457 11.0196 10.0821 10.8321C10.2696 10.6446 10.375 10.3902 10.375 10.125C10.3753 9.83004 10.4559 9.54072 10.6082 9.28809C10.7604 9.03545 10.9786 8.82902 11.2392 8.69092C11.4998 8.55282 11.7932 8.48827 12.0877 8.50419C12.3822 8.52011 12.6669 8.61589 12.9111 8.78127C13.1553 8.94666 13.35 9.1754 13.4741 9.44297C13.5982 9.71054 13.6472 10.0069 13.6157 10.3001C13.5843 10.5934 13.4736 10.8726 13.2955 11.1078C13.1175 11.3429 12.8788 11.5252 12.605 11.635C11.929 11.905 11 12.597 11 13.75V14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14C13 13.756 13.05 13.634 13.261 13.53L13.348 13.49C14.1288 13.1759 14.776 12.6 15.1787 11.8609C15.5814 11.1219 15.7145 10.2658 15.5551 9.43938C15.3958 8.61299 14.9539 7.86776 14.3052 7.33147C13.6566 6.79518 12.8416 6.50122 12 6.5Z"
                        fill="#20A9D3" />
                    </g>
                    <defs>
                      <clipPath id="clip0_8693_20253">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg> Need Help</a>
              </span>
            </span> -->
          </div>

          <!--Mobile Footer footer hide from Tab -->
          <footer class="footer text-center footer-change pt-md-0 pt-2 d-none">
            <!-- <button class="-mt-2 blue-btn fs-16 blue-btn-v3" button-primary-auth type="submit" *ngIf="opened_step == 2"
              (click)="addAddressFn(patient_address)">Continue</button>
            <button class="-mt-2 blue-btn fs-16 blue-btn-v3" button-primary-auth type="submit"
              *ngIf="opened_step == 3 && planInfo" (click)="signature=null;switchForm()"
              [disabled]="!recurring_source_id">Continue</button>
            <button class="-mt-2 blue-btn fs-16 blue-btn-v3" button-primary-auth type="submit"
              *ngIf="opened_step == 4 && planInfo" (click)="uploadBusinessSignature()"
              [disabled]="!signature || !terms || !dp_source_id || (split_request_data[0].show_buss_terms && !check_business_terms)">Continue</button> -->
            <div class="col-12 mt-2 mt-sm-0 Powered form-powerd--wrap">
              <span
                *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && !mainService.contractSupport"
                class="footer-help--wrap--v2">
                <span class="m-0 f-s-16 small-mob color-gray fw-700"
                  *ngIf="mainService.support_data && !mainService.support_data.support_mobile">
                  <a class="" style="color: #017A9F" href="https://www.credee.com/support" target="_blank"><svg
                      xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <g clip-path="url(#clip0_8693_20253)">
                        <path
                          d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 16C11.7348 16 11.4804 16.1054 11.2929 16.2929C11.1054 16.4804 11 16.7348 11 17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17C13 16.7348 12.8946 16.4804 12.7071 16.2929C12.5196 16.1054 12.2652 16 12 16ZM12 6.5C11.0386 6.5 10.1166 6.88192 9.43674 7.56174C8.75692 8.24156 8.375 9.16359 8.375 10.125C8.375 10.3902 8.48036 10.6446 8.66789 10.8321C8.85543 11.0196 9.10978 11.125 9.375 11.125C9.64022 11.125 9.89457 11.0196 10.0821 10.8321C10.2696 10.6446 10.375 10.3902 10.375 10.125C10.3753 9.83004 10.4559 9.54072 10.6082 9.28809C10.7604 9.03545 10.9786 8.82902 11.2392 8.69092C11.4998 8.55282 11.7932 8.48827 12.0877 8.50419C12.3822 8.52011 12.6669 8.61589 12.9111 8.78127C13.1553 8.94666 13.35 9.1754 13.4741 9.44297C13.5982 9.71054 13.6472 10.0069 13.6157 10.3001C13.5843 10.5934 13.4736 10.8726 13.2955 11.1078C13.1175 11.3429 12.8788 11.5252 12.605 11.635C11.929 11.905 11 12.597 11 13.75V14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14C13 13.756 13.05 13.634 13.261 13.53L13.348 13.49C14.1288 13.1759 14.776 12.6 15.1787 11.8609C15.5814 11.1219 15.7145 10.2658 15.5551 9.43938C15.3958 8.61299 14.9539 7.86776 14.3052 7.33147C13.6566 6.79518 12.8416 6.50122 12 6.5Z"
                          fill="#20A9D3" />
                      </g>
                      <defs>
                        <clipPath id="clip0_8693_20253">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg> Need Help</a>
                </span>
              </span>
              <div class="w-100 small-mob mt-2 mb-3">
                <span class="fs-14 ">Powered By <span class="text-primary ms-1"><img
                      src="assets/svg/logo_colored.svg"></span></span>
              </div>
            </div>
            <div class="text-big">
              <span
                *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && mainService.contractSupport">
                <span class="m-0 f-s-16 small-mob color-gray text-capitalize">
                  In case of any additional queries, please contact your service provider
                  <b>{{planInfo && planInfo.practice_name ? planInfo.practice_name : planInfo.doctor_first_name+'
                    '+planInfo.doctor_last_name | titlecase}}</b>
                  <span *ngIf="(planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"> at
                  </span>
                  <a class="text-bold"
                    *ngIf="planInfo && (planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"
                    href="tel:{{planInfo && planInfo.practice_mobile ?planInfo.practice_mobile:planInfo.doctor_phone}}">
                    {{(planInfo && planInfo.practice_mobile ? (planInfo.practice_mobile) :
                    (planInfo.doctor_phone) ? (planInfo.doctor_phone) :
                    (planInfo.doctor_mobile)) | phoneNumber : "N.A"}}
                  </a>
                </span>

              </span>
              <span class="small-mob footer-terms--date">
                &copy; {{date | date:'yyyy'}} - Credee
              </span>
            </div>
          </footer>

        </div>

      </div>
    </div>
  </div>
  <!-- footer start from tab -->
  <footer class="footer d-none d-md-block  fixed-bottom pb-3">
    <div class="mb-2 text-center text-muted fs-16"
      *ngIf="mainService.support_data && mainService.support_data.support_mobile">
      Need Help? &nbsp; Call us at <span><a highlight-color
          href="tel:{{mainService.support_data.support_mobile}}">{{mainService.support_data.support_mobile}}</a></span>,
      or <span><a highlight-color href="https://www.credee.com/support" target="_blank">Click here</a></span> to Request
      a Callback.
    </div>
    <div class="d-flex justify-content-center align-items-center py-1">
      <div class="mt-2 mt-sm-0 me-2 Powered">
        <div class="w-100 small-mob text-muted">
          <span class="fs-14 ">Powered By <span class="text-primary ms-1"><img
                src="assets/svg/logo_colored.svg"></span></span>
        </div>
      </div>
      <div class="text-big">
        <span *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && mainService.contractSupport">
          <span class="m-0 f-s-16 small-mob color-gray text-capitalize">
            In case of any additional queries, please contact your service provider
            <b>{{planInfo && planInfo.practice_name ? planInfo.practice_name : planInfo.doctor_first_name+'
              '+planInfo.doctor_last_name | titlecase}}</b>
            <span *ngIf="(planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"> at </span>
            <a class="text-bold"
              *ngIf="planInfo && (planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"
              href="tel:{{planInfo && planInfo.practice_mobile ?planInfo.practice_mobile:planInfo.doctor_phone}}">
              {{(planInfo && planInfo.practice_mobile ? (planInfo.practice_mobile) :
              (planInfo.doctor_phone) ? (planInfo.doctor_phone) :
              (planInfo.doctor_mobile)) | phoneNumber : "N.A"}}
            </a>
          </span>

        </span>

        <span class="small-mob text-muted">
          &copy; {{date | date:'yyyy'}} - Credee
        </span>
      </div>
    </div>
  </footer>

</div>

<div bsModal #addNewPaymentMethodModal="bs-modal" [config]="{ignoreBackdropClick:true}" class="modal" tabindex="-1"
  role="dialog" (onShow)="AddStripeElement('add_new_card');" aria-labelledby="mySmallModalLabel" aria-hidden="true"
  (onHide)="RemoveStripeElement('add_new_card');">
  <div class="modal-dialog  modal-dialog-centered customModal modal-md"
    [ngClass]="dataEnter ? 'side_modal' : 'close_modal'">
    <div class="modal-content p-4">
      <div class="modal-header-payment pt-0 mb-3">
        <h4 class="modal-title color-gray ps-3 text-capitalize">Add {{mod_step == 2 ? 'Recurring' :
          mod_step == 3 ? 'Backup' : ''}}
          Payment Method</h4>
        <button type="button" class="close" aria-label="Close" role="button_close" (click)="closeBank()"><img
            src="assets/svg/close-circle.svg" alt=""></button>
      </div>

      <div class="modal-body pt-0">
        <div class="d-flex mb-3 card_bank">
          <!-- card grayed -->
          <div class="px-3"
            *ngIf="planInfo && ((mod_step == 2 &&  (planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.recurring_type == 2 || planInfo.selected_payment_matrix.recurring_type == 3)))
            
            || (mod_step == 3 && planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.backup_type == 2 || planInfo.selected_payment_matrix.backup_type == 3))
            
            || (mod_step == 1 && planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.primary_type == 2 || planInfo.selected_payment_matrix.primary_type == 3)))">

            <button
              (click)="add_bank_step = 'card'; showElement = false; selected_card = ''; existing(buttonSelectedType.cardTab);"
              class="button-login-100 w-100 py-2" [ngClass]="[add_bank_step == 'card' ? '' : ' color-gray bg_gray']"
              id="card_add">
              <span>
                <img [src]="[add_bank_step == 'card' ? 'assets/svg/card.svg' : 'assets/svg/card_fade.svg']" alt=""
                  srcset="">
                <span [ngClass]="[add_bank_step == 'card' ? '' : 'color-gray']" class="vam ps-1">
                  Card
                </span>
              </span>
            </button>
          </div>

          <!-- bank  -->
          <div class=""
            *ngIf="!manual_continue && (planInfo && patientData && patientData['show_ach'] == 1 && ((mod_step == 2 &&  (planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.recurring_type == 1 || planInfo.selected_payment_matrix.recurring_type == 3)))     
             
              || (mod_step == 3 && planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.backup_type == 1 || planInfo.selected_payment_matrix.backup_type == 3)) 
             
             || (mod_step == 1 && planInfo.selected_payment_matrix && (planInfo.selected_payment_matrix.primary_type == 1 || (planInfo.selected_payment_matrix.primary_type == 3)))))">
            <button
              (click)="add_bank_step = 'bank'; showElement = false; selected_card = ''; existing(buttonSelectedType.bank);"
              class="button-login-100 w-100 py-2" [ngClass]="[add_bank_step == 'bank' ? '' : ' color-gray bg_gray']">
              <span>
                <img [src]="[add_bank_step == 'bank' ? 'assets/svg/bank_fade.svg' : 'assets/svg/bank.svg']" alt=""
                  srcset="">
                <span [ngClass]="[add_bank_step == 'bank' ? '' : 'color-gray']" class="vam ps-1">
                  Bank
                </span>
                &nbsp; <img src="../../../../assets/svg/offer.svg" width="20px"
                  tooltip="{{'If you instantly pay your payment today using bank, you will get $' + planInfo.plans_array[0].enrollment_fee + 'off on your contract enrollment fee!'}}"
                  *ngIf="(getNumber(mod_step) == 1 || getNumber(mod_step) == 2) && planInfo.plans_array[0] && planInfo.enrollment_waiver == 1 && planInfo.selected_payment_matrix.primary_type == 3 && planInfo.enrollment_enabled == 0">
              </span>

            </button>
          </div>
        </div>

        <div class="pointer"
          *ngIf="add_bank_step != 'bank' && ((mod_step == 2) || (mod_step == 3) || (mod_step == 1)) &&  (primary_card_added || recurring_card_added || backup_card_added)">
          <input type="radio" name="existing" id="list_card" [checked]="validValue" (change)="validValue = !validValue">
          <label for="list_card" (click)="existing(buttonSelectedType.existing)">
            <span style="font-weight: 600;font-size: 17px;" class="ps-2" id="Select_existing_Cards">Select existing
              Cards
            </span>
          </label>
        </div>
        <!-- Bank Added Start -->
        <div class="add_card_button_1 mt-sm-0 opened_step" style="max-height: 350px;overflow-y: auto;"
          *ngIf="(mod_step == 1 && validValue) && patientData && patientData.primary_sources && patientData.primary_sources.length > 0">
          <div class="card-block mb-2" *ngFor="let source of patientData.primary_sources">
            <label class="col-12 card_show_box mb-0"
              *ngIf="(source &&  source.payment_source_type == 1 && add_bank_step == 'bank') || (source.payment_source_type !== 1 && add_bank_step == 'card')"
              [ngClass]="{'primary-card-label': !(source && source.payment_source_type == 1 && source.source_id > 0)}"
              [ngStyle]="{'padding-bottom': !(source && source.payment_source_type == 1 && source.source_id > 0 ? '7px' : '')}">
              <div class="d-flex align-items-center h-100" [ngClass]="[(planInfo.enrollment_waiver == 1 && planInfo.selected_payment_matrix.primary_type == 3 && planInfo.enrollment_enabled == 0 && source.payment_source_type == 1 && source.source_id > 0) ? 'py-3' 
           : '' ]">
                <span class="flex-grow-1 flex-grow-1 d-flex align-items-center">
                  <img [ngStyle]="{'width': source.payment_source == 'Bank' ? '24px' :'30px'}" class="me-2"
                    [src]="source.payment_source == 'Bank' ? 'assets/svg/bank.svg' : source.brand?'assets/svg/card-type/'+source?.brand.toLowerCase()+'.svg':'assets/svg/card-type/no_card.svg'"
                    *ngIf="source.brand;else no_card"/>
                    <!-- source.brand=='MasterCard' || source.brand=='Discover' || source.brand=='JCB' || source.brand=='Visa' || source.brand=='American Express' || source.payment_source == 'Bank';else no_card  -->
                  <ng-template #no_card>
                    <img style="width:24px;" class="me-2" [src]="'assets/svg/card-type/no_card.svg'">
                  </ng-template>
                  XXXX XXXX {{source.payment_source_type != 1 ? 'XXXX ' : ''}}{{source.last4}}
                  <span *ngIf="source.source_id == -1" class="pull-right text-danger me-2">Verification
                    Pending</span>
                  <span *ngIf="source && source.bank_status && source.bank_status == 'reauthenticate' "
                    class="pull-right text-danger me-2"><a (click)="reAuthenticatePlaid()">Reauthentication
                      Required</a></span>
                  &nbsp;&nbsp;
                </span>
                <div class="custom-radio-box position-relative custom-radio-checkobx">
                  <input type="radio" [value]="source" class="ms-3" name="selected_card" [(ngModel)]="selected_card"
                    [checked]="recurring_source_id == source.source_id"
                    [disabled]="source && source.bank_status && source.bank_status == 'reauthenticate'"
                    (change)="checkValue($event)" />
                  <label class="radio-label"></label>
                </div>

              </div>
              <div class="offer-strip"
                *ngIf="(mod_step == 1 || mod_step == 2) && planInfo.enrollment_waiver == 1 && planInfo.selected_payment_matrix.primary_type == 3 && planInfo.enrollment_enabled == 0 && source.payment_source_type == 1 && source.source_id > 0 && planInfo.plans_array[0].enrollment_fee > 0">
                Offer available: Get {{mainService.currency_data.display_logo}}
                {{planInfo.plans_array[0].enrollment_fee
                ? (planInfo.plans_array[0].enrollment_fee|DynamicDecimalPipe:mainService.currency_data.currency_code) : '30'}} off on your contract enrollment fee!
              </div>
            </label>
          </div>
        </div>

        <!-- rescurring payment method  -->
        <div class=""
          *ngIf="(mod_step == 2 && validValue) && patientData && patientData.recurring_sources && patientData.recurring_sources.length > 0"
          class="add_card_button_1 opened_step_2" style="max-height: 350px;overflow-y: auto;">
          <div class="card-block mb-2" style="max-height: 350px;overflow-y: auto;"
            *ngFor="let source of patientData.recurring_sources;let i =index">
            <label class="col-12 card_show_box mb-0"
              *ngIf="source &&  (source.payment_source_type == 1 && add_bank_step == 'bank') || (source.payment_source_type !== 1 && add_bank_step == 'card')">
              <div class="d-flex align-items-center h-100">
                <span class="flex-grow-1 flex-grow-1 d-flex align-items-center" [id]="i + '_recurring_card'">
                  <img [ngStyle]="{'width': source.payment_source == 'Bank' ? '24px' :'30px'}" class="me-2"
                    [src]="source.payment_source == 'Bank' ? 'assets/svg/bank.svg' : source.brand?'assets/svg/card-type/'+source?.brand.toLowerCase()+'.svg':'assets/svg/card-type/no_card.svg'"
                    *ngIf="source?.brand;else no_card " />
                    <!-- *ngIf="source.brand=='MasterCard' || source.brand=='Discover' || source.brand=='JCB' || source.brand=='Visa' || source.brand=='American Express' || source.payment_source == 'Bank';else no_card " -->
                  <ng-template #no_card>
                    <img style="width:24px;" class="me-2" [src]="'assets/svg/card-type/no_card.svg'">
                  </ng-template>
                  XXXX XXXX {{source.payment_source_type != 1 ? 'XXXX ' : ''}}{{source.last4}}
                  <span *ngIf="source.source_id == -1" class="pull-right text-danger me-2">Verification
                    Pending</span>
                  <span *ngIf="source && source.bank_status && source.bank_status == 'reauthenticate' "
                    class="pull-right text-danger me-2"><a (click)="reAuthenticatePlaid()">Reauthentication
                      Required</a></span>
                  &nbsp;&nbsp;
                </span>
                <div class="custom-radio-box position-relative custom-radio-checkobx">
                  <input type="radio" [value]="source" class="ms-3" name="selected_card" [(ngModel)]="selected_card"
                    [checked]="recurring_source_id == source.source_id"
                    [disabled]="source && source.bank_status && source.bank_status == 'reauthenticate'"
                    (change)="checkValue($event)" />
                  <label class="radio-label"></label>
                </div>
              </div>
              <div class="offer-strip mt-2"
                *ngIf="(mod_step == 1 || mod_step== 2) && planInfo.enrollment_waiver == 1 && planInfo.selected_payment_matrix.primary_type == 3 && planInfo.enrollment_enabled == 0 && source.payment_source_type == 1 && source.source_id > 0 && planInfo.plans_array[0].enrollment_fee > 0">
                Offer available: Get {{mainService.currency_data.display_logo}}
                {{planInfo.plans_array[0].enrollment_fee
                ?
                (planInfo.plans_array[0].enrollment_fee|DynamicDecimalPipe:mainService.currency_data.currency_code) : '30'}} off on your contract enrollment fee!
              </div>
            </label>
          </div>
        </div>

        <!-- backup cards    -->
        <div
          *ngIf="(mod_step == 3 && validValue) && patientData && patientData.backup_sources && patientData.backup_sources.length > 0"
          class="add_card_button_1 mt-sm-4 opened_step_3" style="max-height: 350px;overflow-y: auto;">
          <ng-container *ngFor="let source of patientData.backup_sources">
            <div class="card-block mb-2"
              *ngIf="((source.payment_source_type == 1 && add_bank_step == 'bank') || (source.payment_source_type !== 1 && add_bank_step == 'card'))">
              <label class="col-12 card_show_box mb-0">
                <div class="d-flex align-items-center h-100">
                  <span class="flex-grow-1 flex-grow-1 d-flex align-items-center">
                    <img [ngStyle]="{'width': source.payment_source == 'Bank' ? '24px' :'30px'}" class="me-2"
                      [src]="source.payment_source == 'Bank' ? 'assets/svg/bank.svg' : source.brand?'assets/svg/card-type/'+source?.brand.toLowerCase()+'.svg':'assets/svg/card-type/no_card.svg'"
                      *ngIf="source.brand;else no_card" />
                      <!-- source.brand=='MasterCard' || source.brand=='Discover' || source.brand=='JCB' || source.brand=='Visa' || source.brand=='American Express' || source.payment_source == 'Bank';else no_card -->
                    <ng-template #no_card>
                      <img style="width:24px;" class="me-2" [src]="'assets/svg/card-type/no_card.svg'">
                    </ng-template>
                    XXXX XXXX {{source.payment_source_type != 1 ? 'XXXX ' : ''}}{{source.last4}}
                    <span *ngIf="source.source_id == -1" class="pull-right text-danger me-2">Verification
                      Pending</span>
                    <span *ngIf="source && source.bank_status && source.bank_status == 'reauthenticate' "
                      class="pull-right text-danger me-2"><a (click)="reAuthenticatePlaid()">Reauthentication
                        Required</a></span>
                    &nbsp;&nbsp;
                  </span>
                  <div class="custom-radio-box position-relative custom-radio-checkobx">
                    <input type="radio" [value]="source" class="ms-3" name="selected_card" [(ngModel)]="selected_card"
                      [checked]="backup_source_id == source.source_id"
                      [disabled]="source && source.bank_status && source.bank_status == 'reauthenticate'"
                      (change)="checkValue($event)" />
                    <label class="radio-label"></label>
                  </div>
                </div>
              </label>
            </div>
          </ng-container>
        </div>
        <!-- Bank Added End -->


        <!-- <div class="my-col position-relative"
          [ngClass]="patientData.backup_sources && patientData.backup_sources.length==0 && add_bank_step == 'card' || (stripeFieldsshow && add_bank_step == 'card')?'value':'value-one'">
          <span class="add-new--stripeLabel">
            Add New
          </span>
        </div> -->
        <div class="w-100">
          <button button-primary-auth class="px-5 mt-0 mb-3"
            *ngIf="selected_card && selected_card.last4 && (add_bank_step == 'card')" (click)="openAddBankPopup(3)"
            id="Add_now">

            <span class="px-3">
              Add Now
            </span>
          </button>
        </div>
        <!-- <ng-container *ngIf="add_bank_step == 'bank'">
          <hr class="mt-3">
        </ng-container> -->
        <div class="pointer">
          <input type="radio" name="existing" id="add_new_card" [checked]="showElement || add_bank_step == 'bank'">
          <label for="add_new_card" (click)="existing(buttonSelectedType.bank)"
            [ngClass]="{'d-none': add_bank_step == 'bank' && bank_addded}">
            <span style="font-weight: 600;font-size: 17px;" class="ps-2"
              *ngIf="add_bank_step == 'bank' && !bank_addded">Add Bank</span>
            <span style="font-weight: 600;font-size: 17px;" class="ps-2" *ngIf="add_bank_step !== 'bank'">Add new
              card</span>
          </label>
        </div>

        <div *ngIf="showElement">
          <app-generate-stripe-token [address]="{}" [buttonClickedSubject]="buttonClickedSubject"
            [selected_card]="selected_card" (onFocussed)="CardFocussed()" (clickParentFunction)="openAddBankPopup(3)"
            [elementId]="'add_new_card'" (cardResponse)="CatchStripeTokenForNewCard($event, addNewPaymentMethodModal)"
            class="col-12 my-col" [show_save_card]="false" [payment_failed_first]="dp_last4" [show_address]="false"
            [not_Valid]="valueNotValid" [backUp_Card]="backUpCard" [web_connect]="false"
            [recurring_card]="recurringCard" [today_payment_card]="todayPaymentCard"
            (triggerParentFunction)="confirmPayment()" [bankType]="add_bank_step == 'bank' ? 1 : 0"
            (showElementTrigger)="showElementTrigger($event)">
          </app-generate-stripe-token>
        </div>
        <div class="w-100" style="margin-top: -30px;">
          <button button-primary-auth class="px-5 mt-0"
            *ngIf="selected_card && selected_card.last4 && !showElement && (add_bank_step == 'bank' && patientData && planInfo.selected_payment_matrix && ((planInfo.selected_payment_matrix.recurring_type == 1 || planInfo.selected_payment_matrix.recurring_type == 3) || (planInfo.selected_payment_matrix.primary_type == 1 || planInfo.selected_payment_matrix.primary_type == 3) || (planInfo.selected_payment_matrix.backup_type == 1 || planInfo.selected_payment_matrix.backup_type == 3)))"
            (click)="openAddBankPopup(1)">
            <span class="px-3">
              Add Now
            </span>
          </button>
        </div>
      </div>
    </div>

  </div>
</div>


<div bsModal #paymentFail="bs-modal" [config]="{ignoreBackdropClick:true, backdrop : 'static',
    keyboard : false}" data-keyboard="false" data-backdrop="static" class="modal fade modal-open" tabindex="-1"
  role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered customModal modal-md">
    <div class="modal-content overflow-hidden">
      <div class="modal-body p-0">
        <div class="head_content text-end d-flex align-items-center justify-content-end  px-3 py-2 h5 fw-700">
          <span role="button_close" class="border rounded-circle" (click)="paymentFail.hide()"><img
              src="assets/svg/close-circle.svg" alt=""></span>
        </div>
        <div class="body_content px-4 text-center">

          <div class="w-100">
            <p class="fs-16 fw-700 oppose-icon">
              <img src="assets/svg/oppse_icon.svg" alt="">
            </p>
            <div>
              <p class="h2 color-dblue fw-900">{{"Payment Failed!"}}</p>
            </div>
            <div class="mt-5">
              <p class="color-dblue fs-16 fw-600">{{payment_error}}</p>
            </div>
          </div>

          <div class="botton_continue py-5 align-items-center d-flex flex-column">
            <button button-primary-auth class="px-5 bg-white border color-blue-imp" (click)="uploadBusinessSignature()"
              style="width: 280px !important;">Retry</button>
            <br />
            <button button-primary-auth class="px-5 -mt-4" (click)="changePaymentMethodFailed(paymentFail);"
              style="width: 280px !important;">Change Payment Method</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<div bsModal #confirmPaymentDetailsModal="bs-modal" [config]="{ignoreBackdropClick:true, backdrop : 'static'}"
  data-keyboard="false" data-backdrop="static" class="modal -fade" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered customModal modal-md">
    <div class="modal-content overflow-hidden" style="height: 98vh !important;">
      <div class="modal-body p-0" style="overflow-x: auto;">
        <div class="row h-100 mx-0">
          <div class="col-md-12 col-sm-12 cancel-btn p-0" *ngIf="planInfo" style="position: relative;">
            <div class="w-100 col-md-12 col-sm-12 py-3 text-center">
              <span
                class="p-0 business-logo-outer-modal business-logo-outer mx-auto d-flex justify-content-center align-items-center overflow-hidden"
                *ngIf="planInfo.doctor_image; else elseblock">
                <img [src]="planInfo.doctor_image" class="img-fluid business-logo" alt="Doctor">
              </span>
              <ng-template #elseblock>
                <app-steps (triggerChangeScreen)="changeScreen()" class="mt-3"></app-steps>
              </ng-template>
            </div>
            <div class="w-100 col-md-12 col-sm-12 text-center py-2 ">
              <p class="m-0 fs-24 fw-900 practice-name font-weight-bolder text-black text-capitalize"
                *ngIf="planInfo.practice_name || planInfo.doctor_first_name">
                {{(planInfo.practice_name?planInfo.practice_name:planInfo.doctor_first_name + ' ' +
                planInfo.doctor_last_name) | titlecase}}
              </p>
              <p class="py-2 mb-0 mt-2 fw-700 card-body fs-14 ">{{planInfo.practice_email || planInfo.doctor_email }}
              </p>
              <p class="pb-2 mb-0 card-body fw-700 fs-14">{{planInfo && planInfo.practice_mobile ?
                (planInfo.practice_mobile |
                phoneNumber) :'N.A.'}}</p>
            </div>

            <div class="col-12 py-3 text-center">
              <span class="rounded-pill border px-3 py-2 color-gray eta_button">
                Estimated Payment Plan
              </span>
            </div>

            <div class="col-12 text-center pt-3">
              <span class="h1 fw-900"><span translate="no">
                  {{mainService.currency_data.display_logo}} {{planInfo && planInfo.treatment_amount ?
                  ((planInfo.treatment_amount - planInfo.downpayment_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code) : '0.00'}}</span>
              </span>
            </div>


            <div class="col-12  finance-rows text-center py-2"
              *ngIf="planInfo && (planInfo.is_ar_contract == 1 || planInfo.enrollment_enabled != 1)">
              <span class="financing-labels font-weight-bold h5 finance-values card-body">
                <div>
                  {{((planInfo && planInfo.enrollment_enabled != 1) && !planInfo.is_ar_contract) ? 'Enrollment Fee:' :
                  planInfo && planInfo.is_ar_contract == 1 ? 'Account Setup Fee:' : ''}}</div>
                <div class="f-s-22-w-800 finance-values position-relative account-set">
                  <div class="d-flex align-items-baseline">
                    <div>
                      <span *ngIf="mainService.promotionalEnrollmentOffer"
                        class="strike_through_class">{{mainService.currency_data.display_logo}}</span>
                      <span *ngIf="mainService.promotionalEnrollmentOffer" class="strike_through_class"
                        [innerText]="mainService.strike_enrollment_fee"></span>
                    </div>
                    <div [ngClass]="mainService.promotionalEnrollmentOffer ? 'transaction-fee' :'' "
                      class=" d-inline-block ms-2"><span translate="no">
                        {{mainService.currency_data.display_logo}} {{enrollmentFee ? (enrollmentFee|DynamicDecimalPipe:mainService.currency_data.currency_code): '30'}}</span>
                    </div>
                  </div>
                  <div *ngIf="mainService.promotionalEnrollmentOffer"
                    class="transaction-fee-popup pop-up-right view-full-cast">
                    Promo
                  </div>
                </div>
              </span>
            </div>
            <div class="col mt-4" *ngIf="contract_service_record">
              <div class="col-12 px-4 mx-auto">
                <ul style="list-style-type: none;" class="px-0 service_viewer no_scroll">
                  <li class="d-flex align-items-center justify-content-between py-3 px-4 service_list_item"
                    *ngFor="let service of contract_service_record">
                    <span class="color-gray fs-14">
                      {{service.service}}
                    </span>
                    <span class="fw-700 color-dblue">
                      {{service && service.price ?
                      (service.price |
                      currency : '$') :'$0.00'}}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-12 position-relative">
              <div class="d-flex justify-content-between align-items-center p-4 iframe-body fs-14 mt-4 rounded-top"
                style="border-bottom: 1px solid lightgrey;">
                <p class="p-0 m-0"><span class="color-gray p-0 m-0 me-1">Service amount</span>
                  <span>
                    <img src="assets\png\Icons.png" alt="" class="info_icon">
                    <span class="tooltip_box color-gray-1 show_div1 custom_tool_recurring d-none"
                      style="max-height: 180px !important; overflow-y: auto;">
                      <div class="d-flex justify-content-between border-bottom p-2 align-items-center"
                        *ngFor="let service of contract_service_record">
                        <p class="color-gray p-0 m-0 fw-400 ">{{service.service}}</p>
                        <p class="color-dblue fw-700 p-0 m-0"> {{mainService.currency_data.display_logo}} {{service &&
                          service.price ?
                          (service.price|DynamicDecimalPipe:mainService.currency_data.currency_code) : '0.00'}}</p>
                      </div>
                    </span>
                  </span>
                </p>
                <p class="color-dblue fw-700 p-0 m-0"> {{mainService.currency_data.display_logo}}
                  {{planInfo.treatment_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}}</p>
              </div>

              <div class="d-flex justify-content-between align-items-center p-4 iframe-body fs-14 rounded-bottom">
                <p class="color-gray p-0 m-0">Down payment</p>
                <p class="color-dblue fw-700 p-0 m-0"> {{mainService.currency_data.display_logo}}
                  {{(planInfo.downpayment_amount|DynamicDecimalPipe:mainService.currency_data.currency_code )}}</p>
              </div>
            </div>


            <div class="w-100 px-4 mt-3 auth-select">
              <button button-primary-auth class="py-4 w-100" style="max-width: unset !important;width: 100% !important;"
                (click)="confirmPaymentDetailsModal.hide()">Let's Select a Plan</button>
            </div>


            <div class="col-12 mt-2">
              <div class="w-100 text-center color-gray-light">
                <span>Powered By <span class="text-primary ms-1"><img src="assets/svg/logo_colored.svg"></span></span>
              </div>

            </div>

            <div class="col-12 mt-2 p-0 m-0" style="position: sticky;top: 93vh;">
              <p class="p-0 m-0 fs-16 fw-400 queries_class">Any queries, please contact at <span>{{planInfo &&
                  planInfo.practice_mobile ? (planInfo.practice_mobile |
                  phoneNumber) :'N.A.'}}</span></p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div bsModal #tilaModal="bs-modal" [config]="{ignoreBackdropClick:true, backdrop : 'static',
    keyboard : false}" data-keyboard="false" data-backdrop="static" class="modal fade modal-open" tabindex="-1"
  role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered customModal modal-xl">
    <div class="modal-content overflow-hidden">
      <div class="modal-body p-0">
        <div class="head_content text-end d-flex align-items-center justify-content-end  px-3 py-2 h5 fw-700">
          <span role="button_close" class="border rounded-circle" (click)="tilaModal.hide()"><img
              src="assets/svg/close-circle.svg" alt=""></span>
        </div>
        <div class="body_content px-4 text-center">

          <div *ngIf="showModalTila" class="w-100">
            <app-iframe-tila></app-iframe-tila>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<div bsModal #hipaaModal="bs-modal" [config]="{ignoreBackdropClick:true, backdrop : 'static',
    keyboard : false}" data-keyboard="false" data-backdrop="static" class="modal fade modal-open" tabindex="-1"
  role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered customModal modal-xl">
    <div class="modal-content overflow-hidden" style="padding-top: 13px;">
      <div class="modal-body p-0">
        <div class="head_content text-end d-flex align-items-center justify-content-end  px-3 py-2 h5 fw-700"
          style="position: absolute; right: 0;z-index: 9999;">
          <span role="button_close" class="border rounded-circle" (click)="hipaaModal.hide()"><img
              src="assets/svg/close-circle.svg" alt=""></span>
        </div>
        <div class="body_content px-4 text-center">

          <div *ngIf="showModalHipaa" class="w-100">
            <app-consent-form [consentFormToken]="contractToken"></app-consent-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>